/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {
  ZonedDateTime,
  LocalDate,
  LocalDateTime,
  Instant,
  Duration
} from '@js-joda/core';
import {
  makeLocalDateTime,
  makeLocalDate,
  makeDate,
  makeZonedDateTime,
  makeInstant
} from 'utils';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const makeFunctions: {[key: string]: (data: any) => any} = {};

export function hydrateResponse(type: string, response: any) {
  if (['string', 'void', 'boolean', 'number', 'null', 'undefined'].includes(type) || (type.startsWith('{') && type.endsWith('}'))) {
    return response;
  }

  if (type.includes('[]')) {
    return response.map(makeFunctions[type.replace('[]', '')]);
  }

  return makeFunctions[type](response);
}

export class Service {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    getApiContent(contentItemId: string | null, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/content/{contentItemId}";
        if (contentItemId === undefined || contentItemId === null)
            throw new Error("The parameter 'contentItemId' must be defined.");
        url_ = url_.replace("{contentItemId}", encodeURIComponent("" + contentItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApiContent(_response);
        });
    }

    protected processGetApiContent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteApiContent(contentItemId: string | null, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/content/{contentItemId}";
        if (contentItemId === undefined || contentItemId === null)
            throw new Error("The parameter 'contentItemId' must be defined.");
        url_ = url_.replace("{contentItemId}", encodeURIComponent("" + contentItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteApiContent(_response);
        });
    }

    protected processDeleteApiContent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    postApiContent(model?: ContentItem | undefined, draft?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/content?";
        if (draft === null)
            throw new Error("The parameter 'draft' cannot be null.");
        else if (draft !== undefined)
            url_ += "draft=" + encodeURIComponent("" + draft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostApiContent(_response);
        });
    }

    protected processPostApiContent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    notificationsMarkAsRead(model?: ReadNotificationViewModel | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Notifications/MarkAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotificationsMarkAsRead(_response);
        });
    }

    protected processNotificationsMarkAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ClientsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param searchTerm (optional) 
     */
    list(page?: number | undefined, pageSize?: number | null | undefined, searchTerm?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfClientDto> {
        let url_ = this.baseUrl + "/api/Clients?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PagedListOfClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfClientDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfClientDto>(null as any);
    }

    create(command: CreateClientCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    get(clientId: string, cancelToken?: CancelToken): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Clients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ClientDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientDto>(null as any);
    }

    update(clientId: string, command: UpdateClientCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Clients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(clientId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Clients/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserDashboardsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    getMyDashboards(projectId: string, cancelToken?: CancelToken): Promise<UserDashboardDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dashboards/me";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyDashboards(_response);
        });
    }

    protected processGetMyDashboards(response: AxiosResponse): Promise<UserDashboardDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('UserDashboardDto[]', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDashboardDto[]>(null as any);
    }

    saveMyDashboard(projectId: string, request: SaveUserDashboardRequest, cancelToken?: CancelToken): Promise<UserDashboardDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dashboards/me";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveMyDashboard(_response);
        });
    }

    protected processSaveMyDashboard(response: AxiosResponse): Promise<UserDashboardDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('UserDashboardDto', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDashboardDto>(null as any);
    }

    deleteMyDashboard(projectId: string, dashboardId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dashboards/me/{dashboardId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (dashboardId === undefined || dashboardId === null)
            throw new Error("The parameter 'dashboardId' must be defined.");
        url_ = url_.replace("{dashboardId}", encodeURIComponent("" + dashboardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMyDashboard(_response);
        });
    }

    protected processDeleteMyDashboard(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProjectsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param searchTerm (optional) 
     * @param clientId (optional) 
     * @param projectType (optional) 
     * @param includeArchived (optional) 
     */
    list(page?: number | undefined, pageSize?: number | null | undefined, searchTerm?: string | null | undefined, clientId?: string | null | undefined, projectType?: string | null | undefined, includeArchived?: boolean | undefined, cancelToken?: CancelToken): Promise<PagedListOfProjectDto> {
        let url_ = this.baseUrl + "/api/Projects?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (projectType !== undefined && projectType !== null)
            url_ += "projectType=" + encodeURIComponent("" + projectType) + "&";
        if (includeArchived === null)
            throw new Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PagedListOfProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfProjectDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfProjectDto>(null as any);
    }

    get(projectId: string, cancelToken?: CancelToken): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ProjectDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    update(projectId: string, command: UpdateProjectCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(projectId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    create(clientId: string, command: CreateProjectCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/clients/{clientId}/projects";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createPcProject(command: CreateProjectCommand, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/pc-projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePcProject(_response);
        });
    }

    protected processCreatePcProject(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateProjectImage(projectId: string, imageFile?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/image";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageFile !== null && imageFile !== undefined)
            content_.append("imageFile", imageFile.data, imageFile.fileName ? imageFile.fileName : "imageFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProjectImage(_response);
        });
    }

    protected processUpdateProjectImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getClientId(projectId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/clientid";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientId(_response);
        });
    }

    protected processGetClientId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateProjectLicenceExpiryDate(projectId: string, command: SetProjectLicenceExpiryDateCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/licence";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProjectLicenceExpiryDate(_response);
        });
    }

    protected processUpdateProjectLicenceExpiryDate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setHistoricalBinderPercentage(projectId: string, command: SetHistoricalBinderPercentageCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/SetHistoricalBinderPercentage";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetHistoricalBinderPercentage(_response);
        });
    }

    protected processSetHistoricalBinderPercentage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setArchived(projectId: string, command: SetProjectArchivedCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/SetArchived";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetArchived(_response);
        });
    }

    protected processSetArchived(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setCurrencyPreference(projectId: string, command: SetCurrencyPreferenceCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/SetCurrencyPreference";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetCurrencyPreference(_response);
        });
    }

    protected processSetCurrencyPreference(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setDashboardCharts(projectId: string, command: SetDashboardChartsCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/SetDashboardCharts";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDashboardCharts(_response);
        });
    }

    protected processSetDashboardCharts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setStopeNoteTemplateId(projectId: string, command: SetStopeNoteTemplateIdCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/SetStopeNoteTemplateId";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetStopeNoteTemplateId(_response);
        });
    }

    protected processSetStopeNoteTemplateId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    inviteUserToPcProject(projectId: string, command: InviteUserToPcProjectCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/invite";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInviteUserToPcProject(_response);
        });
    }

    protected processInviteUserToPcProject(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    removeUserFromPcProject(projectId: string, userId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/collaborators/{userId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveUserFromPcProject(_response);
        });
    }

    protected processRemoveUserFromPcProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPcProjectCollaborators(projectId: string, cancelToken?: CancelToken): Promise<ProjectCollaboratorDto[]> {
        let url_ = this.baseUrl + "/api/Projects/{projectId}/collaborators";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPcProjectCollaborators(_response);
        });
    }

    protected processGetPcProjectCollaborators(response: AxiosResponse): Promise<ProjectCollaboratorDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ProjectCollaboratorDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectCollaboratorDto[]>(null as any);
    }
}

export class FlushRecipesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    get(flushRecipeId: string, cancelToken?: CancelToken): Promise<FlushRecipeDto> {
        let url_ = this.baseUrl + "/api/FlushRecipes/{flushRecipeId}";
        if (flushRecipeId === undefined || flushRecipeId === null)
            throw new Error("The parameter 'flushRecipeId' must be defined.");
        url_ = url_.replace("{flushRecipeId}", encodeURIComponent("" + flushRecipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FlushRecipeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('FlushRecipeDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlushRecipeDto>(null as any);
    }

    update(flushRecipeId: string, form: UpdateFlushRecipeCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FlushRecipes/{flushRecipeId}";
        if (flushRecipeId === undefined || flushRecipeId === null)
            throw new Error("The parameter 'flushRecipeId' must be defined.");
        url_ = url_.replace("{flushRecipeId}", encodeURIComponent("" + flushRecipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(flushRecipeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/FlushRecipes/{flushRecipeId}";
        if (flushRecipeId === undefined || flushRecipeId === null)
            throw new Error("The parameter 'flushRecipeId' must be defined.");
        url_ = url_.replace("{flushRecipeId}", encodeURIComponent("" + flushRecipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAllByProject(projectId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FlushRecipeDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/flush-recipes/all?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByProject(_response);
        });
    }

    protected processGetAllByProject(response: AxiosResponse): Promise<FlushRecipeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('FlushRecipeDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlushRecipeDto[]>(null as any);
    }

    getByStope(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FlushRecipeDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/flush-recipes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByStope(_response);
        });
    }

    protected processGetByStope(response: AxiosResponse): Promise<FlushRecipeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('FlushRecipeDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlushRecipeDto[]>(null as any);
    }

    create(mineModelId: string, stopeId: string, form: CreateFlushRecipeCommand, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/flush-recipes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    restore(flushRecipeId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/FlushRecipes/{flushRecipeId}/restore";
        if (flushRecipeId === undefined || flushRecipeId === null)
            throw new Error("The parameter 'flushRecipeId' must be defined.");
        url_ = url_.replace("{flushRecipeId}", encodeURIComponent("" + flushRecipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PublicPoursService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    get(pourId: string, mineModelId: string, accessTokenHash: string, cancelToken?: CancelToken): Promise<PublicPourApprovalViewDto> {
        let url_ = this.baseUrl + "/api/{pourId}/public/{mineModelId}/{accessTokenHash}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PublicPourApprovalViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PublicPourApprovalViewDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicPourApprovalViewDto>(null as any);
    }

    publicApprovePourNoteApproval(pourId: string, pourNoteId: string, accessTokenHash: string, email?: string | null | undefined, signatureFile?: FileParameter | null | undefined, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PublicPours/{pourId}/pournotes/{pourNoteId}/approvers/approve/public/{accessTokenHash}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (signatureFile !== null && signatureFile !== undefined)
            content_.append("SignatureFile", signatureFile.data, signatureFile.fileName ? signatureFile.fileName : "SignatureFile");
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublicApprovePourNoteApproval(_response);
        });
    }

    protected processPublicApprovePourNoteApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    rejectPourNote(pourId: string, pourNoteId: string, accessTokenHash: string, comment?: string | null | undefined, email?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/PublicPours/{pourId}/pournotes/{pourNoteId}/approvers/reject/public/{accessTokenHash}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectPourNote(_response);
        });
    }

    protected processRejectPourNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPourNote(pourId: string, pourNoteId: string, accessTokenHash: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/PublicPours/{pourId}/pournotes/{pourNoteId}/{accessTokenHash}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPourNote(_response);
        });
    }

    protected processGetPourNote(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PublicStopeNotesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    get(mineModelId: string, stopeNoteId: string, accessTokenHash: string, cancelToken?: CancelToken): Promise<PublicStopeNoteApprovalViewDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/public/stopenote/{stopeNoteId}/{accessTokenHash}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PublicStopeNoteApprovalViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PublicStopeNoteApprovalViewDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicStopeNoteApprovalViewDto>(null as any);
    }

    getStopeNoteFile(mineModelId: string, stopeNoteId: string, accessTokenHash: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/public/stopenote/{stopeNoteId}/file/{accessTokenHash}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStopeNoteFile(_response);
        });
    }

    protected processGetStopeNoteFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    publicApproveApprover(mineModelId: string, stopeNoteId: string, accessTokenHash: string, email?: string | null | undefined, signatureFile?: FileParameter | null | undefined, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/public/stopenote/{stopeNoteId}/approvers/approve/{accessTokenHash}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (signatureFile !== null && signatureFile !== undefined)
            content_.append("SignatureFile", signatureFile.data, signatureFile.fileName ? signatureFile.fileName : "SignatureFile");
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublicApproveApprover(_response);
        });
    }

    protected processPublicApproveApprover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    publicRejectStopeNote(mineModelId: string, stopeNoteId: string, accessTokenHash: string, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/public/stopenote/{stopeNoteId}/approvers/reject/{accessTokenHash}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        if (accessTokenHash === undefined || accessTokenHash === null)
            throw new Error("The parameter 'accessTokenHash' must be defined.");
        url_ = url_.replace("{accessTokenHash}", encodeURIComponent("" + accessTokenHash));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPublicRejectStopeNote(_response);
        });
    }

    protected processPublicRejectStopeNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StopeNotesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    createStopeNote(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, isPdf?: boolean | null | undefined, includeRoutePoints?: boolean | null | undefined, includeRiseRate?: boolean | null | undefined, routePoints?: string | null | undefined, hglImages?: string | null | undefined, riseRateImageBase64?: string | null | undefined, riseRateSlices?: string | null | undefined, customPdf?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenote/create?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (isPdf !== null && isPdf !== undefined)
            content_.append("IsPdf", isPdf.toString());
        if (includeRoutePoints !== null && includeRoutePoints !== undefined)
            content_.append("IncludeRoutePoints", includeRoutePoints.toString());
        if (includeRiseRate !== null && includeRiseRate !== undefined)
            content_.append("IncludeRiseRate", includeRiseRate.toString());
        if (routePoints !== null && routePoints !== undefined)
            content_.append("RoutePoints", routePoints.toString());
        if (hglImages !== null && hglImages !== undefined)
            content_.append("HglImages", hglImages.toString());
        if (riseRateImageBase64 !== null && riseRateImageBase64 !== undefined)
            content_.append("RiseRateImageBase64", riseRateImageBase64.toString());
        if (riseRateSlices !== null && riseRateSlices !== undefined)
            content_.append("RiseRateSlices", riseRateSlices.toString());
        if (customPdf !== null && customPdf !== undefined)
            content_.append("CustomPdf", customPdf.data, customPdf.fileName ? customPdf.fileName : "CustomPdf");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateStopeNote(_response);
        });
    }

    protected processCreateStopeNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    downloadStopeNote(mineModelId: string, stopeId: string, stopeNoteId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadStopeNote(_response);
        });
    }

    protected processDownloadStopeNote(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getStopeNotes(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<StopeNoteDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStopeNotes(_response);
        });
    }

    protected processGetStopeNotes(response: AxiosResponse): Promise<StopeNoteDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('StopeNoteDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopeNoteDto[]>(null as any);
    }

    addApprover(mineModelId: string, stopeId: string, stopeNoteId: string, cmd: AddStopeNoteApproverCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/approvers";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddApprover(_response);
        });
    }

    protected processAddApprover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeApprover(mineModelId: string, stopeId: string, stopeNoteId: string, cmd: RemoveStopeNoteApproverCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/approvers";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveApprover(_response);
        });
    }

    protected processRemoveApprover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    approveApprover(mineModelId: string, stopeId: string, stopeNoteId: string, email?: string | null | undefined, signatureFile?: FileParameter | null | undefined, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/approvers/approve";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (signatureFile !== null && signatureFile !== undefined)
            content_.append("SignatureFile", signatureFile.data, signatureFile.fileName ? signatureFile.fileName : "SignatureFile");
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveApprover(_response);
        });
    }

    protected processApproveApprover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    unapproveApprover(mineModelId: string, stopeId: string, stopeNoteId: string, cmd: UnapproveStopeNoteApproverCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/approvers/unapprove";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnapproveApprover(_response);
        });
    }

    protected processUnapproveApprover(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    requestApproval(mineModelId: string, stopeId: string, stopeNoteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/requestapproval";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestApproval(_response);
        });
    }

    protected processRequestApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resendApproval(mineModelId: string, stopeId: string, stopeNoteId: string, cmd: ResendStopeNoteApprovalCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/resendapproval";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendApproval(_response);
        });
    }

    protected processResendApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    approveStopeNote(mineModelId: string, stopeId: string, stopeNoteId: string, isPdf?: boolean | null | undefined, includeRoutePoints?: boolean | null | undefined, routePoints?: string | null | undefined, hglImages?: string | null | undefined, riseRateImageBase64?: string | null | undefined, riseRateSlices?: string | null | undefined, customPdf?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/approve";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (isPdf !== null && isPdf !== undefined)
            content_.append("IsPdf", isPdf.toString());
        if (includeRoutePoints !== null && includeRoutePoints !== undefined)
            content_.append("IncludeRoutePoints", includeRoutePoints.toString());
        if (routePoints !== null && routePoints !== undefined)
            content_.append("RoutePoints", routePoints.toString());
        if (hglImages !== null && hglImages !== undefined)
            content_.append("HglImages", hglImages.toString());
        if (riseRateImageBase64 !== null && riseRateImageBase64 !== undefined)
            content_.append("RiseRateImageBase64", riseRateImageBase64.toString());
        if (riseRateSlices !== null && riseRateSlices !== undefined)
            content_.append("RiseRateSlices", riseRateSlices.toString());
        if (customPdf !== null && customPdf !== undefined)
            content_.append("CustomPdf", customPdf.data, customPdf.fileName ? customPdf.fileName : "CustomPdf");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveStopeNote(_response);
        });
    }

    protected processApproveStopeNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    unapproveStopeNote(mineModelId: string, stopeId: string, stopeNoteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/unapprove";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnapproveStopeNote(_response);
        });
    }

    protected processUnapproveStopeNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    voidStopeNote(mineModelId: string, stopeId: string, stopeNoteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenotes/{stopeNoteId}/void";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (stopeNoteId === undefined || stopeNoteId === null)
            throw new Error("The parameter 'stopeNoteId' must be defined.");
        url_ = url_.replace("{stopeNoteId}", encodeURIComponent("" + stopeNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVoidStopeNote(_response);
        });
    }

    protected processVoidStopeNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRouteImages(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<StopeNoteRouteImageDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenote-route-images?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRouteImages(_response);
        });
    }

    protected processGetRouteImages(response: AxiosResponse): Promise<StopeNoteRouteImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('StopeNoteRouteImageDto[]', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopeNoteRouteImageDto[]>(null as any);
    }

    addRouteImages(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, images?: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<StopeNoteRouteImageDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenote-route-images?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (images !== null && images !== undefined)
            images.forEach(item_ => content_.append("images", item_.data, item_.fileName ? item_.fileName : "images") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRouteImages(_response);
        });
    }

    protected processAddRouteImages(response: AxiosResponse): Promise<StopeNoteRouteImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('StopeNoteRouteImageDto[]', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopeNoteRouteImageDto[]>(null as any);
    }

    deleteRouteImage(mineModelId: string, stopeId: string, fileId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/stopenote-route-images/{fileId}?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRouteImage(_response);
        });
    }

    protected processDeleteRouteImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AnalyticsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * The parameters a user can drop onto a chart shelf, grouped for the builder's rail.
     */
    getChartParameters(mineModelId: string, cancelToken?: CancelToken): Promise<ChartParameterGroupDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/analytics/chart-parameters";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChartParameters(_response);
        });
    }

    protected processGetChartParameters(response: AxiosResponse): Promise<ChartParameterGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ChartParameterGroupDto[]', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartParameterGroupDto[]>(null as any);
    }

    /**
     * The project's saved chart specs, as the raw JSON array the client wrote.
     */
    getDashboardCharts(mineModelId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/analytics/charts";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDashboardCharts(_response);
        });
    }

    protected processGetDashboardCharts(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * One flat, typed row per pour — the fact table the chart builder aggregates over.
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param status (optional) 
     * @param stopeId (optional) 
     * @param scenarioId (optional) 
     */
    getPourFacts(mineModelId: string, startDate?: string | null | undefined, endDate?: string | null | undefined, status?: PourStatus | null | undefined, stopeId?: string | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<PourFactDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/analytics/pour-facts?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (stopeId !== undefined && stopeId !== null)
            url_ += "StopeId=" + encodeURIComponent("" + stopeId) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPourFacts(_response);
        });
    }

    protected processGetPourFacts(response: AxiosResponse): Promise<PourFactDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourFactDto[]', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourFactDto[]>(null as any);
    }
}

export class PourTypesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * @deprecated
     */
    getAllByProject(mineModelId: string, cancelToken?: CancelToken): Promise<PourTypeDataDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/pourTypes";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByProject(_response);
        });
    }

    protected processGetAllByProject(response: AxiosResponse): Promise<PourTypeDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourTypeDataDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourTypeDataDto[]>(null as any);
    }

    /**
     * @deprecated
     */
    create(mineModelId: string, cmd: CreatePourTypesCommand, cancelToken?: CancelToken): Promise<PourTypeDataId[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/pourTypes";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PourTypeDataId[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('PourTypeDataId[]', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourTypeDataId[]>(null as any);
    }

    /**
     * @deprecated
     */
    update(mineModelId: string, cmd: UpdatePourTypeCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/pourTypes";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @deprecated
     */
    getByStopeId(mineModelId: string, stopeId: string, cancelToken?: CancelToken): Promise<PourTypeDataDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/pourTypes";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByStopeId(_response);
        });
    }

    protected processGetByStopeId(response: AxiosResponse): Promise<PourTypeDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourTypeDataDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourTypeDataDto[]>(null as any);
    }
}

export class CustomReportsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    getTemplates(projectId: string, cancelToken?: CancelToken): Promise<CustomReportTemplateDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplates(_response);
        });
    }

    protected processGetTemplates(response: AxiosResponse): Promise<CustomReportTemplateDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportTemplateDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportTemplateDto[]>(null as any);
    }

    createTemplate(projectId: string, form: CustomReportTemplateForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTemplate(_response);
        });
    }

    protected processCreateTemplate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getStopeNoteTemplateId(projectId: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/stope-note-template";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStopeNoteTemplateId(_response);
        });
    }

    protected processGetStopeNoteTemplateId(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateTemplate(projectId: string, templateId: string, form: CustomReportTemplateForm, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates/{templateId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTemplate(_response);
        });
    }

    protected processUpdateTemplate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTemplate(projectId: string, templateId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates/{templateId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTemplate(_response);
        });
    }

    protected processDeleteTemplate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadTemplateFile(projectId: string, templateId: string, templateFile?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<CustomReportTemplateDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates/{templateId}/file";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (templateFile !== null && templateFile !== undefined)
            content_.append("TemplateFile", templateFile.data, templateFile.fileName ? templateFile.fileName : "TemplateFile");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTemplateFile(_response);
        });
    }

    protected processUploadTemplateFile(response: AxiosResponse): Promise<CustomReportTemplateDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportTemplateDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportTemplateDto>(null as any);
    }

    downloadTemplateFile(projectId: string, templateId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates/{templateId}/file";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadTemplateFile(_response);
        });
    }

    protected processDownloadTemplateFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRequirements(projectId: string, targetType?: CustomReportTargetType | undefined, targetId?: string | null | undefined, cancelToken?: CancelToken): Promise<CustomReportRequirementStatusDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/requirements?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (targetType === null)
            throw new Error("The parameter 'targetType' cannot be null.");
        else if (targetType !== undefined)
            url_ += "targetType=" + encodeURIComponent("" + targetType) + "&";
        if (targetId !== undefined && targetId !== null)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRequirements(_response);
        });
    }

    protected processGetRequirements(response: AxiosResponse): Promise<CustomReportRequirementStatusDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportRequirementStatusDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportRequirementStatusDto[]>(null as any);
    }

    getBindingCatalog(projectId: string, targetType?: CustomReportTargetType | undefined, cancelToken?: CancelToken): Promise<CustomReportBindingGroupDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/binding-catalog?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (targetType === null)
            throw new Error("The parameter 'targetType' cannot be null.");
        else if (targetType !== undefined)
            url_ += "targetType=" + encodeURIComponent("" + targetType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBindingCatalog(_response);
        });
    }

    protected processGetBindingCatalog(response: AxiosResponse): Promise<CustomReportBindingGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportBindingGroupDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportBindingGroupDto[]>(null as any);
    }

    getResolvedValues(projectId: string, templateId: string, form: ResolveCustomReportValuesForm, targetType?: CustomReportTargetType | undefined, targetId?: string | null | undefined, cancelToken?: CancelToken): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates/{templateId}/resolved-values?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (targetType === null)
            throw new Error("The parameter 'targetType' cannot be null.");
        else if (targetType !== undefined)
            url_ += "targetType=" + encodeURIComponent("" + targetType) + "&";
        if (targetId !== undefined && targetId !== null)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResolvedValues(_response);
        });
    }

    protected processGetResolvedValues(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('{ [key: string]: string; }', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    getStopeBindings(projectId: string, stopeId: string, cancelToken?: CancelToken): Promise<CustomReportStopeBindingDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/stopes/{stopeId}/bindings";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStopeBindings(_response);
        });
    }

    protected processGetStopeBindings(response: AxiosResponse): Promise<CustomReportStopeBindingDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportStopeBindingDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportStopeBindingDto[]>(null as any);
    }

    setStopeBinding(projectId: string, stopeId: string, templateId: string, form: SetCustomReportStopeBindingForm, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/stopes/{stopeId}/bindings/{templateId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetStopeBinding(_response);
        });
    }

    protected processSetStopeBinding(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTemplateRequirements(projectId: string, templateId: string, cancelToken?: CancelToken): Promise<CustomReportTemplateRequirementsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates/{templateId}/requirements";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTemplateRequirements(_response);
        });
    }

    protected processGetTemplateRequirements(response: AxiosResponse): Promise<CustomReportTemplateRequirementsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportTemplateRequirementsDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportTemplateRequirementsDto>(null as any);
    }

    setTemplateRequirements(projectId: string, templateId: string, form: SetCustomReportTemplateRequirementsForm, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/templates/{templateId}/requirements";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTemplateRequirements(_response);
        });
    }

    protected processSetTemplateRequirements(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSubmissions(projectId: string, cancelToken?: CancelToken): Promise<CustomReportSubmissionDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/submissions";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubmissions(_response);
        });
    }

    protected processGetSubmissions(response: AxiosResponse): Promise<CustomReportSubmissionDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportSubmissionDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportSubmissionDto[]>(null as any);
    }

    saveSubmission(projectId: string, templateId: string, form: SaveCustomReportSubmissionForm, targetType?: CustomReportTargetType | undefined, targetId?: string | null | undefined, cancelToken?: CancelToken): Promise<CustomReportSubmissionDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/custom-reports/submissions/{templateId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        if (targetType === null)
            throw new Error("The parameter 'targetType' cannot be null.");
        else if (targetType !== undefined)
            url_ += "targetType=" + encodeURIComponent("" + targetType) + "&";
        if (targetId !== undefined && targetId !== null)
            url_ += "targetId=" + encodeURIComponent("" + targetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSubmission(_response);
        });
    }

    protected processSaveSubmission(response: AxiosResponse): Promise<CustomReportSubmissionDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('CustomReportSubmissionDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomReportSubmissionDto>(null as any);
    }
}

export class BackfillRecipesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    get(recipeId: string, cancelToken?: CancelToken): Promise<BackfillRecipeDto> {
        let url_ = this.baseUrl + "/api/BackfillRecipes/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BackfillRecipeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BackfillRecipeDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackfillRecipeDto>(null as any);
    }

    update(recipeId: string, form: UpdateBackfillRecipeCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BackfillRecipes/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(recipeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BackfillRecipes/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAllByProject(projectId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<BackfillRecipeDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/recipes/all?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByProject(_response);
        });
    }

    protected processGetAllByProject(response: AxiosResponse): Promise<BackfillRecipeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BackfillRecipeDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackfillRecipeDto[]>(null as any);
    }

    getAllAutoCreated(projectId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<AutoCreatedRecipeDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/recipes/autocreated?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAutoCreated(_response);
        });
    }

    protected processGetAllAutoCreated(response: AxiosResponse): Promise<AutoCreatedRecipeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('AutoCreatedRecipeDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutoCreatedRecipeDto[]>(null as any);
    }

    getAll(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<BackfillRecipeDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/recipes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<BackfillRecipeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BackfillRecipeDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BackfillRecipeDto[]>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param recipeReference (optional) 
     * @param scenarioId (optional) 
     */
    getPaginated(mineModelId: string, stopeId: string, page?: number | undefined, pageSize?: number | null | undefined, recipeReference?: string | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfBackfillRecipeDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/recipes/paginated?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (recipeReference !== undefined && recipeReference !== null)
            url_ += "recipeReference=" + encodeURIComponent("" + recipeReference) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaginated(_response);
        });
    }

    protected processGetPaginated(response: AxiosResponse): Promise<PagedListOfBackfillRecipeDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfBackfillRecipeDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfBackfillRecipeDto>(null as any);
    }

    create(mineModelId: string, form: CreateBackfillRecipeCommand[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/recipes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    restore(recipeId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BackfillRecipes/{recipeId}/restore";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    undoAutoRecipes(mineModelId: string, autoRecipeBatchId: number, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/autoRecipeBatchId/{autoRecipeBatchId}/undoAutoRecipes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (autoRecipeBatchId === undefined || autoRecipeBatchId === null)
            throw new Error("The parameter 'autoRecipeBatchId' must be defined.");
        url_ = url_.replace("{autoRecipeBatchId}", encodeURIComponent("" + autoRecipeBatchId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUndoAutoRecipes(_response);
        });
    }

    protected processUndoAutoRecipes(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class StopeBackfillingService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    markComplete(mineModelId: string, stopeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/StopeBackfilling/{mineModelId}/stopes/{stopeId}/markcomplete";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkComplete(_response);
        });
    }

    protected processMarkComplete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markIncomplete(mineModelId: string, stopeId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/StopeBackfilling/{mineModelId}/stopes/{stopeId}/markincomplete";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkIncomplete(_response);
        });
    }

    protected processMarkIncomplete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PoursService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param status (optional) 
     * @param stopeId (optional) 
     * @param scenarioId (optional) 
     */
    getAllByProject(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, status?: PourStatus | null | undefined, stopeId?: string | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfPourReportDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/pours?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (stopeId !== undefined && stopeId !== null)
            url_ += "StopeId=" + encodeURIComponent("" + stopeId) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByProject(_response);
        });
    }

    protected processGetAllByProject(response: AxiosResponse): Promise<PagedListOfPourReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfPourReportDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfPourReportDto>(null as any);
    }

    get(pourId: string, cancelToken?: CancelToken): Promise<PourDto> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PourDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourDto>(null as any);
    }

    /**
     * Deletes a pour by the specified ID.
     * @param pourId The ID of the pour to delete.
     * @return An IActionResult indicating the result of the operation.
     */
    deletePour(pourId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePour(_response);
        });
    }

    protected processDeletePour(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getProjectPreferencesForPour(pourId: string, cancelToken?: CancelToken): Promise<PourProjectPreferencesDto> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/GetProjectPreferences";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectPreferencesForPour(_response);
        });
    }

    protected processGetProjectPreferencesForPour(response: AxiosResponse): Promise<PourProjectPreferencesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourProjectPreferencesDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourProjectPreferencesDto>(null as any);
    }

    getPourBreakingScheduleDetails(pourId: string, cancelToken?: CancelToken): Promise<PourBreakingScheduleDetailsDto> {
        let url_ = this.baseUrl + "/api/Pours/Pour/{pourId}/BreakingScheduleDetails";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPourBreakingScheduleDetails(_response);
        });
    }

    protected processGetPourBreakingScheduleDetails(response: AxiosResponse): Promise<PourBreakingScheduleDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourBreakingScheduleDetailsDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourBreakingScheduleDetailsDto>(null as any);
    }

    createPourNote(pourId: string, isPdf?: boolean | null | undefined, includeRoutePoints?: boolean | null | undefined, includeRiseRate?: boolean | null | undefined, routePoints?: string | null | undefined, hglImageBase64?: string | null | undefined, riseRateImageBase64?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournote/create";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (isPdf !== null && isPdf !== undefined)
            content_.append("IsPdf", isPdf.toString());
        if (includeRoutePoints !== null && includeRoutePoints !== undefined)
            content_.append("IncludeRoutePoints", includeRoutePoints.toString());
        if (includeRiseRate !== null && includeRiseRate !== undefined)
            content_.append("IncludeRiseRate", includeRiseRate.toString());
        if (routePoints !== null && routePoints !== undefined)
            content_.append("RoutePoints", routePoints.toString());
        if (hglImageBase64 !== null && hglImageBase64 !== undefined)
            content_.append("HglImageBase64", hglImageBase64.toString());
        if (riseRateImageBase64 !== null && riseRateImageBase64 !== undefined)
            content_.append("RiseRateImageBase64", riseRateImageBase64.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePourNote(_response);
        });
    }

    protected processCreatePourNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePourDate(pourId: string, cmd: UpdatePourDateCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/date";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePourDate(_response);
        });
    }

    protected processUpdatePourDate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePourVolume(pourId: string, cmd: UpdatePourVolumeCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/volume";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePourVolume(_response);
        });
    }

    protected processUpdatePourVolume(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePourReference(pourId: string, cmd: UpdatePourReferenceCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/reference";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePourReference(_response);
        });
    }

    protected processUpdatePourReference(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addApproverToPourNote(pourId: string, pourNoteId: string, cmd: AddApproverCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/approvers";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddApproverToPourNote(_response);
        });
    }

    protected processAddApproverToPourNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeApproverToPourNote(pourId: string, pourNoteId: string, cmd: RemoveApproverCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/approvers";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveApproverToPourNote(_response);
        });
    }

    protected processRemoveApproverToPourNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    approvePourNoteApproval(pourId: string, pourNoteId: string, email?: string | null | undefined, signatureFile?: FileParameter | null | undefined, comment?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/approvers/approve";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (signatureFile !== null && signatureFile !== undefined)
            content_.append("SignatureFile", signatureFile.data, signatureFile.fileName ? signatureFile.fileName : "SignatureFile");
        if (comment !== null && comment !== undefined)
            content_.append("Comment", comment.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovePourNoteApproval(_response);
        });
    }

    protected processApprovePourNoteApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    unapprovePourNoteApproval(pourId: string, pourNoteId: string, cmd: UnapprovePourNoteApprovalCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/approvers/unapprove";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnapprovePourNoteApproval(_response);
        });
    }

    protected processUnapprovePourNoteApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    downloadAttachment(pourId: string, fileId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/attachments/{fileId}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadAttachment(_response);
        });
    }

    protected processDownloadAttachment(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRouteImages(pourId: string, cancelToken?: CancelToken): Promise<PourRouteImageDto[]> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/route-images";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRouteImages(_response);
        });
    }

    protected processGetRouteImages(response: AxiosResponse): Promise<PourRouteImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourRouteImageDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourRouteImageDto[]>(null as any);
    }

    addRouteImages(pourId: string, images?: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<PourRouteImageDto[]> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/route-images";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (images !== null && images !== undefined)
            images.forEach(item_ => content_.append("images", item_.data, item_.fileName ? item_.fileName : "images") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRouteImages(_response);
        });
    }

    protected processAddRouteImages(response: AxiosResponse): Promise<PourRouteImageDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourRouteImageDto[]', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourRouteImageDto[]>(null as any);
    }

    deleteRouteImage(pourId: string, fileId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/route-images/{fileId}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRouteImage(_response);
        });
    }

    protected processDeleteRouteImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    downloadPourNote(pourId: string, pourNoteId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadPourNote(_response);
        });
    }

    protected processDownloadPourNote(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    voidPourNote(pourId: string, pourNoteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/void";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVoidPourNote(_response);
        });
    }

    protected processVoidPourNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    requestPourNoteApproval(pourId: string, pourNoteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/requestapproval";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestPourNoteApproval(_response);
        });
    }

    protected processRequestPourNoteApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resendPourNoteApproval(pourId: string, pourNoteId: string, form: ResendPourNoteApprovalRequestCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/resendapproval";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendPourNoteApproval(_response);
        });
    }

    protected processResendPourNoteApproval(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    approvePourNote(pourId: string, pourNoteId: string, isPdf?: boolean | null | undefined, includeRoutePoints?: boolean | null | undefined, routePoints?: string | null | undefined, hglImageBase64?: string | null | undefined, riseRateImageBase64?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/approve";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (isPdf !== null && isPdf !== undefined)
            content_.append("IsPdf", isPdf.toString());
        if (includeRoutePoints !== null && includeRoutePoints !== undefined)
            content_.append("IncludeRoutePoints", includeRoutePoints.toString());
        if (routePoints !== null && routePoints !== undefined)
            content_.append("RoutePoints", routePoints.toString());
        if (hglImageBase64 !== null && hglImageBase64 !== undefined)
            content_.append("HglImageBase64", hglImageBase64.toString());
        if (riseRateImageBase64 !== null && riseRateImageBase64 !== undefined)
            content_.append("RiseRateImageBase64", riseRateImageBase64.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovePourNote(_response);
        });
    }

    protected processApprovePourNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    unapprovePourNote(pourId: string, pourNoteId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pournotes/{pourNoteId}/unapprove";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (pourNoteId === undefined || pourNoteId === null)
            throw new Error("The parameter 'pourNoteId' must be defined.");
        url_ = url_.replace("{pourNoteId}", encodeURIComponent("" + pourNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnapprovePourNote(_response);
        });
    }

    protected processUnapprovePourNote(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAll(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, includeRockFill?: boolean | undefined, cancelToken?: CancelToken): Promise<PourDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/pours?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (includeRockFill === null)
            throw new Error("The parameter 'includeRockFill' cannot be null.");
        else if (includeRockFill !== undefined)
            url_ += "includeRockFill=" + encodeURIComponent("" + includeRockFill) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<PourDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourDto[]>(null as any);
    }

    getMineOverview(mineModelId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<StopeBackfillSummaryDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/pours/overview?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMineOverview(_response);
        });
    }

    protected processGetMineOverview(response: AxiosResponse): Promise<StopeBackfillSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('StopeBackfillSummaryDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopeBackfillSummaryDto[]>(null as any);
    }

    getStopeOverview(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<StopeBackfillSummaryDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopes/{stopeId}/pours/overview?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStopeOverview(_response);
        });
    }

    protected processGetStopeOverview(response: AxiosResponse): Promise<StopeBackfillSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('StopeBackfillSummaryDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopeBackfillSummaryDto>(null as any);
    }

    create(recipeId: string, form: PourForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/BackfillRecipe/{recipeId}/pours";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Creates multiple pours in a single request. Pours may reference different recipes.
    Creation is best-effort: pours that fail are reported in the result without aborting the batch.
     */
    createPours(command: CreatePoursCommand, cancelToken?: CancelToken): Promise<CreatePoursResult> {
        let url_ = this.baseUrl + "/api/Pours/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePours(_response);
        });
    }

    protected processCreatePours(response: AxiosResponse): Promise<CreatePoursResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('CreatePoursResult', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatePoursResult>(null as any);
    }

    /**
     * Creates a "rock fill" pour: a recipe-less pour that only carries a volume/height against a stope,
    for stope-fill reporting. It is not surfaced in the normal pour workflows.
     * @param scenarioId (optional) 
     * @param pourPresetId (optional) 
     */
    createRockFillPour(mineModelId: string, stopeId: string, form: PourForm, scenarioId?: string | null | undefined, pourPresetId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Pours/{mineModelId}/stope/{stopeId}/rockfill?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (pourPresetId !== undefined && pourPresetId !== null)
            url_ += "pourPresetId=" + encodeURIComponent("" + pourPresetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRockFillPour(_response);
        });
    }

    protected processCreateRockFillPour(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getAllAutoCreated(projectId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<AutoCreatedPourDto[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/pours/autocreated?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllAutoCreated(_response);
        });
    }

    protected processGetAllAutoCreated(response: AxiosResponse): Promise<AutoCreatedPourDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('AutoCreatedPourDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AutoCreatedPourDto[]>(null as any);
    }

    undoAutoPours(mineModelId: string, autoPourBatchId: number, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/autoPourBatchId/{autoPourBatchId}/undoAutoPours?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (autoPourBatchId === undefined || autoPourBatchId === null)
            throw new Error("The parameter 'autoPourBatchId' must be defined.");
        url_ = url_.replace("{autoPourBatchId}", encodeURIComponent("" + autoPourBatchId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUndoAutoPours(_response);
        });
    }

    protected processUndoAutoPours(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    completePour(pourId: string, operatorLogNote?: FileParameter | null | undefined, pourCompletedDate?: string | null | undefined, dryTonnage?: number | null | undefined, massConcentration?: number | null | undefined, binderContent?: number | null | undefined, volume?: number | null | undefined, totalBinder?: number | null | undefined, comments?: string | null | undefined, volumeRetainedAfterOutflow?: number | null | undefined, binderTailingsRatio?: number | null | undefined, documents?: PourDocument[] | null | undefined, uCSAverage?: number | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/complete";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (operatorLogNote !== null && operatorLogNote !== undefined)
            content_.append("operatorLogNote", operatorLogNote.data, operatorLogNote.fileName ? operatorLogNote.fileName : "operatorLogNote");
        if (pourCompletedDate !== null && pourCompletedDate !== undefined)
            content_.append("PourCompletedDate", pourCompletedDate.toString());
        if (dryTonnage !== null && dryTonnage !== undefined)
            content_.append("DryTonnage", dryTonnage.toString());
        if (massConcentration !== null && massConcentration !== undefined)
            content_.append("MassConcentration", massConcentration.toString());
        if (binderContent !== null && binderContent !== undefined)
            content_.append("BinderContent", binderContent.toString());
        if (volume !== null && volume !== undefined)
            content_.append("Volume", volume.toString());
        if (totalBinder !== null && totalBinder !== undefined)
            content_.append("TotalBinder", totalBinder.toString());
        if (comments !== null && comments !== undefined)
            content_.append("Comments", comments.toString());
        if (volumeRetainedAfterOutflow !== null && volumeRetainedAfterOutflow !== undefined)
            content_.append("VolumeRetainedAfterOutflow", volumeRetainedAfterOutflow.toString());
        if (binderTailingsRatio !== null && binderTailingsRatio !== undefined)
            content_.append("BinderTailingsRatio", binderTailingsRatio.toString());
        if (documents !== null && documents !== undefined)
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (uCSAverage !== null && uCSAverage !== undefined)
            content_.append("UCSAverage", uCSAverage.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompletePour(_response);
        });
    }

    protected processCompletePour(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updatePourData(pourId: string, operatorLogNote?: FileParameter | null | undefined, pourCompletedDate?: string | null | undefined, dryTonnage?: number | null | undefined, massConcentration?: number | null | undefined, binderContent?: number | null | undefined, volume?: number | null | undefined, totalBinder?: number | null | undefined, comments?: string | null | undefined, volumeRetainedAfterOutflow?: number | null | undefined, binderTailingsRatio?: number | null | undefined, documents?: PourDocument[] | null | undefined, uCSAverage?: number | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/pourdata";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (operatorLogNote !== null && operatorLogNote !== undefined)
            content_.append("operatorLogNote", operatorLogNote.data, operatorLogNote.fileName ? operatorLogNote.fileName : "operatorLogNote");
        if (pourCompletedDate !== null && pourCompletedDate !== undefined)
            content_.append("PourCompletedDate", pourCompletedDate.toString());
        if (dryTonnage !== null && dryTonnage !== undefined)
            content_.append("DryTonnage", dryTonnage.toString());
        if (massConcentration !== null && massConcentration !== undefined)
            content_.append("MassConcentration", massConcentration.toString());
        if (binderContent !== null && binderContent !== undefined)
            content_.append("BinderContent", binderContent.toString());
        if (volume !== null && volume !== undefined)
            content_.append("Volume", volume.toString());
        if (totalBinder !== null && totalBinder !== undefined)
            content_.append("TotalBinder", totalBinder.toString());
        if (comments !== null && comments !== undefined)
            content_.append("Comments", comments.toString());
        if (volumeRetainedAfterOutflow !== null && volumeRetainedAfterOutflow !== undefined)
            content_.append("VolumeRetainedAfterOutflow", volumeRetainedAfterOutflow.toString());
        if (binderTailingsRatio !== null && binderTailingsRatio !== undefined)
            content_.append("BinderTailingsRatio", binderTailingsRatio.toString());
        if (documents !== null && documents !== undefined)
            documents.forEach(item_ => content_.append("Documents", item_.toString()));
        if (uCSAverage !== null && uCSAverage !== undefined)
            content_.append("UCSAverage", uCSAverage.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePourData(_response);
        });
    }

    protected processUpdatePourData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addDocumentToPour(pourId: string, files?: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/adddocumenttopour";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDocumentToPour(_response);
        });
    }

    protected processAddDocumentToPour(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeDocumentFromPour(pourId: string, fileName?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/removedocumentfrompour?";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDocumentFromPour(_response);
        });
    }

    protected processRemoveDocumentFromPour(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    abandonPour(pourId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/abandon";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAbandonPour(_response);
        });
    }

    protected processAbandonPour(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves historical pour volume data for a project.
     * @param mineModelId The unique identifier of the project.
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param status (optional) 
     * @param stopeId (optional) 
     * @param scenarioId (optional) The scenario to scope the data to, or null for master.
     * @return A result containing a paged list of PourVolumeComparisonDto objects.
     */
    getHistoricalPourVolumeDataByProject(mineModelId: string, startDate?: string | null | undefined, endDate?: string | null | undefined, status?: PourStatus | null | undefined, stopeId?: string | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<PourVolumeComparisonDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/pourvolumecomparison?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (stopeId !== undefined && stopeId !== null)
            url_ += "StopeId=" + encodeURIComponent("" + stopeId) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHistoricalPourVolumeDataByProject(_response);
        });
    }

    protected processGetHistoricalPourVolumeDataByProject(response: AxiosResponse): Promise<PourVolumeComparisonDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourVolumeComparisonDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourVolumeComparisonDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param scenarioId (optional) 
     * @return A number that relates to the savings made in the users preferred currency
     */
    getBinderCostSavedByProject(mineModelId: string, startDate?: string | undefined, endDate?: string | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<BinderSavingsReportDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/binderCostSaved?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBinderCostSavedByProject(_response);
        });
    }

    protected processGetBinderCostSavedByProject(response: AxiosResponse): Promise<BinderSavingsReportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BinderSavingsReportDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BinderSavingsReportDto>(null as any);
    }

    createPourPreset(form: CreatePourPresetForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Pours/pourpreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePourPreset(_response);
        });
    }

    protected processCreatePourPreset(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    createPourPresetGroup(mineModelId: string, form: CreatePourPresetGroupForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Pours/{mineModelId}/pourpresetgroup";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePourPresetGroup(_response);
        });
    }

    protected processCreatePourPresetGroup(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param groupName (optional) 
     * @param presetName (optional) 
     */
    getPourPresetGroups(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, groupName?: string | null | undefined, presetName?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfPourPresetGroupDto> {
        let url_ = this.baseUrl + "/api/Pours/{mineModelId}/pourpresetgroups?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (groupName !== undefined && groupName !== null)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        if (presetName !== undefined && presetName !== null)
            url_ += "presetName=" + encodeURIComponent("" + presetName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPourPresetGroups(_response);
        });
    }

    protected processGetPourPresetGroups(response: AxiosResponse): Promise<PagedListOfPourPresetGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfPourPresetGroupDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfPourPresetGroupDto>(null as any);
    }

    /**
     * Deletes a pour preset by the specified ID.
     * @param pourPresetId The ID of the pour preset to delete.
     * @return An IActionResult indicating the result of the operation.
     */
    deletePourPreset(pourPresetId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/pourpreset/{pourPresetId}";
        if (pourPresetId === undefined || pourPresetId === null)
            throw new Error("The parameter 'pourPresetId' must be defined.");
        url_ = url_.replace("{pourPresetId}", encodeURIComponent("" + pourPresetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePourPreset(_response);
        });
    }

    protected processDeletePourPreset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates a pour preset with the specified ID using the provided form data.
     * @param pourPresetId The ID of the pour preset to update.
     * @param form The form data containing the new information for the pour preset.
     * @return An IActionResult indicating the result of the operation.
     */
    updatePourPreset(pourPresetId: string, form: UpdatePourPresetForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/pourpreset/{pourPresetId}";
        if (pourPresetId === undefined || pourPresetId === null)
            throw new Error("The parameter 'pourPresetId' must be defined.");
        url_ = url_.replace("{pourPresetId}", encodeURIComponent("" + pourPresetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePourPreset(_response);
        });
    }

    protected processUpdatePourPreset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    restorePourPreset(pourPresetId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pours/pourpreset/{pourPresetId}/restore";
        if (pourPresetId === undefined || pourPresetId === null)
            throw new Error("The parameter 'pourPresetId' must be defined.");
        url_ = url_.replace("{pourPresetId}", encodeURIComponent("" + pourPresetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestorePourPreset(_response);
        });
    }

    protected processRestorePourPreset(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes a pour preset group by the specified ID.
     * @param pourPresetGroupId The ID of the pour preset group to delete.
     * @return An ActionResult indicating the result of the operation.
     */
    deletePourPresetGroup(pourPresetGroupId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/pourpresetgroup/{pourPresetGroupId}";
        if (pourPresetGroupId === undefined || pourPresetGroupId === null)
            throw new Error("The parameter 'pourPresetGroupId' must be defined.");
        url_ = url_.replace("{pourPresetGroupId}", encodeURIComponent("" + pourPresetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePourPresetGroup(_response);
        });
    }

    protected processDeletePourPresetGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Pour preset group with no pour presets by id.
     * @param pourPresetGroupId The ID of the pour preset group to retrieve.
     * @return PourPresetGroupDto
     */
    getPourPresetGroup(pourPresetGroupId: string, cancelToken?: CancelToken): Promise<PourPresetGroupDto> {
        let url_ = this.baseUrl + "/api/Pours/pourpresetgroup/{pourPresetGroupId}";
        if (pourPresetGroupId === undefined || pourPresetGroupId === null)
            throw new Error("The parameter 'pourPresetGroupId' must be defined.");
        url_ = url_.replace("{pourPresetGroupId}", encodeURIComponent("" + pourPresetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPourPresetGroup(_response);
        });
    }

    protected processGetPourPresetGroup(response: AxiosResponse): Promise<PourPresetGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourPresetGroupDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourPresetGroupDto>(null as any);
    }

    restorePourPresetGroup(pourPresetGroupId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pours/pourpresetgroup/{pourPresetGroupId}/restore";
        if (pourPresetGroupId === undefined || pourPresetGroupId === null)
            throw new Error("The parameter 'pourPresetGroupId' must be defined.");
        url_ = url_.replace("{pourPresetGroupId}", encodeURIComponent("" + pourPresetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestorePourPresetGroup(_response);
        });
    }

    protected processRestorePourPresetGroup(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Updates the name of a pour preset group by the specified ID.
     * @param pourPresetGroupId The ID of the pour preset group to update.
     * @param name (optional) The new name of the pour preset group.
     * @return An IActionResult indicating the result of the operation.
     */
    updatePourPresetGroupName(pourPresetGroupId: string, name?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/pourpresetgroup/{pourPresetGroupId}/name?";
        if (pourPresetGroupId === undefined || pourPresetGroupId === null)
            throw new Error("The parameter 'pourPresetGroupId' must be defined.");
        url_ = url_.replace("{pourPresetGroupId}", encodeURIComponent("" + pourPresetGroupId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePourPresetGroupName(_response);
        });
    }

    protected processUpdatePourPresetGroupName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reorders the pour presets within a group to match the supplied ordered list of preset ids.
     * @param pourPresetGroupId The ID of the pour preset group whose presets are being reordered.
     * @param form The presets in their new order.
     * @return An IActionResult indicating the result of the operation.
     */
    reorderPourPresets(pourPresetGroupId: string, form: ReorderPourPresetsForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/pourpresetgroup/{pourPresetGroupId}/reorder";
        if (pourPresetGroupId === undefined || pourPresetGroupId === null)
            throw new Error("The parameter 'pourPresetGroupId' must be defined.");
        url_ = url_.replace("{pourPresetGroupId}", encodeURIComponent("" + pourPresetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReorderPourPresets(_response);
        });
    }

    protected processReorderPourPresets(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get Pour preset
     * @param pourPresetId The ID of the pour preset to retrieve.
     * @return PourPresetDto
     */
    getPourPreset(pourPresetId: string, cancelToken?: CancelToken): Promise<PourPresetDto> {
        let url_ = this.baseUrl + "/api/Pours/pourpresetgroup/pourpreset/{pourPresetId}";
        if (pourPresetId === undefined || pourPresetId === null)
            throw new Error("The parameter 'pourPresetId' must be defined.");
        url_ = url_.replace("{pourPresetId}", encodeURIComponent("" + pourPresetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPourPreset(_response);
        });
    }

    protected processGetPourPreset(response: AxiosResponse): Promise<PourPresetDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PourPresetDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PourPresetDto>(null as any);
    }

    createApprovalPresetGroup(projectId: string, form: CreateApprovalPresetGroupForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Pours/{projectId}/approvalpresetgroup";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApprovalPresetGroup(_response);
        });
    }

    protected processCreateApprovalPresetGroup(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param groupName (optional) 
     */
    getApprovalPresetGroups(projectId: string, page?: number | undefined, pageSize?: number | null | undefined, groupName?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfApprovalPresetGroupDto> {
        let url_ = this.baseUrl + "/api/Pours/{projectId}/approvalpresetgroups?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (groupName !== undefined && groupName !== null)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalPresetGroups(_response);
        });
    }

    protected processGetApprovalPresetGroups(response: AxiosResponse): Promise<PagedListOfApprovalPresetGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfApprovalPresetGroupDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfApprovalPresetGroupDto>(null as any);
    }

    deleteApprovalPresetGroup(approvalPresetGroupId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/approvalpresetgroup/{approvalPresetGroupId}";
        if (approvalPresetGroupId === undefined || approvalPresetGroupId === null)
            throw new Error("The parameter 'approvalPresetGroupId' must be defined.");
        url_ = url_.replace("{approvalPresetGroupId}", encodeURIComponent("" + approvalPresetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteApprovalPresetGroup(_response);
        });
    }

    protected processDeleteApprovalPresetGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getApprovalPresetGroup(approvalPresetGroupId: string, cancelToken?: CancelToken): Promise<ApprovalPresetGroupDto> {
        let url_ = this.baseUrl + "/api/Pours/approvalpresetgroup/{approvalPresetGroupId}";
        if (approvalPresetGroupId === undefined || approvalPresetGroupId === null)
            throw new Error("The parameter 'approvalPresetGroupId' must be defined.");
        url_ = url_.replace("{approvalPresetGroupId}", encodeURIComponent("" + approvalPresetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApprovalPresetGroup(_response);
        });
    }

    protected processGetApprovalPresetGroup(response: AxiosResponse): Promise<ApprovalPresetGroupDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ApprovalPresetGroupDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApprovalPresetGroupDto>(null as any);
    }

    updateApprovalPresetGroupName(approvalPresetGroupId: string, name?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/approvalpresetgroup/{approvalPresetGroupId}/name?";
        if (approvalPresetGroupId === undefined || approvalPresetGroupId === null)
            throw new Error("The parameter 'approvalPresetGroupId' must be defined.");
        url_ = url_.replace("{approvalPresetGroupId}", encodeURIComponent("" + approvalPresetGroupId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateApprovalPresetGroupName(_response);
        });
    }

    protected processUpdateApprovalPresetGroupName(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addApprovalPresetGroupEmail(approvalPresetGroupId: string, form: AddApprovalPresetGroupEmailForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/approvalpresetgroup/{approvalPresetGroupId}/emails";
        if (approvalPresetGroupId === undefined || approvalPresetGroupId === null)
            throw new Error("The parameter 'approvalPresetGroupId' must be defined.");
        url_ = url_.replace("{approvalPresetGroupId}", encodeURIComponent("" + approvalPresetGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddApprovalPresetGroupEmail(_response);
        });
    }

    protected processAddApprovalPresetGroupEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeApprovalPresetGroupEmail(approvalPresetGroupId: string, email?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Pours/approvalpresetgroup/{approvalPresetGroupId}/emails?";
        if (approvalPresetGroupId === undefined || approvalPresetGroupId === null)
            throw new Error("The parameter 'approvalPresetGroupId' must be defined.");
        url_ = url_.replace("{approvalPresetGroupId}", encodeURIComponent("" + approvalPresetGroupId));
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveApprovalPresetGroupEmail(_response);
        });
    }

    protected processRemoveApprovalPresetGroupEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param scenarioId (optional) 
     */
    getRelevantStopePours(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfStopePoursDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/relevantstopepours?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRelevantStopePours(_response);
        });
    }

    protected processGetRelevantStopePours(response: AxiosResponse): Promise<PagedListOfStopePoursDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfStopePoursDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfStopePoursDto>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param scenarioId (optional) 
     */
    getScheduledStopePours(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfStopePoursDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/scheduledstopepours?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScheduledStopePours(_response);
        });
    }

    protected processGetScheduledStopePours(response: AxiosResponse): Promise<PagedListOfStopePoursDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfStopePoursDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfStopePoursDto>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param scenarioId (optional) 
     */
    getStopePours(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfStopePoursDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/stopepours?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStopePours(_response);
        });
    }

    protected processGetStopePours(response: AxiosResponse): Promise<PagedListOfStopePoursDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfStopePoursDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfStopePoursDto>(null as any);
    }

    /**
     * Deletes multiple pours by their IDs.
     * @param request The IDs of the pours to delete.
     * @return An IActionResult indicating the result of the operation.
     */
    deletePours(request: BulkDeletePoursRequest, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pours/bulk-delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePours(_response);
        });
    }

    protected processDeletePours(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    restorePour(pourId: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Pours/{pourId}/restore";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestorePour(_response);
        });
    }

    protected processRestorePour(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class BinderDeliveriesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    get(binderDeliveryId: string, cancelToken?: CancelToken): Promise<BinderDeliveryDto> {
        let url_ = this.baseUrl + "/api/BinderDeliveries/{binderDeliveryId}";
        if (binderDeliveryId === undefined || binderDeliveryId === null)
            throw new Error("The parameter 'binderDeliveryId' must be defined.");
        url_ = url_.replace("{binderDeliveryId}", encodeURIComponent("" + binderDeliveryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BinderDeliveryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BinderDeliveryDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BinderDeliveryDto>(null as any);
    }

    /**
     * Updates an existing Binder Delivery.
     * @param binderDeliveryId The ID of the Binder Delivery to be updated.
     * @param form The form containing information about the Binder Delivery.
     * @return Returns the updated Binder Delivery.
     */
    update(binderDeliveryId: string, form: BinderDeliveryForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BinderDeliveries/{binderDeliveryId}";
        if (binderDeliveryId === undefined || binderDeliveryId === null)
            throw new Error("The parameter 'binderDeliveryId' must be defined.");
        url_ = url_.replace("{binderDeliveryId}", encodeURIComponent("" + binderDeliveryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes an existing Binder Delivery.
     * @param binderDeliveryId The ID of the Binder Delivery to be deleted.
     * @return Returns NoContent if the deletion is successful.
     */
    delete(binderDeliveryId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BinderDeliveries/{binderDeliveryId}";
        if (binderDeliveryId === undefined || binderDeliveryId === null)
            throw new Error("The parameter 'binderDeliveryId' must be defined.");
        url_ = url_.replace("{binderDeliveryId}", encodeURIComponent("" + binderDeliveryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param supplier (optional) 
     * @param brand (optional) 
     * @param deliveryDateFrom (optional) 
     * @param deliveryDateTo (optional) 
     */
    searchBinderDeliveries(projectId: string, page?: number | undefined, pageSize?: number | null | undefined, supplier?: string | null | undefined, brand?: string | null | undefined, deliveryDateFrom?: string | null | undefined, deliveryDateTo?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfBinderDeliveryDto> {
        let url_ = this.baseUrl + "/api/BinderDeliveries/project/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (supplier !== undefined && supplier !== null)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (brand !== undefined && brand !== null)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (deliveryDateFrom !== undefined && deliveryDateFrom !== null)
            url_ += "deliveryDateFrom=" + encodeURIComponent("" + deliveryDateFrom) + "&";
        if (deliveryDateTo !== undefined && deliveryDateTo !== null)
            url_ += "deliveryDateTo=" + encodeURIComponent("" + deliveryDateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBinderDeliveries(_response);
        });
    }

    protected processSearchBinderDeliveries(response: AxiosResponse): Promise<PagedListOfBinderDeliveryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfBinderDeliveryDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfBinderDeliveryDto>(null as any);
    }

    getAllForProject(projectId: string, cancelToken?: CancelToken): Promise<BinderDeliveryDto[]> {
        let url_ = this.baseUrl + "/api/BinderDeliveries/project/{projectId}/all";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllForProject(_response);
        });
    }

    protected processGetAllForProject(response: AxiosResponse): Promise<BinderDeliveryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BinderDeliveryDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BinderDeliveryDto[]>(null as any);
    }

    /**
     * Creates a new Binder Delivery.
     * @param projectId The ID of the project for which the Binder Delivery is being created.
     * @param form The form containing information about the Binder Delivery.
     * @return Returns the ID of the newly created Binder Delivery.
     */
    create(projectId: string, form: BinderDeliveryForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/BinderDeliveries/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class BinderCostRecordsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    get(binderCostRecordId: string, cancelToken?: CancelToken): Promise<BinderCostRecordDto> {
        let url_ = this.baseUrl + "/api/BinderCostRecords/{binderCostRecordId}";
        if (binderCostRecordId === undefined || binderCostRecordId === null)
            throw new Error("The parameter 'binderCostRecordId' must be defined.");
        url_ = url_.replace("{binderCostRecordId}", encodeURIComponent("" + binderCostRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BinderCostRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BinderCostRecordDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BinderCostRecordDto>(null as any);
    }

    /**
     * Updates an existing Binder Cost Record.
     * @param binderCostRecordId The ID of the Binder Cost Record to be updated.
     * @param form The form containing information about the Binder Cost Record.
     * @return Returns the updated Binder Cost Record.
     */
    update(binderCostRecordId: string, form: BinderCostRecordForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BinderCostRecords/{binderCostRecordId}";
        if (binderCostRecordId === undefined || binderCostRecordId === null)
            throw new Error("The parameter 'binderCostRecordId' must be defined.");
        url_ = url_.replace("{binderCostRecordId}", encodeURIComponent("" + binderCostRecordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes an existing Binder Cost Record.
     * @param binderCostRecordId The ID of the Binder Cost Record to be deleted.
     * @return Returns NoContent if the deletion is successful.
     */
    delete(binderCostRecordId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BinderCostRecords/{binderCostRecordId}";
        if (binderCostRecordId === undefined || binderCostRecordId === null)
            throw new Error("The parameter 'binderCostRecordId' must be defined.");
        url_ = url_.replace("{binderCostRecordId}", encodeURIComponent("" + binderCostRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param brand (optional) 
     * @param supplier (optional) 
     * @param purchaseDateFrom (optional) 
     * @param purchaseDateTo (optional) 
     * @param minPricePerTonne (optional) 
     * @param maxPricePerTonne (optional) 
     */
    searchBinderCostRecords(projectId: string, page?: number | undefined, pageSize?: number | null | undefined, brand?: string | null | undefined, supplier?: string | null | undefined, purchaseDateFrom?: string | null | undefined, purchaseDateTo?: string | null | undefined, minPricePerTonne?: number | null | undefined, maxPricePerTonne?: number | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfBinderCostRecordDto> {
        let url_ = this.baseUrl + "/api/BinderCostRecords/project/{projectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (brand !== undefined && brand !== null)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (supplier !== undefined && supplier !== null)
            url_ += "supplier=" + encodeURIComponent("" + supplier) + "&";
        if (purchaseDateFrom !== undefined && purchaseDateFrom !== null)
            url_ += "purchaseDateFrom=" + encodeURIComponent("" + purchaseDateFrom) + "&";
        if (purchaseDateTo !== undefined && purchaseDateTo !== null)
            url_ += "purchaseDateTo=" + encodeURIComponent("" + purchaseDateTo) + "&";
        if (minPricePerTonne !== undefined && minPricePerTonne !== null)
            url_ += "minPricePerTonne=" + encodeURIComponent("" + minPricePerTonne) + "&";
        if (maxPricePerTonne !== undefined && maxPricePerTonne !== null)
            url_ += "maxPricePerTonne=" + encodeURIComponent("" + maxPricePerTonne) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBinderCostRecords(_response);
        });
    }

    protected processSearchBinderCostRecords(response: AxiosResponse): Promise<PagedListOfBinderCostRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfBinderCostRecordDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfBinderCostRecordDto>(null as any);
    }

    /**
     * Creates a new Binder Cost Record.
     * @param projectId The ID of the project for which the Binder Cost Record is being created.
     * @param form The form containing information about the Binder Cost Record.
     * @return Returns the ID of the newly created Binder Cost Record.
     */
    create(projectId: string, form: BinderCostRecordForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/BinderCostRecords/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class BinderSuppliersService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    get(binderSupplierId: string, cancelToken?: CancelToken): Promise<BinderSupplierDto> {
        let url_ = this.baseUrl + "/api/BinderSuppliers/{binderSupplierId}";
        if (binderSupplierId === undefined || binderSupplierId === null)
            throw new Error("The parameter 'binderSupplierId' must be defined.");
        url_ = url_.replace("{binderSupplierId}", encodeURIComponent("" + binderSupplierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BinderSupplierDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BinderSupplierDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BinderSupplierDto>(null as any);
    }

    /**
     * Updates an existing Binder Supplier.
     * @param binderSupplierId The ID of the Binder Supplier to be updated.
     * @param form The form containing information about the Binder Supplier.
     * @return Returns the updated Binder Supplier.
     */
    update(binderSupplierId: string, form: BinderSupplierForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BinderSuppliers/{binderSupplierId}";
        if (binderSupplierId === undefined || binderSupplierId === null)
            throw new Error("The parameter 'binderSupplierId' must be defined.");
        url_ = url_.replace("{binderSupplierId}", encodeURIComponent("" + binderSupplierId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes an existing Binder Supplier.
     * @param binderSupplierId The ID of the Binder Supplier to be deleted.
     * @return Returns NoContent if the deletion is successful.
     */
    delete(binderSupplierId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BinderSuppliers/{binderSupplierId}";
        if (binderSupplierId === undefined || binderSupplierId === null)
            throw new Error("The parameter 'binderSupplierId' must be defined.");
        url_ = url_.replace("{binderSupplierId}", encodeURIComponent("" + binderSupplierId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getByProject(projectId: string, cancelToken?: CancelToken): Promise<BinderSupplierDto[]> {
        let url_ = this.baseUrl + "/api/BinderSuppliers/project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByProject(_response);
        });
    }

    protected processGetByProject(response: AxiosResponse): Promise<BinderSupplierDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BinderSupplierDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BinderSupplierDto[]>(null as any);
    }

    /**
     * Creates a new Binder Supplier.
     * @param projectId The ID of the project for which the Binder Supplier is being created.
     * @param form The form containing information about the Binder Supplier.
     * @return Returns the ID of the newly created Binder Supplier.
     */
    create(projectId: string, form: BinderSupplierForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/BinderSuppliers/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MineModelsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    getWithoutRheology(mineModelId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<MineModelDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWithoutRheology(_response);
        });
    }

    protected processGetWithoutRheology(response: AxiosResponse): Promise<MineModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('MineModelDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MineModelDto>(null as any);
    }

    getRheologyDataSet(mineModelId: string, rheologyDataSetId: string, cancelToken?: CancelToken): Promise<RheologyDataDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/rheologyDataSet/{rheologyDataSetId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (rheologyDataSetId === undefined || rheologyDataSetId === null)
            throw new Error("The parameter 'rheologyDataSetId' must be defined.");
        url_ = url_.replace("{rheologyDataSetId}", encodeURIComponent("" + rheologyDataSetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRheologyDataSet(_response);
        });
    }

    protected processGetRheologyDataSet(response: AxiosResponse): Promise<RheologyDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('RheologyDataDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RheologyDataDto>(null as any);
    }

    getRheologyDataByListOfIds(mineModelId: string, dto: RheologyDataAbstractsRequestDto, cancelToken?: CancelToken): Promise<RheologyDataDto[]> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/rheologydatalist";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRheologyDataByListOfIds(_response);
        });
    }

    protected processGetRheologyDataByListOfIds(response: AxiosResponse): Promise<RheologyDataDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('RheologyDataDto[]', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RheologyDataDto[]>(null as any);
    }

    getWithRheologyList(mineModelId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<MineModelDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/fullrheology?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWithRheologyList(_response);
        });
    }

    protected processGetWithRheologyList(response: AxiosResponse): Promise<MineModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('MineModelDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MineModelDto>(null as any);
    }

    getSummary(mineModelId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<MineModelSummaryDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/summary?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSummary(_response);
        });
    }

    protected processGetSummary(response: AxiosResponse): Promise<MineModelSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('MineModelSummaryDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MineModelSummaryDto>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param name (optional) 
     */
    searchInspectionPoint(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, name?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfInspectionPointDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/inspectionPoint?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInspectionPoint(_response);
        });
    }

    protected processSearchInspectionPoint(response: AxiosResponse): Promise<PagedListOfInspectionPointDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfInspectionPointDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfInspectionPointDto>(null as any);
    }

    getInspectionPointsByMineModelId(mineModelId: string, cancelToken?: CancelToken): Promise<InspectionPointDto[]> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/inspectionPointsByMineModel";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInspectionPointsByMineModelId(_response);
        });
    }

    protected processGetInspectionPointsByMineModelId(response: AxiosResponse): Promise<InspectionPointDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('InspectionPointDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionPointDto[]>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param inspectionPoint (optional) 
     */
    searchWearData(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, inspectionPoint?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfWearDataDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/weardata?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (inspectionPoint !== undefined && inspectionPoint !== null)
            url_ += "inspectionPoint=" + encodeURIComponent("" + inspectionPoint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchWearData(_response);
        });
    }

    protected processSearchWearData(response: AxiosResponse): Promise<PagedListOfWearDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfWearDataDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfWearDataDto>(null as any);
    }

    /**
     * Add Wear data to a mine model.
     * @param mineModelId The ID of the mine model to which the wear data is being added.
     * @param form The form containing the wear data to be added.
     * @return An ActionResult with the WearDataId of the added wear data.
     */
    addWearData(mineModelId: string, form: WearDataForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/weardata";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddWearData(_response);
        });
    }

    protected processAddWearData(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getInspectionPoint(mineModelId: string, inspectionPointId: string, cancelToken?: CancelToken): Promise<InspectionPointDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/inspectionPoint/{inspectionPointId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (inspectionPointId === undefined || inspectionPointId === null)
            throw new Error("The parameter 'inspectionPointId' must be defined.");
        url_ = url_.replace("{inspectionPointId}", encodeURIComponent("" + inspectionPointId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInspectionPoint(_response);
        });
    }

    protected processGetInspectionPoint(response: AxiosResponse): Promise<InspectionPointDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('InspectionPointDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InspectionPointDto>(null as any);
    }

    /**
     * Retrieve a single wear data object based on minemodel and wear data entity Id
     * @return WearDataDro
     */
    getWearData(mineModelId: string, wearDataId: string, cancelToken?: CancelToken): Promise<WearDataDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/wearData/{wearDataId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (wearDataId === undefined || wearDataId === null)
            throw new Error("The parameter 'wearDataId' must be defined.");
        url_ = url_.replace("{wearDataId}", encodeURIComponent("" + wearDataId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWearData(_response);
        });
    }

    protected processGetWearData(response: AxiosResponse): Promise<WearDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('WearDataDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WearDataDto>(null as any);
    }

    /**
     * Add Reticulation data to mine
     */
    create(mineModelId: string, reticulationData: ReticulationDataImportDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reticulationData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Reticulation data for mine
     * @param scenarioId (optional) 
     * @param force (optional) 
     */
    update(mineModelId: string, reticulationData: ReticulationDataImportDto, scenarioId?: string | null | undefined, force?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (force === null)
            throw new Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reticulationData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportReticulationData(mineModelId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<ReticulationDataImportDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportReticulationData(_response);
        });
    }

    protected processExportReticulationData(response: AxiosResponse): Promise<ReticulationDataImportDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ReticulationDataImportDto', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReticulationDataImportDto>(null as any);
    }

    exportReticulationDataDuf(mineModelId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/duf?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportReticulationDataDuf(_response);
        });
    }

    protected processExportReticulationDataDuf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Package a stope's pour solids (triangulated client-side by the stope fill view, in metric
    mine-grid coordinates) into a Deswik DUF, one Polyface per pour with the pour's details
    attached as Deswik attributes.
     */
    exportPourShapesDuf(mineModelId: string, stopeId: string, exportData: PourShapesExportDto, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/stopes/{stopeId}/pourshapes/duf";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportData);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPourShapesDuf(_response);
        });
    }

    protected processExportPourShapesDuf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportReticulationNodesCsv(mineModelId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/nodes/csv?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportReticulationNodesCsv(_response);
        });
    }

    protected processExportReticulationNodesCsv(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    bulkUpdateNodesFromCsv(mineModelId: string, scenarioId?: string | null | undefined, file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/nodes/csv?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateNodesFromCsv(_response);
        });
    }

    protected processBulkUpdateNodesFromCsv(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Add spools. Connecting two nodes is one spool; imports and bulk tools send many. A spool already
    joining the same two nodes is replaced, keeping its id.
     * @param scenarioId (optional) 
     */
    addSpools(mineModelId: string, spools: SpoolImportDto[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/spools?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(spools);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSpools(_response);
        });
    }

    protected processAddSpools(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Remove spools, by their own ids and/or by the node pairs they join. One request, one save - the
    reticulation document is one per mine, so a per-spool call would race itself.
     * @param scenarioId (optional) 
     */
    removeSpools(mineModelId: string, form: RemoveSpoolsForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/spools?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSpools(_response);
        });
    }

    protected processRemoveSpools(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Patch spools in place: pipe, flow direction, flow-loop length, name, service dates, status and Other
    are all edge properties. Every field except the id is optional and an omitted one is left alone;
    see SpoolUpdateForm for how a name or date is cleared.
     * @param scenarioId (optional) 
     */
    bulkUpdateSpools(mineModelId: string, spools: SpoolUpdateForm[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/spools/bulk?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(spools);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateSpools(_response);
        });
    }

    protected processBulkUpdateSpools(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Set every spool in the master or scenario document Active or Inactive from its installed and removed
    dates as of AsOf. Recipes whose route a flipped spool
    was on, or now opens, are marked stale.
     * @param scenarioId (optional) 
     */
    applySpoolStatusFromDates(mineModelId: string, form: ApplySpoolStatusFromDatesForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<ApplySpoolStatusFromDatesResultDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/spools/status-from-dates?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplySpoolStatusFromDates(_response);
        });
    }

    protected processApplySpoolStatusFromDates(response: AxiosResponse): Promise<ApplySpoolStatusFromDatesResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ApplySpoolStatusFromDatesResultDto', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplySpoolStatusFromDatesResultDto>(null as any);
    }

    exportRheologyData(mineModelId: string, rheologyDataSetId?: string | null | undefined, cancelToken?: CancelToken): Promise<RheologyDataDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/rheologyData?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (rheologyDataSetId !== undefined && rheologyDataSetId !== null)
            url_ += "rheologyDataSetId=" + encodeURIComponent("" + rheologyDataSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportRheologyData(_response);
        });
    }

    protected processExportRheologyData(response: AxiosResponse): Promise<RheologyDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('RheologyDataDto', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RheologyDataDto>(null as any);
    }

    /**
     * Add Rheology data to mine.  Reticulation must be uploaded before calling this method
     */
    createRheologyData(mineModelId: string, rheologyData: RheologyDataForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/rheologyData";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rheologyData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRheologyData(_response);
        });
    }

    protected processCreateRheologyData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the Rheology data for mine
     * @param rheologyDataSetId (optional) 
     */
    updateRheology(mineModelId: string, rheologyData: RheologyDataForm, rheologyDataSetId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/rheologyData?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (rheologyDataSetId !== undefined && rheologyDataSetId !== null)
            url_ += "rheologyDataSetId=" + encodeURIComponent("" + rheologyDataSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rheologyData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRheology(_response);
        });
    }

    protected processUpdateRheology(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Split the spool between two connected nodes with a new node. One command, so the whole insert is a
    single load and save of the per-mine reticulation document.
     * @param scenarioId (optional) 
     */
    addNodeBetweenNodes(mineModelId: string, nodeForms: AddNodeBetweenNodesForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/addnodebetweennodes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodeForms);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNodeBetweenNodes(_response);
        });
    }

    protected processAddNodeBetweenNodes(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Add dxf node data for mine.  You must first upload Reticulation data
     * @param scenarioId (optional) 
     */
    dxfImport(mineModelId: string, nodes: DxfImportDataForm[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/dxfimport?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodes);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDxfImport(_response);
        });
    }

    protected processDxfImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Add dxf node data for mine.  You must first upload Reticulation data
     * @param scenarioId (optional) 
     */
    dufImport(mineModelId: string, nodes: DufImportDataForm[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/dufimport?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodes);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDufImport(_response);
        });
    }

    protected processDufImport(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Add Node meta data for mine.  You must first upload Reticulation data
     * @param scenarioId (optional) 
     */
    addNode(mineModelId: string, nodes: ModelNodeDataForm[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/node?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodes);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNode(_response);
        });
    }

    protected processAddNode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Update Node meta data for mine.  You must first upload Reticulation data
     * @param scenarioId (optional) 
     */
    updateNode(mineModelId: string, node: UpdateModelNodeDataForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/node?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(node);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateNode(_response);
        });
    }

    protected processUpdateNode(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Remove Node meta data for mine
     * @param forceDelete (optional) 
     * @param scenarioId (optional) 
     */
    removeNode(mineModelId: string, nodeIds: string[], forceDelete?: boolean | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/node?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (forceDelete === null)
            throw new Error("The parameter 'forceDelete' cannot be null.");
        else if (forceDelete !== undefined)
            url_ += "forceDelete=" + encodeURIComponent("" + forceDelete) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodeIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveNode(_response);
        });
    }

    protected processRemoveNode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Bulk update multiple nodes' meta data for mine. You must first upload Reticulation data.
    This endpoint is optimized for updating many nodes in a single request.
     * @param scenarioId (optional) 
     */
    bulkUpdateNodes(mineModelId: string, nodes: UpdateModelNodeDataForm[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/nodes/bulk?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(nodes);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateNodes(_response);
        });
    }

    protected processBulkUpdateNodes(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Reset the cumulative throughput (volume and dry tonnes) of the selected spools.
     * @param scenarioId (optional) 
     */
    resetSpoolThroughput(mineModelId: string, command: ResetSpoolThroughputCommand, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/resetspoolthroughput?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetSpoolThroughput(_response);
        });
    }

    protected processResetSpoolThroughput(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Update Stope meta data for mine.  You must first upload Reticulation data
     * @param scenarioId (optional) 
     */
    updateStopes(mineModelId: string, stopes: UpdateStopeDataForm[], scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/stopes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stopes);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStopes(_response);
        });
    }

    protected processUpdateStopes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addDocument(mineModelId: string, stopeId: string, scenarioId?: string | null | undefined, files?: FileParameter[] | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/stopes/{stopeId}/adddocument?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDocument(_response);
        });
    }

    protected processAddDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    removeDocument(mineModelId: string, stopeId: string, fileName?: string | null | undefined, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/stopes/{stopeId}/removedocument?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveDocument(_response);
        });
    }

    protected processRemoveDocument(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Stope meta data for mine.  You must first upload Reticulation data
     * @param scenarioId (optional) 
     */
    addStope(mineModelId: string, nodeId: string, form: StopeDataForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/{nodeId}/stopes?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddStope(_response);
        });
    }

    protected processAddStope(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Add an inspection point to a spool in a mine model
     * @param mineModelId The ID of the mine model to add the inspection point to
     * @param spoolId The ID of the spool the inspection point measures
     * @param name (optional) The name of the inspection point
     * @return Returns the ID of the added inspection point
     */
    addInspectionPoint(mineModelId: string, spoolId: string, name?: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/spool/{spoolId}/inspectionpoint?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (spoolId === undefined || spoolId === null)
            throw new Error("The parameter 'spoolId' must be defined.");
        url_ = url_.replace("{spoolId}", encodeURIComponent("" + spoolId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddInspectionPoint(_response);
        });
    }

    protected processAddInspectionPoint(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Anchor an existing inspection point to a spool. Used for legacy points that were anchored to a node
    and could not be relinked automatically, and for moving a point onto a different spool.
     */
    assignInspectionPointSpool(mineModelId: string, inspectionPointId: string, spoolId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/inspectionpoint/{inspectionPointId}/spool/{spoolId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (inspectionPointId === undefined || inspectionPointId === null)
            throw new Error("The parameter 'inspectionPointId' must be defined.");
        url_ = url_.replace("{inspectionPointId}", encodeURIComponent("" + inspectionPointId));
        if (spoolId === undefined || spoolId === null)
            throw new Error("The parameter 'spoolId' must be defined.");
        url_ = url_.replace("{spoolId}", encodeURIComponent("" + spoolId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignInspectionPointSpool(_response);
        });
    }

    protected processAssignInspectionPointSpool(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the wear data for a specific mine model.
     * @param mineModelId The unique identifier of the mine model.
     * @param wearDataId The unique identifier of the wear data.
     * @param form The form containing the updated wear data information.
     * @return An ActionResult containing the updated WearDataDto.
     */
    updateWearData(mineModelId: string, wearDataId: string, form: UpdateWearDataForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/weardata/{wearDataId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (wearDataId === undefined || wearDataId === null)
            throw new Error("The parameter 'wearDataId' must be defined.");
        url_ = url_.replace("{wearDataId}", encodeURIComponent("" + wearDataId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWearData(_response);
        });
    }

    protected processUpdateWearData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update Stope meta data for mine.  You must first upload Reticulation data
     * @param scenarioId (optional) 
     */
    removeStope(mineModelId: string, stopeId: string, nodeId: string, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/stopes/{stopeId}/{nodeId}?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (nodeId === undefined || nodeId === null)
            throw new Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveStope(_response);
        });
    }

    protected processRemoveStope(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove multiple stopes in a single request. Skips and reports stopes that cannot be removed (e.g. pours planned).
     * @param scenarioId (optional) 
     */
    removeStopes(mineModelId: string, form: RemoveStopesForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<RemoveStopesResultDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/reticulationdata/stopes/remove-batch?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveStopes(_response);
        });
    }

    protected processRemoveStopes(response: AxiosResponse): Promise<RemoveStopesResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('RemoveStopesResultDto', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RemoveStopesResultDto>(null as any);
    }

    /**
     * Remove a set of Rheology data for a mine
     * @param rheologyDataSetId (optional) 
     */
    removeRheologyDataSet(mineModelId: string, rheologyDataSetId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/removerheologydata?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (rheologyDataSetId !== undefined && rheologyDataSetId !== null)
            url_ += "rheologyDataSetId=" + encodeURIComponent("" + rheologyDataSetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRheologyDataSet(_response);
        });
    }

    protected processRemoveRheologyDataSet(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deactivate (archive) or reactivate a set of Rheology data for a mine. Deactivated data
    sets are hidden from new-recipe selection but are kept so existing pours, recipes and
    QAQC data that reference them keep working.
     */
    setRheologyDataDeactivated(mineModelId: string, command: SetRheologyDataDeactivatedCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/rheologyData/setDeactivated";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetRheologyDataDeactivated(_response);
        });
    }

    protected processSetRheologyDataDeactivated(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the geometry file of a specific stope in a mine model
     * @param mineModelId The ID of the mine model
     * @param stopeId The ID of the stope
     * @param entityGuid (optional) Optional GUID of a specific entity to extract from a DUF file
     * @param scenarioId (optional) Optional scenario ID
     * @param file (optional) 
     * @return An ActionResult indicating the result of the update operation
     */
    updateStopeGeometryFile(mineModelId: string, stopeId: string, entityGuid?: string | null | undefined, scenarioId?: string | null | undefined, file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/stopegeometry/{stopeId}?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (stopeId === undefined || stopeId === null)
            throw new Error("The parameter 'stopeId' must be defined.");
        url_ = url_.replace("{stopeId}", encodeURIComponent("" + stopeId));
        if (entityGuid !== undefined && entityGuid !== null)
            url_ += "entityGuid=" + encodeURIComponent("" + entityGuid) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStopeGeometryFile(_response);
        });
    }

    protected processUpdateStopeGeometryFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Import (or replace) the single mine-wide tunnel profile solid. Accepts .obj, .dxf or .duf.
     * @param mineModelId The ID of the mine model
     * @param entityGuid (optional) Optional GUID of a specific solid to extract from a DUF file
     * @param file (optional) 
     * @return The persisted tunnel profile
     */
    updateTunnelProfile(mineModelId: string, entityGuid?: string | null | undefined, file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<TunnelProfileDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/tunnelprofile?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (entityGuid !== undefined && entityGuid !== null)
            url_ += "entityGuid=" + encodeURIComponent("" + entityGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTunnelProfile(_response);
        });
    }

    protected processUpdateTunnelProfile(response: AxiosResponse): Promise<TunnelProfileDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('TunnelProfileDto', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TunnelProfileDto>(null as any);
    }

    /**
     * Remove the mine-wide tunnel profile.
     * @param mineModelId The ID of the mine model
     */
    removeTunnelProfile(mineModelId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/tunnelprofile";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveTunnelProfile(_response);
        });
    }

    protected processRemoveTunnelProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Update the show/hide and transparency state of the mine-wide tunnel profile.
     * @param mineModelId The ID of the mine model
     * @param form The visibility and opacity to persist
     */
    updateTunnelProfileSettings(mineModelId: string, form: TunnelProfileSettingsForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/tunnelprofile/settings";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTunnelProfileSettings(_response);
        });
    }

    protected processUpdateTunnelProfileSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove an inspection point from a mine model.
     * @param mineModelId The ID of the mine model from which the inspection point should be removed.
     * @param inspectionPointId (optional) The ID of the inspection point to be removed.
     * @return A task representing the asynchronous operation.
     */
    removeInspectionPoint(mineModelId: string, inspectionPointId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/removeinspectionpoint?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (inspectionPointId !== undefined && inspectionPointId !== null)
            url_ += "inspectionPointId=" + encodeURIComponent("" + inspectionPointId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveInspectionPoint(_response);
        });
    }

    protected processRemoveInspectionPoint(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remove wear data for a specific mine model.
     * @param mineModelId The unique identifier of the mine model.
     * @param wearDataId (optional) The identifier of the wear data to be removed.
     * @return Returns an HTTP 200 OK response if the wear data is successfully removed.
     */
    removeWearData(mineModelId: string, wearDataId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/removeweardata?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (wearDataId !== undefined && wearDataId !== null)
            url_ += "wearDataId=" + encodeURIComponent("" + wearDataId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveWearData(_response);
        });
    }

    protected processRemoveWearData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    searchNodeVolumeRecord(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfNodeVolumeRecordDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/nodevolumerecord?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchNodeVolumeRecord(_response);
        });
    }

    protected processSearchNodeVolumeRecord(response: AxiosResponse): Promise<PagedListOfNodeVolumeRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfNodeVolumeRecordDto', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfNodeVolumeRecordDto>(null as any);
    }

    /**
     * Throughput records that carry a series for the given spool, newest first.
     * @param startDate (optional) 
     * @param endDate (optional) 
     */
    getNodeVolumeRecordsBySpoolId(mineModelId: string, spoolId: string, startDate?: string | null | undefined, endDate?: string | null | undefined, cancelToken?: CancelToken): Promise<NodeVolumeRecordDto[]> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/nodevolumerecord/spool/{spoolId}?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (spoolId === undefined || spoolId === null)
            throw new Error("The parameter 'spoolId' must be defined.");
        url_ = url_.replace("{spoolId}", encodeURIComponent("" + spoolId));
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNodeVolumeRecordsBySpoolId(_response);
        });
    }

    protected processGetNodeVolumeRecordsBySpoolId(response: AxiosResponse): Promise<NodeVolumeRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('NodeVolumeRecordDto[]', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NodeVolumeRecordDto[]>(null as any);
    }

    importDUF(mineModelId: string, file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/importduf";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportDUF(_response);
        });
    }

    protected processImportDUF(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Bulk create/update multiple rheology data sets for a mine
     */
    bulkRheologyData(mineModelId: string, bulkRheologyData: BulkRheologyDataCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/bulkRheologyData";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bulkRheologyData);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkRheologyData(_response);
        });
    }

    protected processBulkRheologyData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    bulkImportStopes(mineModelId: string, form: BulkImportStopesForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<BulkImportStopesResultDto> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/bulksolids/import?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkImportStopes(_response);
        });
    }

    protected processBulkImportStopes(response: AxiosResponse): Promise<BulkImportStopesResultDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BulkImportStopesResultDto', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BulkImportStopesResultDto>(null as any);
    }

    bulkUpdateStopeGeometry(mineModelId: string, form: BulkUpdateStopeGeometryForm, scenarioId?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/bulksolids/geometry?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBulkUpdateStopeGeometry(_response);
        });
    }

    protected processBulkUpdateStopeGeometry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Parse a DUF file for bulk import - extracts all geometry entities with OBJ data and bounding boxes
     * @param file (optional) 
     */
    parseDufForBulkImport(mineModelId: string, file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<DufBulkImportParseResponse> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/bulksolids/parseduf";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processParseDufForBulkImport(_response);
        });
    }

    protected processParseDufForBulkImport(response: AxiosResponse): Promise<DufBulkImportParseResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('DufBulkImportParseResponse', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DufBulkImportParseResponse>(null as any);
    }

    getEntityGroups(mineModelId: string, cancelToken?: CancelToken): Promise<ModelEntityGroupDto[]> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/entitygroups";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntityGroups(_response);
        });
    }

    protected processGetEntityGroups(response: AxiosResponse): Promise<ModelEntityGroupDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ModelEntityGroupDto[]', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelEntityGroupDto[]>(null as any);
    }

    createEntityGroup(mineModelId: string, form: CreateModelEntityGroupForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/entitygroups";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEntityGroup(_response);
        });
    }

    protected processCreateEntityGroup(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    updateEntityGroup(mineModelId: string, groupId: string, form: UpdateModelEntityGroupForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/entitygroups/{groupId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEntityGroup(_response);
        });
    }

    protected processUpdateEntityGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteEntityGroup(mineModelId: string, groupId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/MineModels/{mineModelId}/entitygroups/{groupId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEntityGroup(_response);
        });
    }

    protected processDeleteEntityGroup(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ScenariosService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    list(mineModelId: string, cancelToken?: CancelToken): Promise<ProjectScenarioDto[]> {
        let url_ = this.baseUrl + "/api/mine-models/{mineModelId}/scenarios";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ProjectScenarioDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ProjectScenarioDto[]', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectScenarioDto[]>(null as any);
    }

    clone(mineModelId: string, form: CloneScenarioForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/mine-models/{mineModelId}/scenarios/clone";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClone(_response);
        });
    }

    protected processClone(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    delete(mineModelId: string, scenarioId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/mine-models/{mineModelId}/scenarios/{scenarioId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserNotificationsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * Retrieves all user notifications.
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param read (optional) A boolean value indicating if the notification has been read or not.
     * @return A paged list of UserNotificationDto objects.
     * @deprecated
     */
    listAllUserNotifications(page?: number | undefined, pageSize?: number | null | undefined, read?: boolean | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfUserNotificationDto> {
        let url_ = this.baseUrl + "/api/UserNotifications?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (read !== undefined && read !== null)
            url_ += "read=" + encodeURIComponent("" + read) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAllUserNotifications(_response);
        });
    }

    protected processListAllUserNotifications(response: AxiosResponse): Promise<PagedListOfUserNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfUserNotificationDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A paged list of UserNotificationDto objects.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfUserNotificationDto>(null as any);
    }

    /**
     * Retrieves the userNotifications for the current user.
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param read (optional) A boolean value indicating if the notification has been read or not.
     * @return A paged list of userNotification DTOs.
     */
    myUserNotifications(page?: number | undefined, pageSize?: number | null | undefined, read?: boolean | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfUserNotificationDto> {
        let url_ = this.baseUrl + "/api/UserNotifications/myUserNotifications?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (read !== undefined && read !== null)
            url_ += "read=" + encodeURIComponent("" + read) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMyUserNotifications(_response);
        });
    }

    protected processMyUserNotifications(response: AxiosResponse): Promise<PagedListOfUserNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfUserNotificationDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfUserNotificationDto>(null as any);
    }

    /**
     * Marks user notifications as read.
     * @param markUserNotificationsAsReadCommand The command to mark user notifications as read.
     * @return An HTTP response indicating the result of the operation.
     */
    updateUserNotificationAsRead(markUserNotificationsAsReadCommand: MarkUserNotificationsAsReadCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/UserNotifications/read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(markUserNotificationsAsReadCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserNotificationAsRead(_response);
        });
    }

    protected processUpdateUserNotificationAsRead(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * Creates a notification for all users or if a project ID is provided a specific project
     * @param form The notification form containing the title and body of the notification.
     * @return Returns an HTTP OK response if the notifications are created successfully.
     */
    createNotifications(form: NotificationForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateNotifications(_response);
        });
    }

    protected processCreateNotifications(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves all notifications.
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @return A paged list of notification DTOs.
     */
    listAllNotifications(page?: number | undefined, pageSize?: number | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfNotificationDto> {
        let url_ = this.baseUrl + "/api/Notifications?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAllNotifications(_response);
        });
    }

    protected processListAllNotifications(response: AxiosResponse): Promise<PagedListOfNotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfNotificationDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A paged list of notification DTOs.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfNotificationDto>(null as any);
    }

    /**
     * Retrieves a specific notification by its ID.
     * @param notificationId The ID of the notification to retrieve.
     * @return Returns an HTTP OK response with the NotificationDto if the notification is found. Returns an HTTP NotFound response if the notification is not found.
     */
    getNotification(notificationId: string, cancelToken?: CancelToken): Promise<NotificationDto> {
        let url_ = this.baseUrl + "/api/Notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotification(_response);
        });
    }

    protected processGetNotification(response: AxiosResponse): Promise<NotificationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('NotificationDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NotificationDto>(null as any);
    }

    /**
     * Deletes a notification.
     * @param notificationId The ID of the notification to delete.
     * @return An IActionResult representing the result of the operation.
     */
    delete(notificationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Notifications/{notificationId}";
        if (notificationId === undefined || notificationId === null)
            throw new Error("The parameter 'notificationId' must be defined.");
        url_ = url_.replace("{notificationId}", encodeURIComponent("" + notificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class QaqcSamplesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    listByPour(pourId: string, cancelToken?: CancelToken): Promise<QaqcSampleDto[]> {
        let url_ = this.baseUrl + "/api/pours/{pourId}/qaqcSamples";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListByPour(_response);
        });
    }

    protected processListByPour(response: AxiosResponse): Promise<QaqcSampleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('QaqcSampleDto[]', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QaqcSampleDto[]>(null as any);
    }

    create(pourId: string, form: QaqcSampleForm, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/pours/{pourId}/qaqcSamples";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    get(qaqcSampleId: string, cancelToken?: CancelToken): Promise<QaqcSampleDto> {
        let url_ = this.baseUrl + "/api/QaqcSamples/{qaqcSampleId}";
        if (qaqcSampleId === undefined || qaqcSampleId === null)
            throw new Error("The parameter 'qaqcSampleId' must be defined.");
        url_ = url_.replace("{qaqcSampleId}", encodeURIComponent("" + qaqcSampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QaqcSampleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('QaqcSampleDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QaqcSampleDto>(null as any);
    }

    update(qaqcSampleId: string, form: QaqcSampleForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/QaqcSamples/{qaqcSampleId}";
        if (qaqcSampleId === undefined || qaqcSampleId === null)
            throw new Error("The parameter 'qaqcSampleId' must be defined.");
        url_ = url_.replace("{qaqcSampleId}", encodeURIComponent("" + qaqcSampleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(qaqcSampleId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/QaqcSamples/{qaqcSampleId}";
        if (qaqcSampleId === undefined || qaqcSampleId === null)
            throw new Error("The parameter 'qaqcSampleId' must be defined.");
        url_ = url_.replace("{qaqcSampleId}", encodeURIComponent("" + qaqcSampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BreakingTestsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * Retrieves a BreakingTestDto by its ID.
     * @param breakingTestId The ID of the Breaking Test to retrieve.
     * @return An ActionResult containing the BreakingTestDto if found, NotFound if not found, or Forbid if the user does not have the necessary permissions.
     */
    get(breakingTestId: string, cancelToken?: CancelToken): Promise<BreakingTestDto> {
        let url_ = this.baseUrl + "/api/BreakingTests/{breakingTestId}";
        if (breakingTestId === undefined || breakingTestId === null)
            throw new Error("The parameter 'breakingTestId' must be defined.");
        url_ = url_.replace("{breakingTestId}", encodeURIComponent("" + breakingTestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BreakingTestDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BreakingTestDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BreakingTestDto>(null as any);
    }

    /**
     * Retrieves the list of pour IDs for the QAQC user based on their authorization level.
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param pourReference (optional) 
     * @param mineModelId (optional) 
     * @param sortBy (optional) The field to sort by
     * @param sortDirection (optional) The direction to sort
     * @return An ActionResult containing a paged list of PourSummaryDto objects if found, NotFound if not found, or Forbid if the user does not have the necessary permissions.
     */
    listAllPoursForQAQCUser(page?: number | undefined, pageSize?: number | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, pourReference?: string | null | undefined, mineModelId?: string | null | undefined, sortBy?: string | null | undefined, sortDirection?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfPourSummaryDto> {
        let url_ = this.baseUrl + "/api/pours?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (pourReference !== undefined && pourReference !== null)
            url_ += "PourReference=" + encodeURIComponent("" + pourReference) + "&";
        if (mineModelId !== undefined && mineModelId !== null)
            url_ += "mineModelId=" + encodeURIComponent("" + mineModelId) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection !== undefined && sortDirection !== null)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAllPoursForQAQCUser(_response);
        });
    }

    protected processListAllPoursForQAQCUser(response: AxiosResponse): Promise<PagedListOfPourSummaryDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfPourSummaryDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("An ActionResult containing a paged list of PourSummaryDto objects if found, NotFound if not found, or Forbid if the user does not have the necessary permissions.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfPourSummaryDto>(null as any);
    }

    /**
     * Creates a new breaking test for a specified pour.
     * @param breakingScheduleId The identifier of the breaking schedule.
     * @param form The form containing breaking test details.
     * @return An ActionResult indicating the result of the operation.
     */
    create(breakingScheduleId: string, form: BreakingTestForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/breakingSchedule/{breakingScheduleId}/breakingTest";
        if (breakingScheduleId === undefined || breakingScheduleId === null)
            throw new Error("The parameter 'breakingScheduleId' must be defined.");
        url_ = url_.replace("{breakingScheduleId}", encodeURIComponent("" + breakingScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates a breaking test for a specified pour.
     * @param breakingTestId The identifier of the breaking test.
     * @param form The form containing breaking test details.
     * @return An ActionResult indicating the result of the operation.
     */
    update(breakingTestId: string, form: BreakingTestForm, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/breakingSchedule/breakingTest/{breakingTestId}";
        if (breakingTestId === undefined || breakingTestId === null)
            throw new Error("The parameter 'breakingTestId' must be defined.");
        url_ = url_.replace("{breakingTestId}", encodeURIComponent("" + breakingTestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HistoricBreakingTestService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    getImportBatches(mineModelId: string, cancelToken?: CancelToken): Promise<HistoricBreakingTestImportBatchDto[]> {
        let url_ = this.baseUrl + "/api/HistoricBreakingTest/import/{mineModelId}/batches";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportBatches(_response);
        });
    }

    protected processGetImportBatches(response: AxiosResponse): Promise<HistoricBreakingTestImportBatchDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('HistoricBreakingTestImportBatchDto[]', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HistoricBreakingTestImportBatchDto[]>(null as any);
    }

    importHistoricBreakingTests(mineModelId: string, importData: HistoricBreakingTestImportDto[], cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/HistoricBreakingTest/import/{mineModelId}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importData);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportHistoricBreakingTests(_response);
        });
    }

    protected processImportHistoricBreakingTests(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteHistoricBreakingTestImport(mineModelId: string, importedDateUtc?: string | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/HistoricBreakingTest/import/{mineModelId}?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (importedDateUtc !== undefined && importedDateUtc !== null)
            url_ += "importedDateUtc=" + encodeURIComponent("" + importedDateUtc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteHistoricBreakingTestImport(_response);
        });
    }

    protected processDeleteHistoricBreakingTestImport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BreakingSchedulesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * Retrieves a list of BreakingScheduleDto objects based on the provided filters.
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param entityId (optional) The entity ID to filter by.
     * @param pourId (optional) The pour ID to filter by.
     * @param mineModelId (optional) The mineModel ID to filter by MineModel / Project.
     * @param startDateUtc (optional) The start date to filter by.
     * @param endDateUtc (optional) The end date to filter by.
     * @return An ActionResult containing a list of BreakingScheduleDto objects if found, NotFound if not found, or Forbid if the user does not have the necessary permissions.
     */
    list(page?: number | undefined, pageSize?: number | null | undefined, entityId?: string | null | undefined, pourId?: string | null | undefined, mineModelId?: string | null | undefined, startDateUtc?: string | null | undefined, endDateUtc?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfBreakingScheduleDto> {
        let url_ = this.baseUrl + "/api/BreakingSchedules?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (pourId !== undefined && pourId !== null)
            url_ += "pourId=" + encodeURIComponent("" + pourId) + "&";
        if (mineModelId !== undefined && mineModelId !== null)
            url_ += "mineModelId=" + encodeURIComponent("" + mineModelId) + "&";
        if (startDateUtc !== undefined && startDateUtc !== null)
            url_ += "startDateUtc=" + encodeURIComponent("" + startDateUtc) + "&";
        if (endDateUtc !== undefined && endDateUtc !== null)
            url_ += "endDateUtc=" + encodeURIComponent("" + endDateUtc) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PagedListOfBreakingScheduleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfBreakingScheduleDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("An ActionResult containing a list of BreakingScheduleDto objects if found, NotFound if not found, or Forbid if the user does not have the necessary permissions.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfBreakingScheduleDto>(null as any);
    }

    /**
     * Retrieves a BreakingScheduleDto by its ID.
     * @param breakingScheduleId The ID of the Breaking Schedule to retrieve.
     * @return An ActionResult containing the BreakingScheduleDto if found, NotFound if not found, or Forbid if the user does not have the necessary permissions.
     */
    get(breakingScheduleId: string, cancelToken?: CancelToken): Promise<BreakingScheduleDto> {
        let url_ = this.baseUrl + "/api/BreakingSchedules/{breakingScheduleId}";
        if (breakingScheduleId === undefined || breakingScheduleId === null)
            throw new Error("The parameter 'breakingScheduleId' must be defined.");
        url_ = url_.replace("{breakingScheduleId}", encodeURIComponent("" + breakingScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<BreakingScheduleDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BreakingScheduleDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BreakingScheduleDto>(null as any);
    }

    /**
     * Updates a Breaking Schedule with the provided form data.
     * @param breakingScheduleId The ID of the Breaking Schedule to update.
     * @param sampleName (optional) 
     * @param slump (optional) 
     * @param dateCast (optional) 
     * @param numberOfCylinders (optional) 
     * @param vane (optional) 
     * @param slurryDensity (optional) 
     * @param inspectionInterval (optional) 
     * @param slumpPicture (optional) 
     * @return An ActionResult indicating the result of the update operation.
     */
    update(breakingScheduleId: string, sampleName?: string | undefined, slump?: number | undefined, dateCast?: string | undefined, numberOfCylinders?: number | undefined, vane?: number | null | undefined, slurryDensity?: number | null | undefined, inspectionInterval?: number[] | undefined, slumpPicture?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BreakingSchedules/{breakingScheduleId}?";
        if (breakingScheduleId === undefined || breakingScheduleId === null)
            throw new Error("The parameter 'breakingScheduleId' must be defined.");
        url_ = url_.replace("{breakingScheduleId}", encodeURIComponent("" + breakingScheduleId));
        if (sampleName === null)
            throw new Error("The parameter 'sampleName' cannot be null.");
        else if (sampleName !== undefined)
            url_ += "SampleName=" + encodeURIComponent("" + sampleName) + "&";
        if (slump === null)
            throw new Error("The parameter 'slump' cannot be null.");
        else if (slump !== undefined)
            url_ += "Slump=" + encodeURIComponent("" + slump) + "&";
        if (dateCast === null)
            throw new Error("The parameter 'dateCast' cannot be null.");
        else if (dateCast !== undefined)
            url_ += "DateCast=" + encodeURIComponent("" + dateCast) + "&";
        if (numberOfCylinders === null)
            throw new Error("The parameter 'numberOfCylinders' cannot be null.");
        else if (numberOfCylinders !== undefined)
            url_ += "NumberOfCylinders=" + encodeURIComponent("" + numberOfCylinders) + "&";
        if (vane !== undefined && vane !== null)
            url_ += "Vane=" + encodeURIComponent("" + vane) + "&";
        if (slurryDensity !== undefined && slurryDensity !== null)
            url_ += "SlurryDensity=" + encodeURIComponent("" + slurryDensity) + "&";
        if (inspectionInterval === null)
            throw new Error("The parameter 'inspectionInterval' cannot be null.");
        else if (inspectionInterval !== undefined)
            inspectionInterval && inspectionInterval.forEach(item => { url_ += "InspectionInterval=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (slumpPicture !== null && slumpPicture !== undefined)
            content_.append("SlumpPicture", slumpPicture.data, slumpPicture.fileName ? slumpPicture.fileName : "SlumpPicture");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(breakingScheduleId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/BreakingSchedules/{breakingScheduleId}";
        if (breakingScheduleId === undefined || breakingScheduleId === null)
            throw new Error("The parameter 'breakingScheduleId' must be defined.");
        url_ = url_.replace("{breakingScheduleId}", encodeURIComponent("" + breakingScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a new breaking schedule for a specified pour.
     * @param pourId The identifier of the pour for which the breaking schedule is created.
     * @param sampleName (optional) 
     * @param slump (optional) 
     * @param dateCast (optional) 
     * @param numberOfCylinders (optional) 
     * @param vane (optional) 
     * @param slurryDensity (optional) 
     * @param inspectionInterval (optional) 
     * @param slumpPicture (optional) 
     * @return An ActionResult indicating the result of the operation.
     */
    create(pourId: string, sampleName?: string | undefined, slump?: number | undefined, dateCast?: string | undefined, numberOfCylinders?: number | undefined, vane?: number | null | undefined, slurryDensity?: number | null | undefined, inspectionInterval?: number[] | undefined, slumpPicture?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/pours/{pourId}/breakingSchedule?";
        if (pourId === undefined || pourId === null)
            throw new Error("The parameter 'pourId' must be defined.");
        url_ = url_.replace("{pourId}", encodeURIComponent("" + pourId));
        if (sampleName === null)
            throw new Error("The parameter 'sampleName' cannot be null.");
        else if (sampleName !== undefined)
            url_ += "SampleName=" + encodeURIComponent("" + sampleName) + "&";
        if (slump === null)
            throw new Error("The parameter 'slump' cannot be null.");
        else if (slump !== undefined)
            url_ += "Slump=" + encodeURIComponent("" + slump) + "&";
        if (dateCast === null)
            throw new Error("The parameter 'dateCast' cannot be null.");
        else if (dateCast !== undefined)
            url_ += "DateCast=" + encodeURIComponent("" + dateCast) + "&";
        if (numberOfCylinders === null)
            throw new Error("The parameter 'numberOfCylinders' cannot be null.");
        else if (numberOfCylinders !== undefined)
            url_ += "NumberOfCylinders=" + encodeURIComponent("" + numberOfCylinders) + "&";
        if (vane !== undefined && vane !== null)
            url_ += "Vane=" + encodeURIComponent("" + vane) + "&";
        if (slurryDensity !== undefined && slurryDensity !== null)
            url_ += "SlurryDensity=" + encodeURIComponent("" + slurryDensity) + "&";
        if (inspectionInterval === null)
            throw new Error("The parameter 'inspectionInterval' cannot be null.");
        else if (inspectionInterval !== undefined)
            inspectionInterval && inspectionInterval.forEach(item => { url_ += "InspectionInterval=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (slumpPicture !== null && slumpPicture !== undefined)
            content_.append("SlumpPicture", slumpPicture.data, slumpPicture.fileName ? slumpPicture.fileName : "SlumpPicture");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return hydrateResponse('string', result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Retrieves the breaking schedules of a project for the given pours, so callers (e.g. the pour
    approval stage) can tell which pours already have QAQC sampling set up.
     * @param mineModelId The project the pours belong to.
     * @param pourIds (optional) The pours to look up.
     * @return The breaking schedules found for those pours (pours without one are simply absent).
     */
    listByPours(mineModelId: string, pourIds?: string[] | undefined, cancelToken?: CancelToken): Promise<BreakingScheduleDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/breakingSchedules/byPours?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (pourIds === null)
            throw new Error("The parameter 'pourIds' cannot be null.");
        else if (pourIds !== undefined)
            pourIds && pourIds.forEach(item => { url_ += "pourIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListByPours(_response);
        });
    }

    protected processListByPours(response: AxiosResponse): Promise<BreakingScheduleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BreakingScheduleDto[]', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("The breaking schedules found for those pours (pours without one are simply absent).", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BreakingScheduleDto[]>(null as any);
    }

    /**
     * Sets up QAQC sampling (a breaking schedule) for several pours of a project at once, e.g. from
    the pour approval stage. Pours that already have a breaking schedule are left as they are.
     * @param mineModelId The project the pours belong to.
     * @param form The test days and cylinder count per pour.
     * @return One result per pour saying which breaking schedule it now has and whether it was created by this call.
     */
    setupForPours(mineModelId: string, form: BreakingScheduleSetupForm, cancelToken?: CancelToken): Promise<BreakingScheduleSetupResultDto[]> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/breakingSchedules/setup";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(form);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupForPours(_response);
        });
    }

    protected processSetupForPours(response: AxiosResponse): Promise<BreakingScheduleSetupResultDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BreakingScheduleSetupResultDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BreakingScheduleSetupResultDto[]>(null as any);
    }

    move(breakingScheduleId: string, command: MoveBreakingScheduleCommand, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/BreakingSchedules/{breakingScheduleId}/move";
        if (breakingScheduleId === undefined || breakingScheduleId === null)
            throw new Error("The parameter 'breakingScheduleId' must be defined.");
        url_ = url_.replace("{breakingScheduleId}", encodeURIComponent("" + breakingScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Retrieves a list of BreakingTestDto by BreakingSchedule ID.
     * @param breakingScheduleId The ID of the associated Breaking Schedule for the Breaking Tests.
     * @return An ActionResult containing the list of BreakingTestDto if there are any associated, NotFound if not found, or Forbid if the user does not have the necessary permissions.
     */
    listByBreakingScheduleId(breakingScheduleId: string, cancelToken?: CancelToken): Promise<BreakingTestDto[]> {
        let url_ = this.baseUrl + "/api/BreakingSchedules/{breakingScheduleId}/getbreakingtests";
        if (breakingScheduleId === undefined || breakingScheduleId === null)
            throw new Error("The parameter 'breakingScheduleId' must be defined.");
        url_ = url_.replace("{breakingScheduleId}", encodeURIComponent("" + breakingScheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListByBreakingScheduleId(_response);
        });
    }

    protected processListByBreakingScheduleId(response: AxiosResponse): Promise<BreakingTestDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('BreakingTestDto[]', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("An ActionResult containing the list of BreakingTestDto if there are any associated, NotFound if not found, or Forbid if the user does not have the necessary permissions.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BreakingTestDto[]>(null as any);
    }

    /**
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param pourReference (optional) 
     * @param status (optional) 
     * @param stopeId (optional) 
     */
    listQAQCTableRecords(mineModelId: string, page?: number | undefined, pageSize?: number | null | undefined, startDate?: string | null | undefined, endDate?: string | null | undefined, pourReference?: string | null | undefined, status?: PourStatus | null | undefined, stopeId?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfQAQCTableRecordDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/ListQAQCTableRecords/list?";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (pourReference !== undefined && pourReference !== null)
            url_ += "PourReference=" + encodeURIComponent("" + pourReference) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (stopeId !== undefined && stopeId !== null)
            url_ += "StopeId=" + encodeURIComponent("" + stopeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListQAQCTableRecords(_response);
        });
    }

    protected processListQAQCTableRecords(response: AxiosResponse): Promise<PagedListOfQAQCTableRecordDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfQAQCTableRecordDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfQAQCTableRecordDto>(null as any);
    }

    getUcsStrengthGraphData(mineModelId: string, targetCuringDay: number, cancelToken?: CancelToken): Promise<UscStrengthRecordDto[]> {
        let url_ = this.baseUrl + "/api/BreakingSchedules/{mineModelId}/ucsstrengthrecords/{targetCuringDay}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (targetCuringDay === undefined || targetCuringDay === null)
            throw new Error("The parameter 'targetCuringDay' must be defined.");
        url_ = url_.replace("{targetCuringDay}", encodeURIComponent("" + targetCuringDay));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUcsStrengthGraphData(_response);
        });
    }

    protected processGetUcsStrengthGraphData(response: AxiosResponse): Promise<UscStrengthRecordDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('UscStrengthRecordDto[]', result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UscStrengthRecordDto[]>(null as any);
    }

    getRheologyUcsGraphData(mineModelId: string, rheologyDataSetId: string, targetDay: number, cancelToken?: CancelToken): Promise<UcsRheologyDataDto> {
        let url_ = this.baseUrl + "/api/projects/{mineModelId}/rheologyucs/{rheologyDataSetId}/{targetDay}";
        if (mineModelId === undefined || mineModelId === null)
            throw new Error("The parameter 'mineModelId' must be defined.");
        url_ = url_.replace("{mineModelId}", encodeURIComponent("" + mineModelId));
        if (rheologyDataSetId === undefined || rheologyDataSetId === null)
            throw new Error("The parameter 'rheologyDataSetId' must be defined.");
        url_ = url_.replace("{rheologyDataSetId}", encodeURIComponent("" + rheologyDataSetId));
        if (targetDay === undefined || targetDay === null)
            throw new Error("The parameter 'targetDay' must be defined.");
        url_ = url_.replace("{targetDay}", encodeURIComponent("" + targetDay));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRheologyUcsGraphData(_response);
        });
    }

    protected processGetRheologyUcsGraphData(response: AxiosResponse): Promise<UcsRheologyDataDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('UcsRheologyDataDto', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UcsRheologyDataDto>(null as any);
    }
}

export class UsersService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * List all users
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param clientId (optional) 
     * @param teamId (optional) 
     * @param searchTerm (optional) 
     * @param sortBy (optional) 
     * @param sortDescending (optional) 
     */
    listUsers(page?: number | undefined, pageSize?: number | null | undefined, clientId?: string | null | undefined, teamId?: string | null | undefined, searchTerm?: string | null | undefined, sortBy?: string | null | undefined, sortDescending?: boolean | undefined, cancelToken?: CancelToken): Promise<PagedListOfUserDto> {
        let url_ = this.baseUrl + "/api/Users?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDescending === null)
            throw new Error("The parameter 'sortDescending' cannot be null.");
        else if (sortDescending !== undefined)
            url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUsers(_response);
        });
    }

    protected processListUsers(response: AxiosResponse): Promise<PagedListOfUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfUserDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfUserDto>(null as any);
    }

    getUserDetail(userId: string, cancelToken?: CancelToken): Promise<UpdateUserDto> {
        let url_ = this.baseUrl + "/api/Users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDetail(_response);
        });
    }

    protected processGetUserDetail(response: AxiosResponse): Promise<UpdateUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('UpdateUserDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserDto>(null as any);
    }

    updateUser(userId: string, updateUserCommand: UpdateUserCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUserCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateUserTeamsRoles(userId: string, updateUserCommand: UpdateUserTeamRolesCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/teams";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUserCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserTeamsRoles(_response);
        });
    }

    protected processUpdateUserTeamsRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDisclaimerStatus(projectId: string, cancelToken?: CancelToken): Promise<ProjectDisclaimer> {
        let url_ = this.baseUrl + "/api/Users/project/{projectId}/disclaimer";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDisclaimerStatus(_response);
        });
    }

    protected processGetDisclaimerStatus(response: AxiosResponse): Promise<ProjectDisclaimer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ProjectDisclaimer', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDisclaimer>(null as any);
    }

    updateDisclaimerOneDay(userId: string, updateUserCommand: UpdateDisclaimerOneDayCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/disclaimer/1";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUserCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDisclaimerOneDay(_response);
        });
    }

    protected processUpdateDisclaimerOneDay(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateDisclaimerSevenDays(userId: string, updateUserCommand: UpdateDisclaimerSevenDaysCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/disclaimer/7";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUserCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDisclaimerSevenDays(_response);
        });
    }

    protected processUpdateDisclaimerSevenDays(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getTermsAndConditionsStatus( cancelToken?: CancelToken): Promise<TermsAndConditionsAcceptance> {
        let url_ = this.baseUrl + "/api/Users/me/terms-and-conditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTermsAndConditionsStatus(_response);
        });
    }

    protected processGetTermsAndConditionsStatus(response: AxiosResponse): Promise<TermsAndConditionsAcceptance> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('TermsAndConditionsAcceptance', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TermsAndConditionsAcceptance>(null as any);
    }

    acceptTermsAndConditions( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/me/terms-and-conditions/accept";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptTermsAndConditions(_response);
        });
    }

    protected processAcceptTermsAndConditions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Flat, unpaged directory of every user: username, email, companies, the models (projects) they can open
    with licence expiry, last connection and their most recent audit-trail entries.
    Built for CRM / marketing automation. Requires ViewUserDirectory (read-only, meant for a
    client-credentials OpenID application) or ManageUsers.
     * @param includeDisabled (optional) Also return accounts an administrator has disabled. Default false.
     * @param logs (optional) How many recent log entries to attach per user (0-50). Default 10.
     */
    getUserDirectory(includeDisabled?: boolean | undefined, logs?: number | undefined, cancelToken?: CancelToken): Promise<UserDirectoryEntryDto[]> {
        let url_ = this.baseUrl + "/api/Users/directory?";
        if (includeDisabled === null)
            throw new Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        if (logs === null)
            throw new Error("The parameter 'logs' cannot be null.");
        else if (logs !== undefined)
            url_ += "logs=" + encodeURIComponent("" + logs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserDirectory(_response);
        });
    }

    protected processGetUserDirectory(response: AxiosResponse): Promise<UserDirectoryEntryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('UserDirectoryEntryDto[]', result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDirectoryEntryDto[]>(null as any);
    }

    /**
     * Lists users who have not used the product for more than the inactivity threshold
     */
    getInactiveUsers( cancelToken?: CancelToken): Promise<InactiveUserDto[]> {
        let url_ = this.baseUrl + "/api/Users/inactive-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInactiveUsers(_response);
        });
    }

    protected processGetInactiveUsers(response: AxiosResponse): Promise<InactiveUserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('InactiveUserDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InactiveUserDto[]>(null as any);
    }

    /**
     * Sends the inactive users report email on demand
     */
    sendInactiveUsersReport( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/inactive-report/send";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInactiveUsersReport(_response);
        });
    }

    protected processSendInactiveUsersReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadUserfeedbackImage(file?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/Users/userfeedback/image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadUserfeedbackImage(_response);
        });
    }

    protected processUploadUserfeedbackImage(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('string', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getUserfeedbackImage(url?: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Users/userfeedback/image?";
        if (url !== undefined && url !== null)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserfeedbackImage(_response);
        });
    }

    protected processGetUserfeedbackImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TeamRolesService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    me( cancelToken?: CancelToken): Promise<{ [key: string]: any; }> {
        let url_ = this.baseUrl + "/api/TeamRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<{ [key: string]: any; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('{ [key: string]: any; }', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: any; }>(null as any);
    }
}

export class TeamsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * List all client teams
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param searchTerm (optional) 
     */
    listClientTeams(page?: number | undefined, pageSize?: number | null | undefined, searchTerm?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfTeamDto> {
        let url_ = this.baseUrl + "/api/Teams?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListClientTeams(_response);
        });
    }

    protected processListClientTeams(response: AxiosResponse): Promise<PagedListOfTeamDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfTeamDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfTeamDto>(null as any);
    }

    /**
     * List project teams by client
     */
    listProjectTeams(clientId: string, cancelToken?: CancelToken): Promise<TeamDto[]> {
        let url_ = this.baseUrl + "/api/Teams/{clientId}/projectteams";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListProjectTeams(_response);
        });
    }

    protected processListProjectTeams(response: AxiosResponse): Promise<TeamDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('TeamDto[]', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamDto[]>(null as any);
    }

    /**
     * Get client team with its project teams
     */
    getTeamsForClient(clientId: string, cancelToken?: CancelToken): Promise<ClientTeamsDto> {
        let url_ = this.baseUrl + "/api/Teams/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamsForClient(_response);
        });
    }

    protected processGetTeamsForClient(response: AxiosResponse): Promise<ClientTeamsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('ClientTeamsDto', result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientTeamsDto>(null as any);
    }

    /**
     * List Team Roles
     */
    getRoles( cancelToken?: CancelToken): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/Teams/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('RoleDto[]', result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }
}

export class InvitationsService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:5001";

    }

    /**
     * List all users
     * @param page (optional) Gets or sets the current page number or null if none specified.
     * @param pageSize (optional) Gets or sets the current page size or null if none specified.
     * @param clientId (optional) 
     * @param teamId (optional) 
     * @param searchTerm (optional) 
     */
    listInvitations(page?: number | undefined, pageSize?: number | null | undefined, clientId?: string | null | undefined, teamId?: string | null | undefined, searchTerm?: string | null | undefined, cancelToken?: CancelToken): Promise<PagedListOfInvitationDto> {
        let url_ = this.baseUrl + "/api/Invitations?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (teamId !== undefined && teamId !== null)
            url_ += "teamId=" + encodeURIComponent("" + teamId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListInvitations(_response);
        });
    }

    protected processListInvitations(response: AxiosResponse): Promise<PagedListOfInvitationDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return hydrateResponse('PagedListOfInvitationDto', result200);

        } else if (status === 204) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListOfInvitationDto>(null as any);
    }

    create(newUserCommand: InviteUserToTeamsCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Invitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newUserCommand);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 406) {
            const _responseText = response.data;
            let result406: any = null;
            let resultData406  = _responseText;
            result406 = JSON.parse(resultData406);
            return throwException("A server side error occurred.", status, _responseText, _headers, result406);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Revoke Invitation
     */
    revokeInvitation(invitationId: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Invitations/{invitationId}";
        if (invitationId === undefined || invitationId === null)
            throw new Error("The parameter 'invitationId' must be defined.");
        url_ = url_.replace("{invitationId}", encodeURIComponent("" + invitationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeInvitation(_response);
        });
    }

    protected processRevokeInvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

/** Common traits of ContentItem, ContentPart and ContentField. */
export interface ContentElement {
}

export function makeContentElement (model: ContentElement): ContentElement {
  return {
  };
}

makeFunctions.ContentElement = makeContentElement;

/** Represents a content item version. */
export interface ContentItem extends ContentElement {
    /** The primary key in the database. */
    id?: number;
    /** The logical identifier of the content item across versions. */
    contentItemId?: string | undefined;
    /** The logical identifier of the versioned content item. */
    contentItemVersionId?: string | undefined;
    /** The content type of the content item. */
    contentType?: string | undefined;
    /** Whether the version is published or not. */
    published?: boolean;
    /** Whether the version is the latest version of the content item. */
    latest?: boolean;
    /** DateTime */
    modifiedUtc?: Date | undefined;
    /** DateTime */
    publishedUtc?: Date | undefined;
    /** DateTime */
    createdUtc?: Date | undefined;
    /** The user id of the user who first created this content item version. */
    owner?: string | undefined;
    /** The name of the user who last modified this content item version. */
    author?: string | undefined;
    /** The text representing this content item. */
    displayText?: string | undefined;
}

export function makeContentItem (model: ContentItem): ContentItem {
  return {
      ...makeContentElement(model),
    id: model.id,
    contentItemId: model.contentItemId,
    contentItemVersionId: model.contentItemVersionId,
    contentType: model.contentType,
    published: model.published,
    latest: model.latest,
    modifiedUtc: model.modifiedUtc && typeof model.modifiedUtc === 'string' ? makeDate(model.modifiedUtc) : model.modifiedUtc,
    publishedUtc: model.publishedUtc && typeof model.publishedUtc === 'string' ? makeDate(model.publishedUtc) : model.publishedUtc,
    createdUtc: model.createdUtc && typeof model.createdUtc === 'string' ? makeDate(model.createdUtc) : model.createdUtc,
    owner: model.owner,
    author: model.author,
    displayText: model.displayText,
  };
}

makeFunctions.ContentItem = makeContentItem;

export interface ReadNotificationViewModel {
    messageId: string;
}

export function makeReadNotificationViewModel (model: ReadNotificationViewModel): ReadNotificationViewModel {
  return {
    messageId: model.messageId,
  };
}

makeFunctions.ReadNotificationViewModel = makeReadNotificationViewModel;

export interface PagedListOfClientDto {
    items: ClientDto[];
    pager: Pager;
}

export function makePagedListOfClientDto (model: PagedListOfClientDto): PagedListOfClientDto {
  return {
    items: (model.items?.map((item) => makeClientDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfClientDto = makePagedListOfClientDto;

export interface EntityDtoOfString {
    entityId: string;
}

export function makeEntityDtoOfString (model: EntityDtoOfString): EntityDtoOfString {
  return {
    entityId: model.entityId,
  };
}

makeFunctions.EntityDtoOfString = makeEntityDtoOfString;

export interface ClientDto extends EntityDtoOfString {
    name: string;
    logoImageBase64?: string | undefined;
}

export function makeClientDto (model: ClientDto): ClientDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
    logoImageBase64: model.logoImageBase64,
  };
}

makeFunctions.ClientDto = makeClientDto;

export interface Pager {
    /** Gets or sets the current page number or null if none specified. */
    page: number;
    /** Gets or sets the current page size or null if none specified. */
    pageSize: number;
    /** Gets or sets the total items available */
    totalItems: number;
    startIndex: number;
    pageIndex: number;
    pageCount: number;
}

export function makePager (model: Pager): Pager {
  return {
    page: model.page,
    pageSize: model.pageSize,
    totalItems: model.totalItems,
    startIndex: model.startIndex,
    pageIndex: model.pageIndex,
    pageCount: model.pageCount,
  };
}

makeFunctions.Pager = makePager;

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export function makeProblemDetails (model: ProblemDetails): ProblemDetails {
  return {
    type: model.type,
    title: model.title,
    status: model.status,
    detail: model.detail,
    instance: model.instance,
  };
}

makeFunctions.ProblemDetails = makeProblemDetails;

export interface HttpValidationProblemDetails extends ProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export function makeHttpValidationProblemDetails (model: HttpValidationProblemDetails): HttpValidationProblemDetails {
  return {
      ...makeProblemDetails(model),
    errors: model.errors,
  };
}

makeFunctions.HttpValidationProblemDetails = makeHttpValidationProblemDetails;

export interface ValidationProblemDetails extends HttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export function makeValidationProblemDetails (model: ValidationProblemDetails): ValidationProblemDetails {
  return {
      ...makeHttpValidationProblemDetails(model),
    errors: model.errors,
  };
}

makeFunctions.ValidationProblemDetails = makeValidationProblemDetails;

export interface AuditableCommandOfClientAndClientId {
}

export function makeAuditableCommandOfClientAndClientId (model: AuditableCommandOfClientAndClientId): AuditableCommandOfClientAndClientId {
  return {
  };
}

makeFunctions.AuditableCommandOfClientAndClientId = makeAuditableCommandOfClientAndClientId;

export interface CreateClientCommand extends AuditableCommandOfClientAndClientId {
    name: string;
    logoImageBase64?: string | undefined;
}

export function makeCreateClientCommand (model: CreateClientCommand): CreateClientCommand {
  return {
      ...makeAuditableCommandOfClientAndClientId(model),
    name: model.name,
    logoImageBase64: model.logoImageBase64,
  };
}

makeFunctions.CreateClientCommand = makeCreateClientCommand;

export interface UpdateClientCommand {
    name: string;
    logoImageBase64?: string | undefined;
}

export function makeUpdateClientCommand (model: UpdateClientCommand): UpdateClientCommand {
  return {
    name: model.name,
    logoImageBase64: model.logoImageBase64,
  };
}

makeFunctions.UpdateClientCommand = makeUpdateClientCommand;

export interface UserDashboardDto extends EntityDtoOfString {
    projectId: string;
    name: string;
    order: number;
    schemaVersion: number;
    tiles: DashboardTileDto[];
}

export function makeUserDashboardDto (model: UserDashboardDto): UserDashboardDto {
  return {
      ...makeEntityDtoOfString(model),
    projectId: model.projectId,
    name: model.name,
    order: model.order,
    schemaVersion: model.schemaVersion,
    tiles: (model.tiles?.map((item) => makeDashboardTileDto(item))),
  };
}

makeFunctions.UserDashboardDto = makeUserDashboardDto;

export interface DashboardTileDto {
    instanceId: string;
    type: string;
    x: number;
    y: number;
    w: number;
    h: number;
    settings?: string | undefined;
}

export function makeDashboardTileDto (model: DashboardTileDto): DashboardTileDto {
  return {
    instanceId: model.instanceId,
    type: model.type,
    x: model.x,
    y: model.y,
    w: model.w,
    h: model.h,
    settings: model.settings,
  };
}

makeFunctions.DashboardTileDto = makeDashboardTileDto;

export interface SaveUserDashboardRequest {
    dashboardId?: string | undefined;
    name?: string | undefined;
    tiles: DashboardTileDto[];
}

export function makeSaveUserDashboardRequest (model: SaveUserDashboardRequest): SaveUserDashboardRequest {
  return {
    dashboardId: model.dashboardId,
    name: model.name,
    tiles: (model.tiles?.map((item) => makeDashboardTileDto(item))),
  };
}

makeFunctions.SaveUserDashboardRequest = makeSaveUserDashboardRequest;

export interface PagedListOfProjectDto {
    items: ProjectDto[];
    pager: Pager;
}

export function makePagedListOfProjectDto (model: PagedListOfProjectDto): PagedListOfProjectDto {
  return {
    items: (model.items?.map((item) => makeProjectDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfProjectDto = makePagedListOfProjectDto;

export interface ProjectDto extends EntityDtoOfString {
    name: string;
    billingEmail: string;
    contractNumber: string;
    poNumber: string;
    billingAddress: AddressDto;
    siteAddress?: AddressDto | undefined;
    siteLocation?: GeoPointDto | undefined;
    timeZone: string;
    image: ImageSummaryDto;
    client: EntitySummaryDto;
    unitSystemPreference: UnitSystem;
    displayUnitPreferences: DisplayUnits[];
    customUnitFields: CustomUnitFields[];
    fillType: FillType;
    licence: Licence;
    licenceTypes?: LicenceType[] | undefined;
    throughput: ThroughputControlType;
    enabledModules: ProjectModule[];
    historicalBinderPercentage: number;
    currencyPreference: string;
    decimalSeparator: DecimalSeparator;
    thousandsSeparator: ThousandsSeparator;
    dashboardCharts?: string | undefined;
    stopeNoteTemplateId?: string | undefined;
    routeNodeOrder: RouteNodeOrder;
    isHideAbandonedPour: boolean;
    volumeAlternativeUnit: AlternativeUnits;
    pumpType: PumpType;
    importDistance: number;
    showMinMaxOnGraph?: boolean;
    isPatersonAndCookeProject?: boolean;
    isArchived?: boolean;
    biDirectionalBoreholes?: boolean;
    showPipeRatingOffsetOnGraph?: boolean;
    showPressureLineOnHgl?: boolean;
    metricPressureUnit?: MetricPressureUnit;
    defaultTransientPercentage?: number | undefined;
    defaultMinYield?: number | undefined;
    defaultMaxYield?: number | undefined;
    defaultExcludedPipeIds?: string[] | undefined;
    defaultPasteBeachAngleDegrees?: number | undefined;
    flushPumpMaxPressure?: number | undefined;
    flushPumpDefaultFlowRate?: number | undefined;
    flushPumpMaxFlowRate?: number | undefined;
    airFlushMaxPressure?: number | undefined;
    defaultFlushVolumeMode?: FlushVolumeMode | undefined;
    defaultFlushVolumeValue?: number | undefined;
}

export function makeProjectDto (model: ProjectDto): ProjectDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
    billingEmail: model.billingEmail,
    contractNumber: model.contractNumber,
    poNumber: model.poNumber,
    billingAddress: model.billingAddress ? makeAddressDto(model.billingAddress) : model.billingAddress,
    siteAddress: model.siteAddress ? makeAddressDto(model.siteAddress) : model.siteAddress,
    siteLocation: model.siteLocation ? makeGeoPointDto(model.siteLocation) : model.siteLocation,
    timeZone: model.timeZone,
    image: model.image ? makeImageSummaryDto(model.image) : model.image,
    client: model.client ? makeEntitySummaryDto(model.client) : model.client,
    unitSystemPreference: model.unitSystemPreference ? makeUnitSystem(model.unitSystemPreference) : model.unitSystemPreference,
    displayUnitPreferences: (model.displayUnitPreferences?.map((item) => makeDisplayUnits(item))),
    customUnitFields: (model.customUnitFields?.map((item) => makeCustomUnitFields(item))),
    fillType: model.fillType ? makeFillType(model.fillType) : model.fillType,
    licence: model.licence ? makeLicence(model.licence) : model.licence,
    licenceTypes: (model.licenceTypes?.map((item) => makeLicenceType(item))),
    throughput: model.throughput ? makeThroughputControlType(model.throughput) : model.throughput,
    enabledModules: (model.enabledModules?.map((item) => makeProjectModule(item))),
    historicalBinderPercentage: model.historicalBinderPercentage,
    currencyPreference: model.currencyPreference,
    decimalSeparator: model.decimalSeparator ? makeDecimalSeparator(model.decimalSeparator) : model.decimalSeparator,
    thousandsSeparator: model.thousandsSeparator ? makeThousandsSeparator(model.thousandsSeparator) : model.thousandsSeparator,
    dashboardCharts: model.dashboardCharts,
    stopeNoteTemplateId: model.stopeNoteTemplateId,
    routeNodeOrder: model.routeNodeOrder ? makeRouteNodeOrder(model.routeNodeOrder) : model.routeNodeOrder,
    isHideAbandonedPour: model.isHideAbandonedPour,
    volumeAlternativeUnit: model.volumeAlternativeUnit ? makeAlternativeUnits(model.volumeAlternativeUnit) : model.volumeAlternativeUnit,
    pumpType: model.pumpType ? makePumpType(model.pumpType) : model.pumpType,
    importDistance: model.importDistance,
    showMinMaxOnGraph: model.showMinMaxOnGraph,
    isPatersonAndCookeProject: model.isPatersonAndCookeProject,
    isArchived: model.isArchived,
    biDirectionalBoreholes: model.biDirectionalBoreholes,
    showPipeRatingOffsetOnGraph: model.showPipeRatingOffsetOnGraph,
    showPressureLineOnHgl: model.showPressureLineOnHgl,
    metricPressureUnit: model.metricPressureUnit ? makeMetricPressureUnit(model.metricPressureUnit) : model.metricPressureUnit,
    defaultTransientPercentage: model.defaultTransientPercentage,
    defaultMinYield: model.defaultMinYield,
    defaultMaxYield: model.defaultMaxYield,
    defaultExcludedPipeIds: model.defaultExcludedPipeIds,
    defaultPasteBeachAngleDegrees: model.defaultPasteBeachAngleDegrees,
    flushPumpMaxPressure: model.flushPumpMaxPressure,
    flushPumpDefaultFlowRate: model.flushPumpDefaultFlowRate,
    flushPumpMaxFlowRate: model.flushPumpMaxFlowRate,
    airFlushMaxPressure: model.airFlushMaxPressure,
    defaultFlushVolumeMode: model.defaultFlushVolumeMode ? makeFlushVolumeMode(model.defaultFlushVolumeMode) : model.defaultFlushVolumeMode,
    defaultFlushVolumeValue: model.defaultFlushVolumeValue,
  };
}

makeFunctions.ProjectDto = makeProjectDto;

export interface AddressForm {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    region?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
}

export function makeAddressForm (model: AddressForm): AddressForm {
  return {
    addressLine1: model.addressLine1,
    addressLine2: model.addressLine2,
    city: model.city,
    region: model.region,
    postCode: model.postCode,
    country: model.country,
  };
}

makeFunctions.AddressForm = makeAddressForm;

export interface AddressDto extends AddressForm {
}

export function makeAddressDto (model: AddressDto): AddressDto {
  return {
      ...makeAddressForm(model),
  };
}

makeFunctions.AddressDto = makeAddressDto;

export interface GeoPointForm {
    latitude: number;
    longitude: number;
}

export function makeGeoPointForm (model: GeoPointForm): GeoPointForm {
  return {
    latitude: model.latitude,
    longitude: model.longitude,
  };
}

makeFunctions.GeoPointForm = makeGeoPointForm;

export interface GeoPointDto extends GeoPointForm {
}

export function makeGeoPointDto (model: GeoPointDto): GeoPointDto {
  return {
      ...makeGeoPointForm(model),
  };
}

makeFunctions.GeoPointDto = makeGeoPointDto;

export interface ImageSummaryDto extends EntityDtoOfString {
    path: string;
    display: string;
    sizes: { [key: string]: string; };
}

export function makeImageSummaryDto (model: ImageSummaryDto): ImageSummaryDto {
  return {
      ...makeEntityDtoOfString(model),
    path: model.path,
    display: model.display,
    sizes: model.sizes,
  };
}

makeFunctions.ImageSummaryDto = makeImageSummaryDto;

export interface EntitySummaryDto extends EntityDtoOfString {
    name: string;
}

export function makeEntitySummaryDto (model: EntitySummaryDto): EntitySummaryDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
  };
}

makeFunctions.EntitySummaryDto = makeEntitySummaryDto;

export enum UnitSystem {
    Metric = 5,
    Imperial = 10,
}

function makeUnitSystem (value: UnitSystem): UnitSystem {
  return value;
}

makeFunctions.UnitSystem = makeUnitSystem;

export enum DisplayUnits {
    DrySolidFeedRate = 0,
    SlurryFeedRate = 10,
    FlowRate = 20,
    SolidsDensity = 30,
    SlurryDensity = 40,
    Slump = 50,
    ContinuousMixerPowerDraw = 60,
    BatchMixerPowerDraw = 70,
    YieldStress = 80,
    WBRatio = 90,
    BinderTonnes = 100,
    FrictionLoss = 110,
}

function makeDisplayUnits (value: DisplayUnits): DisplayUnits {
  return value;
}

makeFunctions.DisplayUnits = makeDisplayUnits;

export enum CustomUnitFields {
    PourVolume = 0,
    Strength = 10,
    PumpPressure = 20,
    DryTonnage = 30,
    WetTonnage = 40,
    Velocity = 50,
    MaxPipePressure = 60,
    PipeLength = 70,
    DrySolidFeedRate = 80,
    SlurryFeedRate = 90,
    FlowRate = 110,
    SolidsDensity = 120,
    SlurryDensity = 130,
    ContinuousMixerPowerDraw = 140,
    BatchMixerPowerDraw = 150,
    Slump = 160,
    Gravity = 170,
    BinderTonnes = 180,
}

function makeCustomUnitFields (value: CustomUnitFields): CustomUnitFields {
  return value;
}

makeFunctions.CustomUnitFields = makeCustomUnitFields;

export enum FillType {
    Paste = 5,
    Hydraulic = 10,
}

function makeFillType (value: FillType): FillType {
  return value;
}

makeFunctions.FillType = makeFillType;

export interface Licence {
    /** NodaTimeType:Instant */
    expiryDate?: Instant;    
    acceptedTimeZone?: string | undefined;
    isLicenced?: boolean;
    daysUntilExpiry?: number;
}

export function makeLicence (model: Licence): Licence {
  return {
    expiryDate: model.expiryDate && typeof model.expiryDate === 'string' ? makeInstant(model.expiryDate) : model.expiryDate,
    acceptedTimeZone: model.acceptedTimeZone,
    isLicenced: model.isLicenced,
    daysUntilExpiry: model.daysUntilExpiry,
  };
}

makeFunctions.Licence = makeLicence;

export enum LicenceType {
    BackfillProCoreLicense = 0,
    DesignModule = 1,
    QAQCModule = 2,
    WearMonitoringModule = 3,
    StopeFillModule = 4,
    LiveDataModule = 5,
    FlushingModule = 6,
    AllOfTheAbove = 7,
}

function makeLicenceType (value: LicenceType): LicenceType {
  return value;
}

makeFunctions.LicenceType = makeLicenceType;

export enum ThroughputControlType {
    DryTonnage = 1,
    WetTonnage = 2,
    FlowRate = 3,
}

function makeThroughputControlType (value: ThroughputControlType): ThroughputControlType {
  return value;
}

makeFunctions.ThroughputControlType = makeThroughputControlType;

export enum ProjectModule {
    WearMonitoring = 1,
    StopeFill = 2,
    QAQC = 3,
    Graphs = 4,
    ManuallyAddedNodes = 5,
    CustomReports = 6,
    Flushing = 7,
}

function makeProjectModule (value: ProjectModule): ProjectModule {
  return value;
}

makeFunctions.ProjectModule = makeProjectModule;

export enum DecimalSeparator {
    Dot = 0,
    Comma = 1,
}

function makeDecimalSeparator (value: DecimalSeparator): DecimalSeparator {
  return value;
}

makeFunctions.DecimalSeparator = makeDecimalSeparator;

export enum ThousandsSeparator {
    Comma = 0,
    Dot = 1,
    Space = 2,
}

function makeThousandsSeparator (value: ThousandsSeparator): ThousandsSeparator {
  return value;
}

makeFunctions.ThousandsSeparator = makeThousandsSeparator;

export enum RouteNodeOrder {
    DischargeToPastePlant = 0,
    PastePlantToDischarge = 1,
}

function makeRouteNodeOrder (value: RouteNodeOrder): RouteNodeOrder {
  return value;
}

makeFunctions.RouteNodeOrder = makeRouteNodeOrder;

export enum AlternativeUnits {
    CubicFeet = 0,
    CubicYard = 10,
}

function makeAlternativeUnits (value: AlternativeUnits): AlternativeUnits {
  return value;
}

makeFunctions.AlternativeUnits = makeAlternativeUnits;

export enum PumpType {
    Pump = 1,
    Gravity = 2,
}

function makePumpType (value: PumpType): PumpType {
  return value;
}

makeFunctions.PumpType = makePumpType;

export enum MetricPressureUnit {
    Bar = 0,
    KiloPascal = 10,
}

function makeMetricPressureUnit (value: MetricPressureUnit): MetricPressureUnit {
  return value;
}

makeFunctions.MetricPressureUnit = makeMetricPressureUnit;

export enum FlushVolumeMode {
    Explicit = 0,
    PipeVolumeMultiple = 1,
    PipeVolumePlus = 2,
    Distance = 3,
    AirStartVolume = 4,
}

function makeFlushVolumeMode (value: FlushVolumeMode): FlushVolumeMode {
  return value;
}

makeFunctions.FlushVolumeMode = makeFlushVolumeMode;

export interface AuditableCommandOfProjectAndProjectId {
}

export function makeAuditableCommandOfProjectAndProjectId (model: AuditableCommandOfProjectAndProjectId): AuditableCommandOfProjectAndProjectId {
  return {
  };
}

makeFunctions.AuditableCommandOfProjectAndProjectId = makeAuditableCommandOfProjectAndProjectId;

export interface CreateProjectCommand extends AuditableCommandOfProjectAndProjectId {
    project: UpdateProjectForm;
    site?: UpdateProjectSiteForm | undefined;
    billing?: UpdateProjectBillingForm | undefined;
    unitSystemPreference: UnitSystem;
    displayUnitPreferences: DisplayUnits[];
    customUnitFields: CustomUnitFields[];
    fillType: FillType;
    throughputControlType: ThroughputControlType;
    enabledModules: ProjectModule[];
    routeNodeOrder: RouteNodeOrder;
    isHideAbandonedPour: boolean;
    volumeAlternativeUnit: AlternativeUnits;
    pumpType: PumpType;
    currencyPreference: string;
    decimalSeparator: DecimalSeparator;
    thousandsSeparator: ThousandsSeparator;
    projectCode?: string | undefined;
    importDistance: number;
    showMinMaxOnGraph?: boolean;
    showPressureLineOnHgl?: boolean;
    metricPressureUnit?: MetricPressureUnit;
    isPatersonAndCookeProject?: boolean;
    biDirectionalBoreholes?: boolean;
    defaultTransientPercentage?: number | undefined;
    defaultMinYield?: number | undefined;
    defaultMaxYield?: number | undefined;
    showPipeRatingOffsetOnGraph?: boolean;
    defaultExcludedPipeIds?: string[] | undefined;
    defaultPasteBeachAngleDegrees?: number | undefined;
    flushPumpMaxPressure?: number | undefined;
    flushPumpDefaultFlowRate?: number | undefined;
    flushPumpMaxFlowRate?: number | undefined;
    airFlushMaxPressure?: number | undefined;
    defaultFlushVolumeMode?: FlushVolumeMode | undefined;
    defaultFlushVolumeValue?: number | undefined;
}

export function makeCreateProjectCommand (model: CreateProjectCommand): CreateProjectCommand {
  return {
      ...makeAuditableCommandOfProjectAndProjectId(model),
    project: model.project ? makeUpdateProjectForm(model.project) : model.project,
    site: model.site ? makeUpdateProjectSiteForm(model.site) : model.site,
    billing: model.billing ? makeUpdateProjectBillingForm(model.billing) : model.billing,
    unitSystemPreference: model.unitSystemPreference ? makeUnitSystem(model.unitSystemPreference) : model.unitSystemPreference,
    displayUnitPreferences: (model.displayUnitPreferences?.map((item) => makeDisplayUnits(item))),
    customUnitFields: (model.customUnitFields?.map((item) => makeCustomUnitFields(item))),
    fillType: model.fillType ? makeFillType(model.fillType) : model.fillType,
    throughputControlType: model.throughputControlType ? makeThroughputControlType(model.throughputControlType) : model.throughputControlType,
    enabledModules: (model.enabledModules?.map((item) => makeProjectModule(item))),
    routeNodeOrder: model.routeNodeOrder ? makeRouteNodeOrder(model.routeNodeOrder) : model.routeNodeOrder,
    isHideAbandonedPour: model.isHideAbandonedPour,
    volumeAlternativeUnit: model.volumeAlternativeUnit ? makeAlternativeUnits(model.volumeAlternativeUnit) : model.volumeAlternativeUnit,
    pumpType: model.pumpType ? makePumpType(model.pumpType) : model.pumpType,
    currencyPreference: model.currencyPreference,
    decimalSeparator: model.decimalSeparator ? makeDecimalSeparator(model.decimalSeparator) : model.decimalSeparator,
    thousandsSeparator: model.thousandsSeparator ? makeThousandsSeparator(model.thousandsSeparator) : model.thousandsSeparator,
    projectCode: model.projectCode,
    importDistance: model.importDistance,
    showMinMaxOnGraph: model.showMinMaxOnGraph,
    showPressureLineOnHgl: model.showPressureLineOnHgl,
    metricPressureUnit: model.metricPressureUnit ? makeMetricPressureUnit(model.metricPressureUnit) : model.metricPressureUnit,
    isPatersonAndCookeProject: model.isPatersonAndCookeProject,
    biDirectionalBoreholes: model.biDirectionalBoreholes,
    defaultTransientPercentage: model.defaultTransientPercentage,
    defaultMinYield: model.defaultMinYield,
    defaultMaxYield: model.defaultMaxYield,
    showPipeRatingOffsetOnGraph: model.showPipeRatingOffsetOnGraph,
    defaultExcludedPipeIds: model.defaultExcludedPipeIds,
    defaultPasteBeachAngleDegrees: model.defaultPasteBeachAngleDegrees,
    flushPumpMaxPressure: model.flushPumpMaxPressure,
    flushPumpDefaultFlowRate: model.flushPumpDefaultFlowRate,
    flushPumpMaxFlowRate: model.flushPumpMaxFlowRate,
    airFlushMaxPressure: model.airFlushMaxPressure,
    defaultFlushVolumeMode: model.defaultFlushVolumeMode ? makeFlushVolumeMode(model.defaultFlushVolumeMode) : model.defaultFlushVolumeMode,
    defaultFlushVolumeValue: model.defaultFlushVolumeValue,
  };
}

makeFunctions.CreateProjectCommand = makeCreateProjectCommand;

export interface UpdateProjectForm {
    name: string;
}

export function makeUpdateProjectForm (model: UpdateProjectForm): UpdateProjectForm {
  return {
    name: model.name,
  };
}

makeFunctions.UpdateProjectForm = makeUpdateProjectForm;

export interface UpdateProjectSiteForm {
    siteAddress?: AddressForm | undefined;
    siteLocation?: GeoPointForm | undefined;
    timeZone?: string | undefined;
}

export function makeUpdateProjectSiteForm (model: UpdateProjectSiteForm): UpdateProjectSiteForm {
  return {
    siteAddress: model.siteAddress ? makeAddressForm(model.siteAddress) : model.siteAddress,
    siteLocation: model.siteLocation ? makeGeoPointForm(model.siteLocation) : model.siteLocation,
    timeZone: model.timeZone,
  };
}

makeFunctions.UpdateProjectSiteForm = makeUpdateProjectSiteForm;

export interface UpdateProjectBillingForm {
    email?: string | undefined;
    contractNumber?: string | undefined;
    poNumber?: string | undefined;
    billingAddress?: AddressForm | undefined;
}

export function makeUpdateProjectBillingForm (model: UpdateProjectBillingForm): UpdateProjectBillingForm {
  return {
    email: model.email,
    contractNumber: model.contractNumber,
    poNumber: model.poNumber,
    billingAddress: model.billingAddress ? makeAddressForm(model.billingAddress) : model.billingAddress,
  };
}

makeFunctions.UpdateProjectBillingForm = makeUpdateProjectBillingForm;

export interface UpdateProjectCommand {
    project: UpdateProjectForm;
    site: UpdateProjectSiteForm;
    billing: UpdateProjectBillingForm;
    unitSystemPreference: UnitSystem;
    displayUnitPreferences: DisplayUnits[];
    customUnitFields: CustomUnitFields[];
    enabledModules: ProjectModule[];
    routeNodeOrder: RouteNodeOrder;
    isHideAbandonedPour: boolean;
    volumeAlternativeUnit: AlternativeUnits;
    pumpType?: PumpType;
    currencyPreference: string;
    decimalSeparator: DecimalSeparator;
    thousandsSeparator: ThousandsSeparator;
    projectCode?: string | undefined;
    importDistance: number;
    showMinMaxOnGraph?: boolean;
    showPressureLineOnHgl?: boolean;
    metricPressureUnit?: MetricPressureUnit;
    biDirectionalBoreholes?: boolean;
    defaultTransientPercentage?: number | undefined;
    defaultMinYield?: number | undefined;
    defaultMaxYield?: number | undefined;
    isPatersonAndCookeProject?: boolean;
    showPipeRatingOffsetOnGraph?: boolean;
    defaultExcludedPipeIds?: string[] | undefined;
    defaultPasteBeachAngleDegrees?: number | undefined;
    flushPumpMaxPressure?: number | undefined;
    flushPumpDefaultFlowRate?: number | undefined;
    flushPumpMaxFlowRate?: number | undefined;
    airFlushMaxPressure?: number | undefined;
    defaultFlushVolumeMode?: FlushVolumeMode | undefined;
    defaultFlushVolumeValue?: number | undefined;
}

export function makeUpdateProjectCommand (model: UpdateProjectCommand): UpdateProjectCommand {
  return {
    project: model.project ? makeUpdateProjectForm(model.project) : model.project,
    site: model.site ? makeUpdateProjectSiteForm(model.site) : model.site,
    billing: model.billing ? makeUpdateProjectBillingForm(model.billing) : model.billing,
    unitSystemPreference: model.unitSystemPreference ? makeUnitSystem(model.unitSystemPreference) : model.unitSystemPreference,
    displayUnitPreferences: (model.displayUnitPreferences?.map((item) => makeDisplayUnits(item))),
    customUnitFields: (model.customUnitFields?.map((item) => makeCustomUnitFields(item))),
    enabledModules: (model.enabledModules?.map((item) => makeProjectModule(item))),
    routeNodeOrder: model.routeNodeOrder ? makeRouteNodeOrder(model.routeNodeOrder) : model.routeNodeOrder,
    isHideAbandonedPour: model.isHideAbandonedPour,
    volumeAlternativeUnit: model.volumeAlternativeUnit ? makeAlternativeUnits(model.volumeAlternativeUnit) : model.volumeAlternativeUnit,
    pumpType: model.pumpType ? makePumpType(model.pumpType) : model.pumpType,
    currencyPreference: model.currencyPreference,
    decimalSeparator: model.decimalSeparator ? makeDecimalSeparator(model.decimalSeparator) : model.decimalSeparator,
    thousandsSeparator: model.thousandsSeparator ? makeThousandsSeparator(model.thousandsSeparator) : model.thousandsSeparator,
    projectCode: model.projectCode,
    importDistance: model.importDistance,
    showMinMaxOnGraph: model.showMinMaxOnGraph,
    showPressureLineOnHgl: model.showPressureLineOnHgl,
    metricPressureUnit: model.metricPressureUnit ? makeMetricPressureUnit(model.metricPressureUnit) : model.metricPressureUnit,
    biDirectionalBoreholes: model.biDirectionalBoreholes,
    defaultTransientPercentage: model.defaultTransientPercentage,
    defaultMinYield: model.defaultMinYield,
    defaultMaxYield: model.defaultMaxYield,
    isPatersonAndCookeProject: model.isPatersonAndCookeProject,
    showPipeRatingOffsetOnGraph: model.showPipeRatingOffsetOnGraph,
    defaultExcludedPipeIds: model.defaultExcludedPipeIds,
    defaultPasteBeachAngleDegrees: model.defaultPasteBeachAngleDegrees,
    flushPumpMaxPressure: model.flushPumpMaxPressure,
    flushPumpDefaultFlowRate: model.flushPumpDefaultFlowRate,
    flushPumpMaxFlowRate: model.flushPumpMaxFlowRate,
    airFlushMaxPressure: model.airFlushMaxPressure,
    defaultFlushVolumeMode: model.defaultFlushVolumeMode ? makeFlushVolumeMode(model.defaultFlushVolumeMode) : model.defaultFlushVolumeMode,
    defaultFlushVolumeValue: model.defaultFlushVolumeValue,
  };
}

makeFunctions.UpdateProjectCommand = makeUpdateProjectCommand;

export interface SetProjectLicenceExpiryDateCommand {
    /** NodaTimeType:Instant */
    expiryDate: Instant;    
    acceptedTimeZone: string;
}

export function makeSetProjectLicenceExpiryDateCommand (model: SetProjectLicenceExpiryDateCommand): SetProjectLicenceExpiryDateCommand {
  return {
    expiryDate: model.expiryDate && typeof model.expiryDate === 'string' ? makeInstant(model.expiryDate) : model.expiryDate,
    acceptedTimeZone: model.acceptedTimeZone,
  };
}

makeFunctions.SetProjectLicenceExpiryDateCommand = makeSetProjectLicenceExpiryDateCommand;

export interface SetHistoricalBinderPercentageCommand {
    historicalBinderPercentage: number;
}

export function makeSetHistoricalBinderPercentageCommand (model: SetHistoricalBinderPercentageCommand): SetHistoricalBinderPercentageCommand {
  return {
    historicalBinderPercentage: model.historicalBinderPercentage,
  };
}

makeFunctions.SetHistoricalBinderPercentageCommand = makeSetHistoricalBinderPercentageCommand;

export interface SetProjectArchivedCommand {
    isArchived?: boolean;
}

export function makeSetProjectArchivedCommand (model: SetProjectArchivedCommand): SetProjectArchivedCommand {
  return {
    isArchived: model.isArchived,
  };
}

makeFunctions.SetProjectArchivedCommand = makeSetProjectArchivedCommand;

export interface SetCurrencyPreferenceCommand {
    currencyPreference: string;
}

export function makeSetCurrencyPreferenceCommand (model: SetCurrencyPreferenceCommand): SetCurrencyPreferenceCommand {
  return {
    currencyPreference: model.currencyPreference,
  };
}

makeFunctions.SetCurrencyPreferenceCommand = makeSetCurrencyPreferenceCommand;

export interface SetDashboardChartsCommand {
    dashboardCharts?: string | undefined;
}

export function makeSetDashboardChartsCommand (model: SetDashboardChartsCommand): SetDashboardChartsCommand {
  return {
    dashboardCharts: model.dashboardCharts,
  };
}

makeFunctions.SetDashboardChartsCommand = makeSetDashboardChartsCommand;

export interface SetStopeNoteTemplateIdCommand {
    stopeNoteTemplateId?: string | undefined;
}

export function makeSetStopeNoteTemplateIdCommand (model: SetStopeNoteTemplateIdCommand): SetStopeNoteTemplateIdCommand {
  return {
    stopeNoteTemplateId: model.stopeNoteTemplateId,
  };
}

makeFunctions.SetStopeNoteTemplateIdCommand = makeSetStopeNoteTemplateIdCommand;

export interface InviteUserToPcProjectCommand extends AuditableCommandOfProjectAndProjectId {
    email: string;
}

export function makeInviteUserToPcProjectCommand (model: InviteUserToPcProjectCommand): InviteUserToPcProjectCommand {
  return {
      ...makeAuditableCommandOfProjectAndProjectId(model),
    email: model.email,
  };
}

makeFunctions.InviteUserToPcProjectCommand = makeInviteUserToPcProjectCommand;

export interface ProjectCollaboratorDto {
    userId?: string | undefined;
    email?: string | undefined;
    name?: string | undefined;
    isCreator?: boolean;
    roles?: string[] | undefined;
}

export function makeProjectCollaboratorDto (model: ProjectCollaboratorDto): ProjectCollaboratorDto {
  return {
    userId: model.userId,
    email: model.email,
    name: model.name,
    isCreator: model.isCreator,
    roles: model.roles,
  };
}

makeFunctions.ProjectCollaboratorDto = makeProjectCollaboratorDto;

export interface FlushRecipeDto extends EntityDtoOfString {
    reference: string;
    stopeIdentifier: StopeIdentifierDto;
    rheologyDataSetId: string;
    rheologyDataSetReference: string;
    rheologyDataSetVersion: string;
    /** The recipe whose paste the water displaces, when one is linked. */
    backfillRecipeId?: string | undefined;
    /** The route as a node walk, the same shape as the recipe's spoolIds. */
    spoolIds: string[];
    /** The route's real spool ids in route order. */
    routeSpoolIds?: string[] | undefined;
    specification: FlushSpecificationDto;
    result: FlushResultDto;
    /** DateTime */
    creationDate?: Date;
    scenarioId?: string | undefined;
}

export function makeFlushRecipeDto (model: FlushRecipeDto): FlushRecipeDto {
  return {
      ...makeEntityDtoOfString(model),
    reference: model.reference,
    stopeIdentifier: model.stopeIdentifier ? makeStopeIdentifierDto(model.stopeIdentifier) : model.stopeIdentifier,
    rheologyDataSetId: model.rheologyDataSetId,
    rheologyDataSetReference: model.rheologyDataSetReference,
    rheologyDataSetVersion: model.rheologyDataSetVersion,
    backfillRecipeId: model.backfillRecipeId,
    spoolIds: model.spoolIds,
    routeSpoolIds: model.routeSpoolIds,
    specification: model.specification ? makeFlushSpecificationDto(model.specification) : model.specification,
    result: model.result ? makeFlushResultDto(model.result) : model.result,
    creationDate: model.creationDate && typeof model.creationDate === 'string' ? makeDate(model.creationDate) : model.creationDate,
    scenarioId: model.scenarioId,
  };
}

makeFunctions.FlushRecipeDto = makeFlushRecipeDto;

export interface StopeIdentifierDto {
    mineModelId: string;
    stopeId: string;
}

export function makeStopeIdentifierDto (model: StopeIdentifierDto): StopeIdentifierDto {
  return {
    mineModelId: model.mineModelId,
    stopeId: model.stopeId,
  };
}

makeFunctions.StopeIdentifierDto = makeStopeIdentifierDto;

export interface FlushSpecificationDto {
    /** Bar. */
    flushPumpMaxPressure: number;
    /** m³/h. */
    flushPumpFlowRate: number;
    /** m³/h. */
    pastePumpFlowRate: number;
    airFlushEnabled: boolean;
    /** Bar. Null when the air purge is disabled. */
    airFlushMaxPressure?: number | undefined;
    volumeMode: FlushVolumeMode;
    volumeValue: number;
}

export function makeFlushSpecificationDto (model: FlushSpecificationDto): FlushSpecificationDto {
  return {
    flushPumpMaxPressure: model.flushPumpMaxPressure,
    flushPumpFlowRate: model.flushPumpFlowRate,
    pastePumpFlowRate: model.pastePumpFlowRate,
    airFlushEnabled: model.airFlushEnabled,
    airFlushMaxPressure: model.airFlushMaxPressure,
    volumeMode: model.volumeMode ? makeFlushVolumeMode(model.volumeMode) : model.volumeMode,
    volumeValue: model.volumeValue,
  };
}

makeFunctions.FlushSpecificationDto = makeFlushSpecificationDto;

export interface FlushResultDto {
    totalLineVolume: number;
    totalLineLength: number;
    finalFlushVolume: number;
    pastePumpWaterVolume: number;
    pastePumpHandoverDistance: number;
    flushPumpCanCompleteAlone: boolean;
    airStartWaterVolume?: number | undefined;
    airStartDistance?: number | undefined;
    airStartTimeMinutes?: number | undefined;
    airStartStage?: FlushStageType | undefined;
    timeToWaterAtStopeMinutes?: number | undefined;
    waterAtStopeStage?: FlushStageType | undefined;
    waterFrontStopDistance: number;
    /** Bar. */
    maxRequiredPressure: number;
    stages: FlushStageDto[];
    warnings: FlushWarningDto[];
}

export function makeFlushResultDto (model: FlushResultDto): FlushResultDto {
  return {
    totalLineVolume: model.totalLineVolume,
    totalLineLength: model.totalLineLength,
    finalFlushVolume: model.finalFlushVolume,
    pastePumpWaterVolume: model.pastePumpWaterVolume,
    pastePumpHandoverDistance: model.pastePumpHandoverDistance,
    flushPumpCanCompleteAlone: model.flushPumpCanCompleteAlone,
    airStartWaterVolume: model.airStartWaterVolume,
    airStartDistance: model.airStartDistance,
    airStartTimeMinutes: model.airStartTimeMinutes,
    airStartStage: model.airStartStage ? makeFlushStageType(model.airStartStage) : model.airStartStage,
    timeToWaterAtStopeMinutes: model.timeToWaterAtStopeMinutes,
    waterAtStopeStage: model.waterAtStopeStage ? makeFlushStageType(model.waterAtStopeStage) : model.waterAtStopeStage,
    waterFrontStopDistance: model.waterFrontStopDistance,
    maxRequiredPressure: model.maxRequiredPressure,
    stages: (model.stages?.map((item) => makeFlushStageDto(item))),
    warnings: (model.warnings?.map((item) => makeFlushWarningDto(item))),
  };
}

makeFunctions.FlushResultDto = makeFlushResultDto;

/** Which pump is pushing the water during a stage of the flush. Mirrors the SPA's FlushStageType member for member. */
export enum FlushStageType {
    PastePump = 0,
    FlushPump = 1,
}

function makeFlushStageType (value: FlushStageType): FlushStageType {
  return value;
}

makeFunctions.FlushStageType = makeFlushStageType;

export interface FlushStageDto {
    stageType: FlushStageType;
    startVolume: number;
    endVolume: number;
    startDistance: number;
    endDistance: number;
    flowRate: number;
    /** Bar. */
    requiredPressureStart: number;
    /** Bar. */
    requiredPressureEnd: number;
    durationMinutes: number;
}

export function makeFlushStageDto (model: FlushStageDto): FlushStageDto {
  return {
    stageType: model.stageType ? makeFlushStageType(model.stageType) : model.stageType,
    startVolume: model.startVolume,
    endVolume: model.endVolume,
    startDistance: model.startDistance,
    endDistance: model.endDistance,
    flowRate: model.flowRate,
    requiredPressureStart: model.requiredPressureStart,
    requiredPressureEnd: model.requiredPressureEnd,
    durationMinutes: model.durationMinutes,
  };
}

makeFunctions.FlushStageDto = makeFlushStageDto;

export interface FlushWarningDto {
    code: string;
    description?: string | undefined;
}

export function makeFlushWarningDto (model: FlushWarningDto): FlushWarningDto {
  return {
    code: model.code,
    description: model.description,
  };
}

makeFunctions.FlushWarningDto = makeFlushWarningDto;

export interface AuditableCommandOfFlushRecipeAndFlushRecipeId {
}

export function makeAuditableCommandOfFlushRecipeAndFlushRecipeId (model: AuditableCommandOfFlushRecipeAndFlushRecipeId): AuditableCommandOfFlushRecipeAndFlushRecipeId {
  return {
  };
}

makeFunctions.AuditableCommandOfFlushRecipeAndFlushRecipeId = makeAuditableCommandOfFlushRecipeAndFlushRecipeId;

export interface FlushRecipeForm extends AuditableCommandOfFlushRecipeAndFlushRecipeId {
    reference: string;
    rheologyDataSetId: string;
    /** The recipe whose paste the water displaces. Optional. */
    backfillRecipeId?: string | undefined;
    /** The route as a node walk, the same shape as the recipe form's spools. */
    spools?: string[] | undefined;
    /** The route's real spool ids, in route order. */
    routeSpools?: string[] | undefined;
    stopeId?: string | undefined;
    specification: FlushSpecificationDto;
    result: FlushResultDto;
}

export function makeFlushRecipeForm (model: FlushRecipeForm): FlushRecipeForm {
  return {
      ...makeAuditableCommandOfFlushRecipeAndFlushRecipeId(model),
    reference: model.reference,
    rheologyDataSetId: model.rheologyDataSetId,
    backfillRecipeId: model.backfillRecipeId,
    spools: model.spools,
    routeSpools: model.routeSpools,
    stopeId: model.stopeId,
    specification: model.specification ? makeFlushSpecificationDto(model.specification) : model.specification,
    result: model.result ? makeFlushResultDto(model.result) : model.result,
  };
}

makeFunctions.FlushRecipeForm = makeFlushRecipeForm;

/** Should be wrapped with StopeCommandContext[T, FlushRecipeId] */
export interface CreateFlushRecipeCommand extends FlushRecipeForm {
}

export function makeCreateFlushRecipeCommand (model: CreateFlushRecipeCommand): CreateFlushRecipeCommand {
  return {
      ...makeFlushRecipeForm(model),
  };
}

makeFunctions.CreateFlushRecipeCommand = makeCreateFlushRecipeCommand;

/** Should be wrapped with FlushRecipeCommandContext[T] */
export interface UpdateFlushRecipeCommand extends FlushRecipeForm {
}

export function makeUpdateFlushRecipeCommand (model: UpdateFlushRecipeCommand): UpdateFlushRecipeCommand {
  return {
      ...makeFlushRecipeForm(model),
  };
}

makeFunctions.UpdateFlushRecipeCommand = makeUpdateFlushRecipeCommand;

export interface PublicPourApprovalViewDto {
    pour: PourDto;
    rheologyData: RheologyDataDto;
    unitSystem: UnitSystem;
    fillType: FillType;
    pumpType: PumpType;
    metricPressureUnit: MetricPressureUnit;
    stopeData?: StopeDataDto | undefined;
}

export function makePublicPourApprovalViewDto (model: PublicPourApprovalViewDto): PublicPourApprovalViewDto {
  return {
    pour: model.pour ? makePourDto(model.pour) : model.pour,
    rheologyData: model.rheologyData ? makeRheologyDataDto(model.rheologyData) : model.rheologyData,
    unitSystem: model.unitSystem ? makeUnitSystem(model.unitSystem) : model.unitSystem,
    fillType: model.fillType ? makeFillType(model.fillType) : model.fillType,
    pumpType: model.pumpType ? makePumpType(model.pumpType) : model.pumpType,
    metricPressureUnit: model.metricPressureUnit ? makeMetricPressureUnit(model.metricPressureUnit) : model.metricPressureUnit,
    stopeData: model.stopeData ? makeStopeDataDto(model.stopeData) : model.stopeData,
  };
}

makeFunctions.PublicPourApprovalViewDto = makePublicPourApprovalViewDto;

export interface PourDto extends EntityDtoOfString {
    status: PourStatus;
    statusUpdates?: StatusUpdateDtoOfPourStatus[] | undefined;
    reference: string;
    rheologyDataSetId?: string | undefined;
    rheologyDataSetReference?: string | undefined;
    rheologyDataSetVersion?: string | undefined;
    /** This was the reference on the recipe at the time of creation. The recipe may have changed name and or values since so this carries little meaning */
    recipeReference?: string | undefined;
    /** NodaTimeType:ZonedDateTime */
    intendedPourDate: ZonedDateTime;    
    volume: number;
    recipeId?: string | undefined;
    pourPresetId?: string | undefined;
    isRockFill?: boolean;
    comment?: string | undefined;
    stopeIdentifier?: StopeIdentifierDto | undefined;
    pasteSpecification?: PasteBackfillSpecificationDto | undefined;
    pasteOptimisedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSelectedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSlackFlowSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteMaxPressureSpecification?: PasteRecipeSpecificationDto | undefined;
    hydraulicSpecification?: HydraulicBackfillSpecificationDto | undefined;
    hydraulicOptimisedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    hydraulicSelectedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    warnings?: BackfillWarningDto[] | undefined;
    pourNote?: PourNoteDto | undefined;
    archivedPourNotes?: PourNoteDto[] | undefined;
    pourData?: PourDataDto | undefined;
    /** The route as a node walk (legacy name, read by the pour note, exports and route highlighting). */
    spoolIds?: string[] | undefined;
    /** The route's real spool ids in route order. Empty on a pour created before recipes carried them. */
    routeSpoolIds?: string[] | undefined;
    volumeRetainedAfterOutflow?: number | undefined;
    pourPositionX?: number | undefined;
    pourPositionY?: number | undefined;
    pourHeight?: number | undefined;
    pasteBeachAngleDegrees?: number | undefined;
    flushRecipeId?: string | undefined;
    flushRecipeReference?: string | undefined;
    flushSpecification?: FlushSpecificationDto | undefined;
    flushResult?: FlushResultDto | undefined;
    accessTokens?: AccessToken[] | undefined;
    documents?: PourDocument[] | undefined;
    pipeFrictionDataItems?: PipeFrictionDataDto[] | undefined;
}

export function makePourDto (model: PourDto): PourDto {
  return {
      ...makeEntityDtoOfString(model),
    status: model.status ? makePourStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateDtoOfPourStatus(item))),
    reference: model.reference,
    rheologyDataSetId: model.rheologyDataSetId,
    rheologyDataSetReference: model.rheologyDataSetReference,
    rheologyDataSetVersion: model.rheologyDataSetVersion,
    recipeReference: model.recipeReference,
    intendedPourDate: model.intendedPourDate && typeof model.intendedPourDate === 'string' ? makeZonedDateTime(model.intendedPourDate) : model.intendedPourDate,
    volume: model.volume,
    recipeId: model.recipeId,
    pourPresetId: model.pourPresetId,
    isRockFill: model.isRockFill,
    comment: model.comment,
    stopeIdentifier: model.stopeIdentifier ? makeStopeIdentifierDto(model.stopeIdentifier) : model.stopeIdentifier,
    pasteSpecification: model.pasteSpecification ? makePasteBackfillSpecificationDto(model.pasteSpecification) : model.pasteSpecification,
    pasteOptimisedSpecification: model.pasteOptimisedSpecification ? makePasteRecipeSpecificationDto(model.pasteOptimisedSpecification) : model.pasteOptimisedSpecification,
    pasteSelectedSpecification: model.pasteSelectedSpecification ? makePasteRecipeSpecificationDto(model.pasteSelectedSpecification) : model.pasteSelectedSpecification,
    pasteSlackFlowSpecification: model.pasteSlackFlowSpecification ? makePasteRecipeSpecificationDto(model.pasteSlackFlowSpecification) : model.pasteSlackFlowSpecification,
    pasteMaxPressureSpecification: model.pasteMaxPressureSpecification ? makePasteRecipeSpecificationDto(model.pasteMaxPressureSpecification) : model.pasteMaxPressureSpecification,
    hydraulicSpecification: model.hydraulicSpecification ? makeHydraulicBackfillSpecificationDto(model.hydraulicSpecification) : model.hydraulicSpecification,
    hydraulicOptimisedSpecification: model.hydraulicOptimisedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicOptimisedSpecification) : model.hydraulicOptimisedSpecification,
    hydraulicSelectedSpecification: model.hydraulicSelectedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicSelectedSpecification) : model.hydraulicSelectedSpecification,
    warnings: (model.warnings?.map((item) => makeBackfillWarningDto(item))),
    pourNote: model.pourNote ? makePourNoteDto(model.pourNote) : model.pourNote,
    archivedPourNotes: (model.archivedPourNotes?.map((item) => makePourNoteDto(item))),
    pourData: model.pourData ? makePourDataDto(model.pourData) : model.pourData,
    spoolIds: model.spoolIds,
    routeSpoolIds: model.routeSpoolIds,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
    pourPositionX: model.pourPositionX,
    pourPositionY: model.pourPositionY,
    pourHeight: model.pourHeight,
    pasteBeachAngleDegrees: model.pasteBeachAngleDegrees,
    flushRecipeId: model.flushRecipeId,
    flushRecipeReference: model.flushRecipeReference,
    flushSpecification: model.flushSpecification ? makeFlushSpecificationDto(model.flushSpecification) : model.flushSpecification,
    flushResult: model.flushResult ? makeFlushResultDto(model.flushResult) : model.flushResult,
    accessTokens: (model.accessTokens?.map((item) => makeAccessToken(item))),
    documents: (model.documents?.map((item) => makePourDocument(item))),
    pipeFrictionDataItems: (model.pipeFrictionDataItems?.map((item) => makePipeFrictionDataDto(item))),
  };
}

makeFunctions.PourDto = makePourDto;

export enum PourStatus {
    Planned = 0,
    PourNoteGenerated = 10,
    AwaitingApproval = 20,
    Approved = 30,
    Complete = 40,
    Rejected = 50,
    Abandoned = -10,
}

function makePourStatus (value: PourStatus): PourStatus {
  return value;
}

makeFunctions.PourStatus = makePourStatus;

export interface StatusUpdateDtoOfPourStatus {
    status?: PourStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryDto | undefined;
}

export function makeStatusUpdateDtoOfPourStatus (model: StatusUpdateDtoOfPourStatus): StatusUpdateDtoOfPourStatus {
  return {
    status: model.status ? makePourStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryDto(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateDtoOfPourStatus = makeStatusUpdateDtoOfPourStatus;

export interface PasteBackfillSpecificationDto {
    targetUCSStrength: number;
    targetDays: number;
    throughput: number;
    throughputControlType: ThroughputControlType;
    pumpPressure: number;
}

export function makePasteBackfillSpecificationDto (model: PasteBackfillSpecificationDto): PasteBackfillSpecificationDto {
  return {
    targetUCSStrength: model.targetUCSStrength,
    targetDays: model.targetDays,
    throughput: model.throughput,
    throughputControlType: model.throughputControlType ? makeThroughputControlType(model.throughputControlType) : model.throughputControlType,
    pumpPressure: model.pumpPressure,
  };
}

makeFunctions.PasteBackfillSpecificationDto = makePasteBackfillSpecificationDto;

export interface PasteRecipeSpecificationDto {
    massConcentration: number;
    binderContent: number;
    ucsStrength: number;
    /** Pump Pressure in Bar */
    pumpPressure: number;
}

export function makePasteRecipeSpecificationDto (model: PasteRecipeSpecificationDto): PasteRecipeSpecificationDto {
  return {
    massConcentration: model.massConcentration,
    binderContent: model.binderContent,
    ucsStrength: model.ucsStrength,
    pumpPressure: model.pumpPressure,
  };
}

makeFunctions.PasteRecipeSpecificationDto = makePasteRecipeSpecificationDto;

export interface HydraulicBackfillSpecificationDto {
    binderTailingsRatio: number;
    throughput: number;
    throughputControlType: ThroughputControlType;
}

export function makeHydraulicBackfillSpecificationDto (model: HydraulicBackfillSpecificationDto): HydraulicBackfillSpecificationDto {
  return {
    binderTailingsRatio: model.binderTailingsRatio,
    throughput: model.throughput,
    throughputControlType: model.throughputControlType ? makeThroughputControlType(model.throughputControlType) : model.throughputControlType,
  };
}

makeFunctions.HydraulicBackfillSpecificationDto = makeHydraulicBackfillSpecificationDto;

export interface HydraulicRecipeSpecificationDto {
    massConcentration: number;
    settlingVelocity: number;
    minVelocity: number;
    maxPipePressure: number;
}

export function makeHydraulicRecipeSpecificationDto (model: HydraulicRecipeSpecificationDto): HydraulicRecipeSpecificationDto {
  return {
    massConcentration: model.massConcentration,
    settlingVelocity: model.settlingVelocity,
    minVelocity: model.minVelocity,
    maxPipePressure: model.maxPipePressure,
  };
}

makeFunctions.HydraulicRecipeSpecificationDto = makeHydraulicRecipeSpecificationDto;

export interface BackfillWarningDto {
    code?: string | undefined;
    display?: string | undefined;
}

export function makeBackfillWarningDto (model: BackfillWarningDto): BackfillWarningDto {
  return {
    code: model.code,
    display: model.display,
  };
}

makeFunctions.BackfillWarningDto = makeBackfillWarningDto;

export interface PourNoteDto extends EntityDtoOfString {
    approvers: PourNoteApprovalDto[];
    activeApprovers: PourNoteApprovalDto[];
    status: PourNoteStatus;
    statusUpdates: StatusUpdateDtoOfPourNoteStatus[];
    file: EntitySummaryDto;
    finalizedFile: EntitySummaryDto;
    /** NodaTimeType:Instant */
    created: Instant;    
    createdBy: EntitySummaryDto;
    routePoints?: PourNoteRoutePointsDto[] | undefined;
    includeRoutePoints?: boolean;
    includeRiseRate?: boolean;
}

export function makePourNoteDto (model: PourNoteDto): PourNoteDto {
  return {
      ...makeEntityDtoOfString(model),
    approvers: (model.approvers?.map((item) => makePourNoteApprovalDto(item))),
    activeApprovers: (model.activeApprovers?.map((item) => makePourNoteApprovalDto(item))),
    status: model.status ? makePourNoteStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateDtoOfPourNoteStatus(item))),
    file: model.file ? makeEntitySummaryDto(model.file) : model.file,
    finalizedFile: model.finalizedFile ? makeEntitySummaryDto(model.finalizedFile) : model.finalizedFile,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    createdBy: model.createdBy ? makeEntitySummaryDto(model.createdBy) : model.createdBy,
    routePoints: (model.routePoints?.map((item) => makePourNoteRoutePointsDto(item))),
    includeRoutePoints: model.includeRoutePoints,
    includeRiseRate: model.includeRiseRate,
  };
}

makeFunctions.PourNoteDto = makePourNoteDto;

export interface PourNoteApprovalDto {
    email: string;
    name: string;
    signatureFile?: EntitySummaryDto | undefined;
    status: PourNoteApprovalStatus;
    statusUpdates: StatusUpdateDtoOfPourNoteApprovalStatus[];
    messages: MessageStatus[];
    lastMessage?: MessageStatus | undefined;
    comment?: string | undefined;
}

export function makePourNoteApprovalDto (model: PourNoteApprovalDto): PourNoteApprovalDto {
  return {
    email: model.email,
    name: model.name,
    signatureFile: model.signatureFile ? makeEntitySummaryDto(model.signatureFile) : model.signatureFile,
    status: model.status ? makePourNoteApprovalStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateDtoOfPourNoteApprovalStatus(item))),
    messages: (model.messages?.map((item) => makeMessageStatus(item))),
    lastMessage: model.lastMessage ? makeMessageStatus(model.lastMessage) : model.lastMessage,
    comment: model.comment,
  };
}

makeFunctions.PourNoteApprovalDto = makePourNoteApprovalDto;

export enum PourNoteApprovalStatus {
    Created = 0,
    AwaitingApproval = 10,
    Approved = 20,
    Reject = 30,
    Removed = -10,
}

function makePourNoteApprovalStatus (value: PourNoteApprovalStatus): PourNoteApprovalStatus {
  return value;
}

makeFunctions.PourNoteApprovalStatus = makePourNoteApprovalStatus;

export interface StatusUpdateDtoOfPourNoteApprovalStatus {
    status?: PourNoteApprovalStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryDto | undefined;
}

export function makeStatusUpdateDtoOfPourNoteApprovalStatus (model: StatusUpdateDtoOfPourNoteApprovalStatus): StatusUpdateDtoOfPourNoteApprovalStatus {
  return {
    status: model.status ? makePourNoteApprovalStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryDto(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateDtoOfPourNoteApprovalStatus = makeStatusUpdateDtoOfPourNoteApprovalStatus;

export interface MessageStatus {
    messageId: string;
    /** NodaTimeType:Instant */
    created: Instant;    
    /** NodaTimeType:Instant */
    sent?: Instant | undefined;    
    sendError?: string | undefined;
}

export function makeMessageStatus (model: MessageStatus): MessageStatus {
  return {
    messageId: model.messageId,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    sent: model.sent && typeof model.sent === 'string' ? makeInstant(model.sent) : model.sent,
    sendError: model.sendError,
  };
}

makeFunctions.MessageStatus = makeMessageStatus;

export enum PourNoteStatus {
    Generated = 0,
    AwaitingApproval = 10,
    Approved = 20,
    Reject = 30,
    Voided = -10,
}

function makePourNoteStatus (value: PourNoteStatus): PourNoteStatus {
  return value;
}

makeFunctions.PourNoteStatus = makePourNoteStatus;

export interface StatusUpdateDtoOfPourNoteStatus {
    status?: PourNoteStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryDto | undefined;
}

export function makeStatusUpdateDtoOfPourNoteStatus (model: StatusUpdateDtoOfPourNoteStatus): StatusUpdateDtoOfPourNoteStatus {
  return {
    status: model.status ? makePourNoteStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryDto(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateDtoOfPourNoteStatus = makeStatusUpdateDtoOfPourNoteStatus;

export interface PourNoteRoutePointsDto {
    distanceFromPump?: number;
    pipeDownstreamName?: string | undefined;
    pipeUpstreamName?: string | undefined;
    pointId?: string | undefined;
    point?: Point3DDto | undefined;
    pressure?: number;
    minPressure?: number | undefined;
    maxPressure?: number | undefined;
    pitName?: string | undefined;
    /** One entry per flow rate target on the recipe, in the order they were defined. */
    targetPressures?: PourNoteTargetPressureDto[] | undefined;
}

export function makePourNoteRoutePointsDto (model: PourNoteRoutePointsDto): PourNoteRoutePointsDto {
  return {
    distanceFromPump: model.distanceFromPump,
    pipeDownstreamName: model.pipeDownstreamName,
    pipeUpstreamName: model.pipeUpstreamName,
    pointId: model.pointId,
    point: model.point ? makePoint3DDto(model.point) : model.point,
    pressure: model.pressure,
    minPressure: model.minPressure,
    maxPressure: model.maxPressure,
    pitName: model.pitName,
    targetPressures: (model.targetPressures?.map((item) => makePourNoteTargetPressureDto(item))),
  };
}

makeFunctions.PourNoteRoutePointsDto = makePourNoteRoutePointsDto;

export interface Point3DDto {
    x: number;
    y: number;
    z: number;
}

export function makePoint3DDto (model: Point3DDto): Point3DDto {
  return {
    x: model.x,
    y: model.y,
    z: model.z,
  };
}

makeFunctions.Point3DDto = makePoint3DDto;

export interface PourNoteTargetPressureDto {
    /** Target flow rate in m³/h (canonical); converted for display only. */
    flowRate?: number;
    pressure?: number | undefined;
}

export function makePourNoteTargetPressureDto (model: PourNoteTargetPressureDto): PourNoteTargetPressureDto {
  return {
    flowRate: model.flowRate,
    pressure: model.pressure,
  };
}

makeFunctions.PourNoteTargetPressureDto = makePourNoteTargetPressureDto;

export interface PourDataDto {
    operatorLogNoteFile?: EntitySummaryDto | undefined;
    /** NodaTimeType:ZonedDateTime */
    pourCompletedDate: ZonedDateTime;    
    dryTonnage?: number | undefined;
    massConcentration?: number | undefined;
    binderContent?: number | undefined;
    volume?: number | undefined;
    totalBinder?: number | undefined;
    binderTailingsRatio?: number | undefined;
    volumeRetainedAfterOutflow?: number | undefined;
    comments?: string | undefined;
    ucsAverage?: number | undefined;
}

export function makePourDataDto (model: PourDataDto): PourDataDto {
  return {
    operatorLogNoteFile: model.operatorLogNoteFile ? makeEntitySummaryDto(model.operatorLogNoteFile) : model.operatorLogNoteFile,
    pourCompletedDate: model.pourCompletedDate && typeof model.pourCompletedDate === 'string' ? makeZonedDateTime(model.pourCompletedDate) : model.pourCompletedDate,
    dryTonnage: model.dryTonnage,
    massConcentration: model.massConcentration,
    binderContent: model.binderContent,
    volume: model.volume,
    totalBinder: model.totalBinder,
    binderTailingsRatio: model.binderTailingsRatio,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
    comments: model.comments,
    ucsAverage: model.ucsAverage,
  };
}

makeFunctions.PourDataDto = makePourDataDto;

export interface Entity {
}

export function makeEntity (model: Entity): Entity {
  return {
  };
}

makeFunctions.Entity = makeEntity;

export interface EntityOfAccessTokenId extends Entity {
    entityId?: AccessTokenId | undefined;
}

export function makeEntityOfAccessTokenId (model: EntityOfAccessTokenId): EntityOfAccessTokenId {
  return {
      ...makeEntity(model),
    entityId: model.entityId ? makeAccessTokenId(model.entityId) : model.entityId,
  };
}

makeFunctions.EntityOfAccessTokenId = makeEntityOfAccessTokenId;

export interface AccessToken extends EntityOfAccessTokenId {
    personalKey?: string | undefined;
    /** NodaTimeType:Instant */
    validUntil?: Instant;    
}

export function makeAccessToken (model: AccessToken): AccessToken {
  return {
      ...makeEntityOfAccessTokenId(model),
    personalKey: model.personalKey,
    validUntil: model.validUntil && typeof model.validUntil === 'string' ? makeInstant(model.validUntil) : model.validUntil,
  };
}

makeFunctions.AccessToken = makeAccessToken;

export interface ValueObjectOfAccessTokenId {
}

export function makeValueObjectOfAccessTokenId (model: ValueObjectOfAccessTokenId): ValueObjectOfAccessTokenId {
  return {
  };
}

makeFunctions.ValueObjectOfAccessTokenId = makeValueObjectOfAccessTokenId;

export interface EntityIdOfAccessTokenId extends ValueObjectOfAccessTokenId {
    value?: string | undefined;
}

export function makeEntityIdOfAccessTokenId (model: EntityIdOfAccessTokenId): EntityIdOfAccessTokenId {
  return {
      ...makeValueObjectOfAccessTokenId(model),
    value: model.value,
  };
}

makeFunctions.EntityIdOfAccessTokenId = makeEntityIdOfAccessTokenId;

export interface AccessTokenId extends EntityIdOfAccessTokenId {
}

export function makeAccessTokenId (model: AccessTokenId): AccessTokenId {
  return {
      ...makeEntityIdOfAccessTokenId(model),
  };
}

makeFunctions.AccessTokenId = makeAccessTokenId;

export interface PourDocument {
    fileName?: string | undefined;
    contentType?: string | undefined;
    content?: string | undefined;
}

export function makePourDocument (model: PourDocument): PourDocument {
  return {
    fileName: model.fileName,
    contentType: model.contentType,
    content: model.content,
  };
}

makeFunctions.PourDocument = makePourDocument;

export interface PipeFrictionDataDto {
    pipeName?: string | undefined;
    pipeId?: string | undefined;
    frictionLoss?: number;
    velocity?: number;
    insideDiameter?: number;
}

export function makePipeFrictionDataDto (model: PipeFrictionDataDto): PipeFrictionDataDto {
  return {
    pipeName: model.pipeName,
    pipeId: model.pipeId,
    frictionLoss: model.frictionLoss,
    velocity: model.velocity,
    insideDiameter: model.insideDiameter,
  };
}

makeFunctions.PipeFrictionDataDto = makePipeFrictionDataDto;

export interface RheologyDataDto {
    rheologyDataSetId: string;
    version: string;
    reference: string;
    /** NodaTimeType:Instant */
    generated: Instant;    
    ucsCoefficients: { [key: string]: UcsCoefficientsDto; };
    mixerCoefficients: MixerCoefficientsDto;
    pumpPressure: PumpPressureDto;
    tailingsDrySolidsDensity: number;
    carrierFluidDensity: number;
    binderDryParticleDensity: number;
    heightOfCylinder: number;
    yieldStressCoefficients: YieldStressCoefficientsDto;
    binder: BinderDto;
    tonnage: TonnageDto;
    viscosityCoefficients: ViscosityCoefficientsDto;
    massConcentration: MassConcentrationDto;
    frictionLossFactorOfSafety?: number;
    isComplete?: boolean;
    isDeactivated?: boolean;
}

export function makeRheologyDataDto (model: RheologyDataDto): RheologyDataDto {
  return {
    rheologyDataSetId: model.rheologyDataSetId,
    version: model.version,
    reference: model.reference,
    generated: model.generated && typeof model.generated === 'string' ? makeInstant(model.generated) : model.generated,
    ucsCoefficients: !model.ucsCoefficients ? model.ucsCoefficients : Object.keys(model.ucsCoefficients)?.reduce((acc, key) => ({...acc, [key]: makeUcsCoefficientsDto(model.ucsCoefficients![key]) }), {}),
    mixerCoefficients: model.mixerCoefficients ? makeMixerCoefficientsDto(model.mixerCoefficients) : model.mixerCoefficients,
    pumpPressure: model.pumpPressure ? makePumpPressureDto(model.pumpPressure) : model.pumpPressure,
    tailingsDrySolidsDensity: model.tailingsDrySolidsDensity,
    carrierFluidDensity: model.carrierFluidDensity,
    binderDryParticleDensity: model.binderDryParticleDensity,
    heightOfCylinder: model.heightOfCylinder,
    yieldStressCoefficients: model.yieldStressCoefficients ? makeYieldStressCoefficientsDto(model.yieldStressCoefficients) : model.yieldStressCoefficients,
    binder: model.binder ? makeBinderDto(model.binder) : model.binder,
    tonnage: model.tonnage ? makeTonnageDto(model.tonnage) : model.tonnage,
    viscosityCoefficients: model.viscosityCoefficients ? makeViscosityCoefficientsDto(model.viscosityCoefficients) : model.viscosityCoefficients,
    massConcentration: model.massConcentration ? makeMassConcentrationDto(model.massConcentration) : model.massConcentration,
    frictionLossFactorOfSafety: model.frictionLossFactorOfSafety,
    isComplete: model.isComplete,
    isDeactivated: model.isDeactivated,
  };
}

makeFunctions.RheologyDataDto = makeRheologyDataDto;

export interface UcsCoefficientsDto {
    coefficient1: number;
    coefficient2: number;
    minUCS?: number | undefined;
    maxUCS?: number | undefined;
}

export function makeUcsCoefficientsDto (model: UcsCoefficientsDto): UcsCoefficientsDto {
  return {
    coefficient1: model.coefficient1,
    coefficient2: model.coefficient2,
    minUCS: model.minUCS,
    maxUCS: model.maxUCS,
  };
}

makeFunctions.UcsCoefficientsDto = makeUcsCoefficientsDto;

export interface MixerCoefficientsDto {
    continuousMixerCoefficientM?: number;
    continuousMixerCoefficientN?: number;
    continuousMixerCoefficientD?: number;
    continuousMixerCoefficientC?: number | undefined;
    batchMixerCoefficientM?: number;
    batchMixerCoefficientN?: number;
    batchMixerCoefficientD?: number;
}

export function makeMixerCoefficientsDto (model: MixerCoefficientsDto): MixerCoefficientsDto {
  return {
    continuousMixerCoefficientM: model.continuousMixerCoefficientM,
    continuousMixerCoefficientN: model.continuousMixerCoefficientN,
    continuousMixerCoefficientD: model.continuousMixerCoefficientD,
    continuousMixerCoefficientC: model.continuousMixerCoefficientC,
    batchMixerCoefficientM: model.batchMixerCoefficientM,
    batchMixerCoefficientN: model.batchMixerCoefficientN,
    batchMixerCoefficientD: model.batchMixerCoefficientD,
  };
}

makeFunctions.MixerCoefficientsDto = makeMixerCoefficientsDto;

export interface PumpPressureDto {
    max: number;
    default: number;
}

export function makePumpPressureDto (model: PumpPressureDto): PumpPressureDto {
  return {
    max: model.max,
    default: model.default,
  };
}

makeFunctions.PumpPressureDto = makePumpPressureDto;

export interface YieldStressCoefficientsDto {
    coefficient1: number;
    coefficient2: number;
}

export function makeYieldStressCoefficientsDto (model: YieldStressCoefficientsDto): YieldStressCoefficientsDto {
  return {
    coefficient1: model.coefficient1,
    coefficient2: model.coefficient2,
  };
}

makeFunctions.YieldStressCoefficientsDto = makeYieldStressCoefficientsDto;

export interface BinderDto {
    min: number;
    max: number;
    interval: number;
}

export function makeBinderDto (model: BinderDto): BinderDto {
  return {
    min: model.min,
    max: model.max,
    interval: model.interval,
  };
}

makeFunctions.BinderDto = makeBinderDto;

export interface TonnageDto {
    min: number;
    max: number;
    interval: number;
    default: number;
}

export function makeTonnageDto (model: TonnageDto): TonnageDto {
  return {
    min: model.min,
    max: model.max,
    interval: model.interval,
    default: model.default,
  };
}

makeFunctions.TonnageDto = makeTonnageDto;

export interface ViscosityCoefficientsDto {
    coefficient1: number;
    coefficient2: number;
}

export function makeViscosityCoefficientsDto (model: ViscosityCoefficientsDto): ViscosityCoefficientsDto {
  return {
    coefficient1: model.coefficient1,
    coefficient2: model.coefficient2,
  };
}

makeFunctions.ViscosityCoefficientsDto = makeViscosityCoefficientsDto;

export interface MassConcentrationDto {
    min: number;
    max: number;
    interval: number;
}

export function makeMassConcentrationDto (model: MassConcentrationDto): MassConcentrationDto {
  return {
    min: model.min,
    max: model.max,
    interval: model.interval,
  };
}

makeFunctions.MassConcentrationDto = makeMassConcentrationDto;

export interface StopeDataDto {
    stopeId: string;
    stopeName: string;
    references: string[];
    pipeArrays?: StopePipeArray[] | undefined;
    volume: number;
    level?: string | undefined;
    area?: string | undefined;
    /** NodaTimeType:Instant */
    physicalPropertiesUpdated: Instant;    
    /** NodaTimeType:Instant */
    routeUpdated: Instant;    
    pourPresetGroupId?: string | undefined;
    stopeGeometryFile?: ImageSummary | undefined;
    documents?: StopeDocument[] | undefined;
    /** NodaTimeType:LocalDate */
    startDate?: LocalDate | undefined;    
    /** NodaTimeType:LocalDate */
    endDate?: LocalDate | undefined;    
    pour?: Pour[] | undefined;
}

export function makeStopeDataDto (model: StopeDataDto): StopeDataDto {
  return {
    stopeId: model.stopeId,
    stopeName: model.stopeName,
    references: model.references,
    pipeArrays: (model.pipeArrays?.map((item) => makeStopePipeArray(item))),
    volume: model.volume,
    level: model.level,
    area: model.area,
    physicalPropertiesUpdated: model.physicalPropertiesUpdated && typeof model.physicalPropertiesUpdated === 'string' ? makeInstant(model.physicalPropertiesUpdated) : model.physicalPropertiesUpdated,
    routeUpdated: model.routeUpdated && typeof model.routeUpdated === 'string' ? makeInstant(model.routeUpdated) : model.routeUpdated,
    pourPresetGroupId: model.pourPresetGroupId,
    stopeGeometryFile: model.stopeGeometryFile ? makeImageSummary(model.stopeGeometryFile) : model.stopeGeometryFile,
    documents: (model.documents?.map((item) => makeStopeDocument(item))),
    startDate: model.startDate && typeof model.startDate === 'string' ? makeLocalDate(model.startDate) : model.startDate,
    endDate: model.endDate && typeof model.endDate === 'string' ? makeLocalDate(model.endDate) : model.endDate,
    pour: (model.pour?.map((item) => makePour(item))),
  };
}

makeFunctions.StopeDataDto = makeStopeDataDto;

export interface StopePipeArray {
    pipeId?: PipeId | undefined;
    pipeVerticalLength?: number;
    pipeHorizontalLength?: number;
}

export function makeStopePipeArray (model: StopePipeArray): StopePipeArray {
  return {
    pipeId: model.pipeId ? makePipeId(model.pipeId) : model.pipeId,
    pipeVerticalLength: model.pipeVerticalLength,
    pipeHorizontalLength: model.pipeHorizontalLength,
  };
}

makeFunctions.StopePipeArray = makeStopePipeArray;

export interface ValueObjectOfPipeId {
}

export function makeValueObjectOfPipeId (model: ValueObjectOfPipeId): ValueObjectOfPipeId {
  return {
  };
}

makeFunctions.ValueObjectOfPipeId = makeValueObjectOfPipeId;

export interface ItemIdOfPipeId extends ValueObjectOfPipeId {
    value?: string | undefined;
}

export function makeItemIdOfPipeId (model: ItemIdOfPipeId): ItemIdOfPipeId {
  return {
      ...makeValueObjectOfPipeId(model),
    value: model.value,
  };
}

makeFunctions.ItemIdOfPipeId = makeItemIdOfPipeId;

export interface PipeId extends ItemIdOfPipeId {
}

export function makePipeId (model: PipeId): PipeId {
  return {
      ...makeItemIdOfPipeId(model),
  };
}

makeFunctions.PipeId = makePipeId;

export interface ImageSummary {
    path?: string | undefined;
    display?: string | undefined;
}

export function makeImageSummary (model: ImageSummary): ImageSummary {
  return {
    path: model.path,
    display: model.display,
  };
}

makeFunctions.ImageSummary = makeImageSummary;

export interface StopeDocument {
    fileName?: string | undefined;
    contentType?: string | undefined;
    content?: string | undefined;
}

export function makeStopeDocument (model: StopeDocument): StopeDocument {
  return {
    fileName: model.fileName,
    contentType: model.contentType,
    content: model.content,
  };
}

makeFunctions.StopeDocument = makeStopeDocument;

export interface EntityOfPourId extends Entity {
    entityId?: PourId | undefined;
}

export function makeEntityOfPourId (model: EntityOfPourId): EntityOfPourId {
  return {
      ...makeEntity(model),
    entityId: model.entityId ? makePourId(model.entityId) : model.entityId,
  };
}

makeFunctions.EntityOfPourId = makeEntityOfPourId;

export interface Pour extends EntityOfPourId {
    reference?: string | undefined;
    rheologyDataSetId?: string | undefined;
    rheologyDataSetReference?: string | undefined;
    rheologyDataSetVersion?: string | undefined;
    recipeId?: string | undefined;
    isDeleted?: boolean;
    scenarioId?: string | undefined;
    isAutoPour?: boolean;
    autoPourBatchId?: number;
    isRockFill?: boolean;
    /** This was the reference on the recipe at the time of creation. The recipe may have changed name and or values since so this carries little meaning */
    recipeReference?: string | undefined;
    status?: PourStatus;
    statusUpdates?: StatusUpdateOfPourStatus[] | undefined;
    /** NodaTimeType:ZonedDateTime */
    intendedPourDate?: ZonedDateTime;    
    volume?: number;
    stopeIdentifier?: StopeIdentifier | undefined;
    pasteSpecification?: PasteBackfillSpecification | undefined;
    pasteOptimisedSpecification?: PasteRecipeSpecification | undefined;
    pasteSelectedSpecification?: PasteRecipeSpecification | undefined;
    pasteSlackFlowSpecification?: PasteRecipeSpecification | undefined;
    pasteMaxPressureSpecification?: PasteRecipeSpecification | undefined;
    hydraulicSpecification?: HydraulicBackfillSpecification | undefined;
    hydraulicOptimisedSpecification?: HydraulicRecipeSpecification | undefined;
    hydraulicSelectedSpecification?: HydraulicRecipeSpecification | undefined;
    volumeRetainedAfterOutflow?: number | undefined;
    pourPositionX?: number | undefined;
    pourPositionY?: number | undefined;
    pourHeight?: number | undefined;
    pasteBeachAngleDegrees?: number | undefined;
    flushRecipeId?: string | undefined;
    flushRecipeReference?: string | undefined;
    flushSpecification?: FlushSpecification | undefined;
    flushResult?: FlushResult | undefined;
    warnings?: BackfillWarning[] | undefined;
    spoolIds?: SpoolId[] | undefined;
    routeSpoolIds?: SpoolId[] | undefined;
    pipeFrictionDataItems?: PipeFrictionData[] | undefined;
    pourNote?: PourNote | undefined;
    archivedPourNotes?: PourNote[] | undefined;
    pourData?: PourData | undefined;
    pourPresetId?: string | undefined;
    accessTokens?: AccessToken[] | undefined;
    documents?: PourDocument[] | undefined;
}

export function makePour (model: Pour): Pour {
  return {
      ...makeEntityOfPourId(model),
    reference: model.reference,
    rheologyDataSetId: model.rheologyDataSetId,
    rheologyDataSetReference: model.rheologyDataSetReference,
    rheologyDataSetVersion: model.rheologyDataSetVersion,
    recipeId: model.recipeId,
    isDeleted: model.isDeleted,
    scenarioId: model.scenarioId,
    isAutoPour: model.isAutoPour,
    autoPourBatchId: model.autoPourBatchId,
    isRockFill: model.isRockFill,
    recipeReference: model.recipeReference,
    status: model.status ? makePourStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateOfPourStatus(item))),
    intendedPourDate: model.intendedPourDate && typeof model.intendedPourDate === 'string' ? makeZonedDateTime(model.intendedPourDate) : model.intendedPourDate,
    volume: model.volume,
    stopeIdentifier: model.stopeIdentifier ? makeStopeIdentifier(model.stopeIdentifier) : model.stopeIdentifier,
    pasteSpecification: model.pasteSpecification ? makePasteBackfillSpecification(model.pasteSpecification) : model.pasteSpecification,
    pasteOptimisedSpecification: model.pasteOptimisedSpecification ? makePasteRecipeSpecification(model.pasteOptimisedSpecification) : model.pasteOptimisedSpecification,
    pasteSelectedSpecification: model.pasteSelectedSpecification ? makePasteRecipeSpecification(model.pasteSelectedSpecification) : model.pasteSelectedSpecification,
    pasteSlackFlowSpecification: model.pasteSlackFlowSpecification ? makePasteRecipeSpecification(model.pasteSlackFlowSpecification) : model.pasteSlackFlowSpecification,
    pasteMaxPressureSpecification: model.pasteMaxPressureSpecification ? makePasteRecipeSpecification(model.pasteMaxPressureSpecification) : model.pasteMaxPressureSpecification,
    hydraulicSpecification: model.hydraulicSpecification ? makeHydraulicBackfillSpecification(model.hydraulicSpecification) : model.hydraulicSpecification,
    hydraulicOptimisedSpecification: model.hydraulicOptimisedSpecification ? makeHydraulicRecipeSpecification(model.hydraulicOptimisedSpecification) : model.hydraulicOptimisedSpecification,
    hydraulicSelectedSpecification: model.hydraulicSelectedSpecification ? makeHydraulicRecipeSpecification(model.hydraulicSelectedSpecification) : model.hydraulicSelectedSpecification,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
    pourPositionX: model.pourPositionX,
    pourPositionY: model.pourPositionY,
    pourHeight: model.pourHeight,
    pasteBeachAngleDegrees: model.pasteBeachAngleDegrees,
    flushRecipeId: model.flushRecipeId,
    flushRecipeReference: model.flushRecipeReference,
    flushSpecification: model.flushSpecification ? makeFlushSpecification(model.flushSpecification) : model.flushSpecification,
    flushResult: model.flushResult ? makeFlushResult(model.flushResult) : model.flushResult,
    warnings: (model.warnings?.map((item) => makeBackfillWarning(item))),
    spoolIds: (model.spoolIds?.map((item) => makeSpoolId(item))),
    routeSpoolIds: (model.routeSpoolIds?.map((item) => makeSpoolId(item))),
    pipeFrictionDataItems: (model.pipeFrictionDataItems?.map((item) => makePipeFrictionData(item))),
    pourNote: model.pourNote ? makePourNote(model.pourNote) : model.pourNote,
    archivedPourNotes: (model.archivedPourNotes?.map((item) => makePourNote(item))),
    pourData: model.pourData ? makePourData(model.pourData) : model.pourData,
    pourPresetId: model.pourPresetId,
    accessTokens: (model.accessTokens?.map((item) => makeAccessToken(item))),
    documents: (model.documents?.map((item) => makePourDocument(item))),
  };
}

makeFunctions.Pour = makePour;

export interface StatusUpdateOfPourStatus {
    status?: PourStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryOfString | undefined;
}

export function makeStatusUpdateOfPourStatus (model: StatusUpdateOfPourStatus): StatusUpdateOfPourStatus {
  return {
    status: model.status ? makePourStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryOfString(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateOfPourStatus = makeStatusUpdateOfPourStatus;

export interface EntitySummaryOfString {
    entityId?: string | undefined;
    display?: string | undefined;
}

export function makeEntitySummaryOfString (model: EntitySummaryOfString): EntitySummaryOfString {
  return {
    entityId: model.entityId,
    display: model.display,
  };
}

makeFunctions.EntitySummaryOfString = makeEntitySummaryOfString;

export interface ValueObjectOfStopeIdentifier {
}

export function makeValueObjectOfStopeIdentifier (model: ValueObjectOfStopeIdentifier): ValueObjectOfStopeIdentifier {
  return {
  };
}

makeFunctions.ValueObjectOfStopeIdentifier = makeValueObjectOfStopeIdentifier;

export interface StopeIdentifier extends ValueObjectOfStopeIdentifier {
    mineModelId?: EntityId | undefined;
    stopeId?: string | undefined;
}

export function makeStopeIdentifier (model: StopeIdentifier): StopeIdentifier {
  return {
      ...makeValueObjectOfStopeIdentifier(model),
    mineModelId: model.mineModelId ? makeEntityId(model.mineModelId) : model.mineModelId,
    stopeId: model.stopeId,
  };
}

makeFunctions.StopeIdentifier = makeStopeIdentifier;

export interface ValueObjectOfEntityId {
}

export function makeValueObjectOfEntityId (model: ValueObjectOfEntityId): ValueObjectOfEntityId {
  return {
  };
}

makeFunctions.ValueObjectOfEntityId = makeValueObjectOfEntityId;

export interface EntityIdOfEntityId extends ValueObjectOfEntityId {
    value?: string | undefined;
}

export function makeEntityIdOfEntityId (model: EntityIdOfEntityId): EntityIdOfEntityId {
  return {
      ...makeValueObjectOfEntityId(model),
    value: model.value,
  };
}

makeFunctions.EntityIdOfEntityId = makeEntityIdOfEntityId;

export interface EntityId extends EntityIdOfEntityId {
}

export function makeEntityId (model: EntityId): EntityId {
  return {
      ...makeEntityIdOfEntityId(model),
  };
}

makeFunctions.EntityId = makeEntityId;

export interface ValueObjectOfPasteBackfillSpecification {
}

export function makeValueObjectOfPasteBackfillSpecification (model: ValueObjectOfPasteBackfillSpecification): ValueObjectOfPasteBackfillSpecification {
  return {
  };
}

makeFunctions.ValueObjectOfPasteBackfillSpecification = makeValueObjectOfPasteBackfillSpecification;

export interface PasteBackfillSpecification extends ValueObjectOfPasteBackfillSpecification {
    targetUCSStrength?: number;
    targetDays?: number;
    throughput?: number;
    pumpPressure?: number;
    throughputControlType?: ThroughputControlType;
}

export function makePasteBackfillSpecification (model: PasteBackfillSpecification): PasteBackfillSpecification {
  return {
      ...makeValueObjectOfPasteBackfillSpecification(model),
    targetUCSStrength: model.targetUCSStrength,
    targetDays: model.targetDays,
    throughput: model.throughput,
    pumpPressure: model.pumpPressure,
    throughputControlType: model.throughputControlType ? makeThroughputControlType(model.throughputControlType) : model.throughputControlType,
  };
}

makeFunctions.PasteBackfillSpecification = makePasteBackfillSpecification;

export interface ValueObjectOfPasteRecipeSpecification {
}

export function makeValueObjectOfPasteRecipeSpecification (model: ValueObjectOfPasteRecipeSpecification): ValueObjectOfPasteRecipeSpecification {
  return {
  };
}

makeFunctions.ValueObjectOfPasteRecipeSpecification = makeValueObjectOfPasteRecipeSpecification;

export interface PasteRecipeSpecification extends ValueObjectOfPasteRecipeSpecification {
    massConcentration?: number;
    binderContent?: number;
    ucsStrength?: number;
    /** Pump Pressure in Bar */
    pumpPressure?: number;
}

export function makePasteRecipeSpecification (model: PasteRecipeSpecification): PasteRecipeSpecification {
  return {
      ...makeValueObjectOfPasteRecipeSpecification(model),
    massConcentration: model.massConcentration,
    binderContent: model.binderContent,
    ucsStrength: model.ucsStrength,
    pumpPressure: model.pumpPressure,
  };
}

makeFunctions.PasteRecipeSpecification = makePasteRecipeSpecification;

export interface ValueObjectOfHydraulicBackfillSpecification {
}

export function makeValueObjectOfHydraulicBackfillSpecification (model: ValueObjectOfHydraulicBackfillSpecification): ValueObjectOfHydraulicBackfillSpecification {
  return {
  };
}

makeFunctions.ValueObjectOfHydraulicBackfillSpecification = makeValueObjectOfHydraulicBackfillSpecification;

export interface HydraulicBackfillSpecification extends ValueObjectOfHydraulicBackfillSpecification {
    binderTailingsRatio?: number;
    throughput?: number;
    throughputControlType?: ThroughputControlType;
}

export function makeHydraulicBackfillSpecification (model: HydraulicBackfillSpecification): HydraulicBackfillSpecification {
  return {
      ...makeValueObjectOfHydraulicBackfillSpecification(model),
    binderTailingsRatio: model.binderTailingsRatio,
    throughput: model.throughput,
    throughputControlType: model.throughputControlType ? makeThroughputControlType(model.throughputControlType) : model.throughputControlType,
  };
}

makeFunctions.HydraulicBackfillSpecification = makeHydraulicBackfillSpecification;

export interface ValueObjectOfHydraulicRecipeSpecification {
}

export function makeValueObjectOfHydraulicRecipeSpecification (model: ValueObjectOfHydraulicRecipeSpecification): ValueObjectOfHydraulicRecipeSpecification {
  return {
  };
}

makeFunctions.ValueObjectOfHydraulicRecipeSpecification = makeValueObjectOfHydraulicRecipeSpecification;

export interface HydraulicRecipeSpecification extends ValueObjectOfHydraulicRecipeSpecification {
    massConcentration?: number;
    settlingVelocity?: number;
    minVelocity?: number;
    maxPipePressure?: number;
}

export function makeHydraulicRecipeSpecification (model: HydraulicRecipeSpecification): HydraulicRecipeSpecification {
  return {
      ...makeValueObjectOfHydraulicRecipeSpecification(model),
    massConcentration: model.massConcentration,
    settlingVelocity: model.settlingVelocity,
    minVelocity: model.minVelocity,
    maxPipePressure: model.maxPipePressure,
  };
}

makeFunctions.HydraulicRecipeSpecification = makeHydraulicRecipeSpecification;

export interface ValueObjectOfFlushSpecification {
}

export function makeValueObjectOfFlushSpecification (model: ValueObjectOfFlushSpecification): ValueObjectOfFlushSpecification {
  return {
  };
}

makeFunctions.ValueObjectOfFlushSpecification = makeValueObjectOfFlushSpecification;

/** The inputs to a flush plan. Pressures are in bar and flow rates in m³/h, the same conventions as the project's flushing defaults and the recipe specifications. */
export interface FlushSpecification extends ValueObjectOfFlushSpecification {
    /** Bar. */
    flushPumpMaxPressure?: number;
    /** m³/h. */
    flushPumpFlowRate?: number;
    /** m³/h. The paste pump pushes the first water at the paste's own rate. */
    pastePumpFlowRate?: number;
    airFlushEnabled?: boolean;
    /** Bar. Null when the air purge is disabled. */
    airFlushMaxPressure?: number | undefined;
    volumeMode?: FlushVolumeMode;
    /** The number that accompanies the mode: m³, a multiple, or metres, as the mode dictates. */
    volumeValue?: number;
}

export function makeFlushSpecification (model: FlushSpecification): FlushSpecification {
  return {
      ...makeValueObjectOfFlushSpecification(model),
    flushPumpMaxPressure: model.flushPumpMaxPressure,
    flushPumpFlowRate: model.flushPumpFlowRate,
    pastePumpFlowRate: model.pastePumpFlowRate,
    airFlushEnabled: model.airFlushEnabled,
    airFlushMaxPressure: model.airFlushMaxPressure,
    volumeMode: model.volumeMode ? makeFlushVolumeMode(model.volumeMode) : model.volumeMode,
    volumeValue: model.volumeValue,
  };
}

makeFunctions.FlushSpecification = makeFlushSpecification;

export interface ValueObjectOfFlushResult {
}

export function makeValueObjectOfFlushResult (model: ValueObjectOfFlushResult): ValueObjectOfFlushResult {
  return {
  };
}

makeFunctions.ValueObjectOfFlushResult = makeValueObjectOfFlushResult;

/** The outputs of the SPA's flush solver, snapshotted at save time. Volumes are m³, distances are metres down the line from the plant, pressures are bar and times are minutes from the start of the flush. */
export interface FlushResult extends ValueObjectOfFlushResult {
    totalLineVolume?: number;
    totalLineLength?: number;
    finalFlushVolume?: number;
    pastePumpWaterVolume?: number;
    pastePumpHandoverDistance?: number;
    flushPumpCanCompleteAlone?: boolean;
    airStartWaterVolume?: number | undefined;
    airStartDistance?: number | undefined;
    airStartTimeMinutes?: number | undefined;
    airStartStage?: FlushStageType | undefined;
    timeToWaterAtStopeMinutes?: number | undefined;
    waterAtStopeStage?: FlushStageType | undefined;
    waterFrontStopDistance?: number;
    maxRequiredPressure?: number;
    stages?: FlushStage[] | undefined;
    warnings?: FlushWarning[] | undefined;
}

export function makeFlushResult (model: FlushResult): FlushResult {
  return {
      ...makeValueObjectOfFlushResult(model),
    totalLineVolume: model.totalLineVolume,
    totalLineLength: model.totalLineLength,
    finalFlushVolume: model.finalFlushVolume,
    pastePumpWaterVolume: model.pastePumpWaterVolume,
    pastePumpHandoverDistance: model.pastePumpHandoverDistance,
    flushPumpCanCompleteAlone: model.flushPumpCanCompleteAlone,
    airStartWaterVolume: model.airStartWaterVolume,
    airStartDistance: model.airStartDistance,
    airStartTimeMinutes: model.airStartTimeMinutes,
    airStartStage: model.airStartStage ? makeFlushStageType(model.airStartStage) : model.airStartStage,
    timeToWaterAtStopeMinutes: model.timeToWaterAtStopeMinutes,
    waterAtStopeStage: model.waterAtStopeStage ? makeFlushStageType(model.waterAtStopeStage) : model.waterAtStopeStage,
    waterFrontStopDistance: model.waterFrontStopDistance,
    maxRequiredPressure: model.maxRequiredPressure,
    stages: (model.stages?.map((item) => makeFlushStage(item))),
    warnings: (model.warnings?.map((item) => makeFlushWarning(item))),
  };
}

makeFunctions.FlushResult = makeFlushResult;

export interface ValueObjectOfFlushStage {
}

export function makeValueObjectOfFlushStage (model: ValueObjectOfFlushStage): ValueObjectOfFlushStage {
  return {
  };
}

makeFunctions.ValueObjectOfFlushStage = makeValueObjectOfFlushStage;

/** One row of the staged plan. Volumes are cumulative water pumped (m³), distances are metres down the line from the plant, pressures are the required plant pressure (bar) at each end of the stage. */
export interface FlushStage extends ValueObjectOfFlushStage {
    stageType?: FlushStageType;
    startVolume?: number;
    endVolume?: number;
    startDistance?: number;
    endDistance?: number;
    flowRate?: number;
    requiredPressureStart?: number;
    requiredPressureEnd?: number;
    durationMinutes?: number;
}

export function makeFlushStage (model: FlushStage): FlushStage {
  return {
      ...makeValueObjectOfFlushStage(model),
    stageType: model.stageType ? makeFlushStageType(model.stageType) : model.stageType,
    startVolume: model.startVolume,
    endVolume: model.endVolume,
    startDistance: model.startDistance,
    endDistance: model.endDistance,
    flowRate: model.flowRate,
    requiredPressureStart: model.requiredPressureStart,
    requiredPressureEnd: model.requiredPressureEnd,
    durationMinutes: model.durationMinutes,
  };
}

makeFunctions.FlushStage = makeFlushStage;

export interface ValueObjectOfFlushWarning {
}

export function makeValueObjectOfFlushWarning (model: ValueObjectOfFlushWarning): ValueObjectOfFlushWarning {
  return {
  };
}

makeFunctions.ValueObjectOfFlushWarning = makeValueObjectOfFlushWarning;

/** A warning raised by the SPA's flush solver. The code is one of its FlushWarningCode values and the description is the text it displayed when the plan was saved. */
export interface FlushWarning extends ValueObjectOfFlushWarning {
    code?: string | undefined;
    description?: string | undefined;
}

export function makeFlushWarning (model: FlushWarning): FlushWarning {
  return {
      ...makeValueObjectOfFlushWarning(model),
    code: model.code,
    description: model.description,
  };
}

makeFunctions.FlushWarning = makeFlushWarning;

export interface BackfillWarning {
    code?: WarningCode | undefined;
    display?: string | undefined;
}

export function makeBackfillWarning (model: BackfillWarning): BackfillWarning {
  return {
    code: model.code ? makeWarningCode(model.code) : model.code,
    display: model.display,
  };
}

makeFunctions.BackfillWarning = makeBackfillWarning;

export interface ValueObjectOfWarningCode {
}

export function makeValueObjectOfWarningCode (model: ValueObjectOfWarningCode): ValueObjectOfWarningCode {
  return {
  };
}

makeFunctions.ValueObjectOfWarningCode = makeValueObjectOfWarningCode;

export interface WarningCode extends ValueObjectOfWarningCode {
    code?: string | undefined;
}

export function makeWarningCode (model: WarningCode): WarningCode {
  return {
      ...makeValueObjectOfWarningCode(model),
    code: model.code,
  };
}

makeFunctions.WarningCode = makeWarningCode;

export interface ValueObjectOfSpoolId {
}

export function makeValueObjectOfSpoolId (model: ValueObjectOfSpoolId): ValueObjectOfSpoolId {
  return {
  };
}

makeFunctions.ValueObjectOfSpoolId = makeValueObjectOfSpoolId;

export interface ItemIdOfSpoolId extends ValueObjectOfSpoolId {
    value?: string | undefined;
}

export function makeItemIdOfSpoolId (model: ItemIdOfSpoolId): ItemIdOfSpoolId {
  return {
      ...makeValueObjectOfSpoolId(model),
    value: model.value,
  };
}

makeFunctions.ItemIdOfSpoolId = makeItemIdOfSpoolId;

export interface SpoolId extends ItemIdOfSpoolId {
}

export function makeSpoolId (model: SpoolId): SpoolId {
  return {
      ...makeItemIdOfSpoolId(model),
  };
}

makeFunctions.SpoolId = makeSpoolId;

export interface ValueObjectOfPipeFrictionData {
}

export function makeValueObjectOfPipeFrictionData (model: ValueObjectOfPipeFrictionData): ValueObjectOfPipeFrictionData {
  return {
  };
}

makeFunctions.ValueObjectOfPipeFrictionData = makeValueObjectOfPipeFrictionData;

export interface PipeFrictionData extends ValueObjectOfPipeFrictionData {
    pipeName?: string | undefined;
    pipeId?: string | undefined;
    /** Friction loss in kPa/m */
    frictionLoss?: number;
    /** Velocity in m/s */
    velocity?: number;
    /** Inside diameter in m */
    insideDiameter?: number;
}

export function makePipeFrictionData (model: PipeFrictionData): PipeFrictionData {
  return {
      ...makeValueObjectOfPipeFrictionData(model),
    pipeName: model.pipeName,
    pipeId: model.pipeId,
    frictionLoss: model.frictionLoss,
    velocity: model.velocity,
    insideDiameter: model.insideDiameter,
  };
}

makeFunctions.PipeFrictionData = makePipeFrictionData;

export interface EntityOfPourNoteId extends Entity {
    entityId?: PourNoteId | undefined;
}

export function makeEntityOfPourNoteId (model: EntityOfPourNoteId): EntityOfPourNoteId {
  return {
      ...makeEntity(model),
    entityId: model.entityId ? makePourNoteId(model.entityId) : model.entityId,
  };
}

makeFunctions.EntityOfPourNoteId = makeEntityOfPourNoteId;

export interface PourNote extends EntityOfPourNoteId {
    approvers?: PourNoteApproval[] | undefined;
    activeApprovers?: PourNoteApproval[] | undefined;
    file?: EntitySummaryOfFileId | undefined;
    finalizedFile?: EntitySummaryOfFileId | undefined;
    status?: PourNoteStatus;
    statusUpdates?: StatusUpdateOfPourNoteStatus[] | undefined;
    createdBy?: EntitySummaryOfString | undefined;
    routePoints?: PourNoteRoutePoints[] | undefined;
    includeRoutePoints?: boolean;
    includeRiseRate?: boolean;
    language?: string | undefined;
}

export function makePourNote (model: PourNote): PourNote {
  return {
      ...makeEntityOfPourNoteId(model),
    approvers: (model.approvers?.map((item) => makePourNoteApproval(item))),
    activeApprovers: (model.activeApprovers?.map((item) => makePourNoteApproval(item))),
    file: model.file ? makeEntitySummaryOfFileId(model.file) : model.file,
    finalizedFile: model.finalizedFile ? makeEntitySummaryOfFileId(model.finalizedFile) : model.finalizedFile,
    status: model.status ? makePourNoteStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateOfPourNoteStatus(item))),
    createdBy: model.createdBy ? makeEntitySummaryOfString(model.createdBy) : model.createdBy,
    routePoints: (model.routePoints?.map((item) => makePourNoteRoutePoints(item))),
    includeRoutePoints: model.includeRoutePoints,
    includeRiseRate: model.includeRiseRate,
    language: model.language,
  };
}

makeFunctions.PourNote = makePourNote;

export interface PourNoteApproval {
    email?: string | undefined;
    name?: string | undefined;
    comment?: string | undefined;
    messageIds?: EntityId[] | undefined;
    signatureFile?: EntitySummaryOfFileId | undefined;
    status?: PourNoteApprovalStatus;
    statusUpdates?: StatusUpdateOfPourNoteApprovalStatus[] | undefined;
}

export function makePourNoteApproval (model: PourNoteApproval): PourNoteApproval {
  return {
    email: model.email,
    name: model.name,
    comment: model.comment,
    messageIds: (model.messageIds?.map((item) => makeEntityId(item))),
    signatureFile: model.signatureFile ? makeEntitySummaryOfFileId(model.signatureFile) : model.signatureFile,
    status: model.status ? makePourNoteApprovalStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateOfPourNoteApprovalStatus(item))),
  };
}

makeFunctions.PourNoteApproval = makePourNoteApproval;

export interface EntitySummaryOfFileId {
    entityId?: FileId | undefined;
    display?: string | undefined;
}

export function makeEntitySummaryOfFileId (model: EntitySummaryOfFileId): EntitySummaryOfFileId {
  return {
    entityId: model.entityId ? makeFileId(model.entityId) : model.entityId,
    display: model.display,
  };
}

makeFunctions.EntitySummaryOfFileId = makeEntitySummaryOfFileId;

export interface ValueObjectOfFileId {
}

export function makeValueObjectOfFileId (model: ValueObjectOfFileId): ValueObjectOfFileId {
  return {
  };
}

makeFunctions.ValueObjectOfFileId = makeValueObjectOfFileId;

export interface EntityIdOfFileId extends ValueObjectOfFileId {
    value?: string | undefined;
}

export function makeEntityIdOfFileId (model: EntityIdOfFileId): EntityIdOfFileId {
  return {
      ...makeValueObjectOfFileId(model),
    value: model.value,
  };
}

makeFunctions.EntityIdOfFileId = makeEntityIdOfFileId;

export interface FileId extends EntityIdOfFileId {
}

export function makeFileId (model: FileId): FileId {
  return {
      ...makeEntityIdOfFileId(model),
  };
}

makeFunctions.FileId = makeFileId;

export interface StatusUpdateOfPourNoteApprovalStatus {
    status?: PourNoteApprovalStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryOfString | undefined;
}

export function makeStatusUpdateOfPourNoteApprovalStatus (model: StatusUpdateOfPourNoteApprovalStatus): StatusUpdateOfPourNoteApprovalStatus {
  return {
    status: model.status ? makePourNoteApprovalStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryOfString(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateOfPourNoteApprovalStatus = makeStatusUpdateOfPourNoteApprovalStatus;

export interface StatusUpdateOfPourNoteStatus {
    status?: PourNoteStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryOfString | undefined;
}

export function makeStatusUpdateOfPourNoteStatus (model: StatusUpdateOfPourNoteStatus): StatusUpdateOfPourNoteStatus {
  return {
    status: model.status ? makePourNoteStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryOfString(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateOfPourNoteStatus = makeStatusUpdateOfPourNoteStatus;

export interface PourNoteRoutePoints {
    distanceFromPump?: number;
    pipeDownstreamName?: string;
    pipeUpstreamName?: string;
    pointId?: string;
    point?: Point3D;
    pressure?: number;
    minPressure?: number | undefined;
    maxPressure?: number | undefined;
    pitName?: string | undefined;
    /** One entry per flow rate target on the recipe, in the order they were defined. */
    targetPressures?: PourNoteTargetPressure[];
}

export function makePourNoteRoutePoints (model: PourNoteRoutePoints): PourNoteRoutePoints {
  return {
    distanceFromPump: model.distanceFromPump,
    pipeDownstreamName: model.pipeDownstreamName,
    pipeUpstreamName: model.pipeUpstreamName,
    pointId: model.pointId,
    point: model.point ? makePoint3D(model.point) : model.point,
    pressure: model.pressure,
    minPressure: model.minPressure,
    maxPressure: model.maxPressure,
    pitName: model.pitName,
    targetPressures: (model.targetPressures?.map((item) => makePourNoteTargetPressure(item))),
  };
}

makeFunctions.PourNoteRoutePoints = makePourNoteRoutePoints;

export interface ValueObjectOfPoint3D {
}

export function makeValueObjectOfPoint3D (model: ValueObjectOfPoint3D): ValueObjectOfPoint3D {
  return {
  };
}

makeFunctions.ValueObjectOfPoint3D = makeValueObjectOfPoint3D;

export interface Point3D extends ValueObjectOfPoint3D {
    /** One decimal place (m) -10,000,000.00  to 10,000,000.00 */
    x?: number;
    /** One decimal place (m) -10,000,000.00  to 10,000,000.00 */
    y?: number;
    /** One decimal place (m) -10,000,000.00  to 10,000,000.00 */
    z?: number;
}

export function makePoint3D (model: Point3D): Point3D {
  return {
      ...makeValueObjectOfPoint3D(model),
    x: model.x,
    y: model.y,
    z: model.z,
  };
}

makeFunctions.Point3D = makePoint3D;

/** A route point's pressure under a flow rate target. Flow rate targets inherit the optimised recipe's mass concentration and binder, so only the throughput — and therefore the pressure — differs from the nominal case. Rendered alongside Slack / Nom / Max on the note. */
export interface PourNoteTargetPressure {
    /** Target flow rate in m³/h (canonical); converted for display only. */
    flowRate?: number;
    pressure?: number | undefined;
}

export function makePourNoteTargetPressure (model: PourNoteTargetPressure): PourNoteTargetPressure {
  return {
    flowRate: model.flowRate,
    pressure: model.pressure,
  };
}

makeFunctions.PourNoteTargetPressure = makePourNoteTargetPressure;

export interface ValueObjectOfPourNoteId {
}

export function makeValueObjectOfPourNoteId (model: ValueObjectOfPourNoteId): ValueObjectOfPourNoteId {
  return {
  };
}

makeFunctions.ValueObjectOfPourNoteId = makeValueObjectOfPourNoteId;

export interface EntityIdOfPourNoteId extends ValueObjectOfPourNoteId {
    value?: string | undefined;
}

export function makeEntityIdOfPourNoteId (model: EntityIdOfPourNoteId): EntityIdOfPourNoteId {
  return {
      ...makeValueObjectOfPourNoteId(model),
    value: model.value,
  };
}

makeFunctions.EntityIdOfPourNoteId = makeEntityIdOfPourNoteId;

export interface PourNoteId extends EntityIdOfPourNoteId {
}

export function makePourNoteId (model: PourNoteId): PourNoteId {
  return {
      ...makeEntityIdOfPourNoteId(model),
  };
}

makeFunctions.PourNoteId = makePourNoteId;

export interface PourData {
    operatorLogNoteFile?: EntitySummaryOfFileId | undefined;
    /** NodaTimeType:ZonedDateTime */
    pourCompletedDate?: ZonedDateTime;    
    /** Dry Tonnage t/h */
    dryTonnage?: number | undefined;
    massConcentration?: number | undefined;
    binderContent?: number | undefined;
    volume?: number | undefined;
    totalBinder?: number | undefined;
    comments?: string | undefined;
    volumeRetainedAfterOutflow?: number | undefined;
    binderTailingsRatio?: number | undefined;
    ucsAverage?: number | undefined;
}

export function makePourData (model: PourData): PourData {
  return {
    operatorLogNoteFile: model.operatorLogNoteFile ? makeEntitySummaryOfFileId(model.operatorLogNoteFile) : model.operatorLogNoteFile,
    pourCompletedDate: model.pourCompletedDate && typeof model.pourCompletedDate === 'string' ? makeZonedDateTime(model.pourCompletedDate) : model.pourCompletedDate,
    dryTonnage: model.dryTonnage,
    massConcentration: model.massConcentration,
    binderContent: model.binderContent,
    volume: model.volume,
    totalBinder: model.totalBinder,
    comments: model.comments,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
    binderTailingsRatio: model.binderTailingsRatio,
    ucsAverage: model.ucsAverage,
  };
}

makeFunctions.PourData = makePourData;

export interface ValueObjectOfPourId {
}

export function makeValueObjectOfPourId (model: ValueObjectOfPourId): ValueObjectOfPourId {
  return {
  };
}

makeFunctions.ValueObjectOfPourId = makeValueObjectOfPourId;

export interface EntityIdOfPourId extends ValueObjectOfPourId {
    value?: string | undefined;
}

export function makeEntityIdOfPourId (model: EntityIdOfPourId): EntityIdOfPourId {
  return {
      ...makeValueObjectOfPourId(model),
    value: model.value,
  };
}

makeFunctions.EntityIdOfPourId = makeEntityIdOfPourId;

export interface PourId extends EntityIdOfPourId {
}

export function makePourId (model: PourId): PourId {
  return {
      ...makeEntityIdOfPourId(model),
  };
}

makeFunctions.PourId = makePourId;

export interface PublicStopeNoteApprovalViewDto {
    accessTokens?: AccessToken[] | undefined;
    stopeNoteId?: string | undefined;
    mineModelId?: string | undefined;
    stopeId?: string | undefined;
    status?: StopeNoteStatus;
}

export function makePublicStopeNoteApprovalViewDto (model: PublicStopeNoteApprovalViewDto): PublicStopeNoteApprovalViewDto {
  return {
    accessTokens: (model.accessTokens?.map((item) => makeAccessToken(item))),
    stopeNoteId: model.stopeNoteId,
    mineModelId: model.mineModelId,
    stopeId: model.stopeId,
    status: model.status ? makeStopeNoteStatus(model.status) : model.status,
  };
}

makeFunctions.PublicStopeNoteApprovalViewDto = makePublicStopeNoteApprovalViewDto;

export enum StopeNoteStatus {
    Generated = 0,
    AwaitingApproval = 10,
    Approved = 20,
    Reject = 30,
    Voided = -10,
}

function makeStopeNoteStatus (value: StopeNoteStatus): StopeNoteStatus {
  return value;
}

makeFunctions.StopeNoteStatus = makeStopeNoteStatus;

export interface StopeNoteDto extends EntityDtoOfString {
    mineModelId?: string | undefined;
    stopeId?: string | undefined;
    scenarioId?: string | undefined;
    status?: StopeNoteStatus;
    statusUpdates?: StatusUpdateDtoOfStopeNoteStatus[] | undefined;
    file?: EntitySummaryDto | undefined;
    finalizedFile?: EntitySummaryDto | undefined;
    /** NodaTimeType:Instant */
    created?: Instant;    
    createdBy?: EntitySummaryDto | undefined;
    routePoints?: PourNoteRoutePointsDto[] | undefined;
    includeRoutePoints?: boolean;
    includeRiseRate?: boolean;
    approvers?: StopeNoteApprovalDto[] | undefined;
    activeApprovers?: StopeNoteApprovalDto[] | undefined;
}

export function makeStopeNoteDto (model: StopeNoteDto): StopeNoteDto {
  return {
      ...makeEntityDtoOfString(model),
    mineModelId: model.mineModelId,
    stopeId: model.stopeId,
    scenarioId: model.scenarioId,
    status: model.status ? makeStopeNoteStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateDtoOfStopeNoteStatus(item))),
    file: model.file ? makeEntitySummaryDto(model.file) : model.file,
    finalizedFile: model.finalizedFile ? makeEntitySummaryDto(model.finalizedFile) : model.finalizedFile,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    createdBy: model.createdBy ? makeEntitySummaryDto(model.createdBy) : model.createdBy,
    routePoints: (model.routePoints?.map((item) => makePourNoteRoutePointsDto(item))),
    includeRoutePoints: model.includeRoutePoints,
    includeRiseRate: model.includeRiseRate,
    approvers: (model.approvers?.map((item) => makeStopeNoteApprovalDto(item))),
    activeApprovers: (model.activeApprovers?.map((item) => makeStopeNoteApprovalDto(item))),
  };
}

makeFunctions.StopeNoteDto = makeStopeNoteDto;

export interface StatusUpdateDtoOfStopeNoteStatus {
    status?: StopeNoteStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryDto | undefined;
}

export function makeStatusUpdateDtoOfStopeNoteStatus (model: StatusUpdateDtoOfStopeNoteStatus): StatusUpdateDtoOfStopeNoteStatus {
  return {
    status: model.status ? makeStopeNoteStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryDto(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateDtoOfStopeNoteStatus = makeStatusUpdateDtoOfStopeNoteStatus;

export interface StopeNoteApprovalDto {
    email: string;
    name: string;
    signatureFile?: EntitySummaryDto | undefined;
    status: StopeNoteApprovalStatus;
    statusUpdates: StatusUpdateDtoOfStopeNoteApprovalStatus[];
    messages: MessageStatus[];
    lastMessage?: MessageStatus | undefined;
    comment?: string | undefined;
}

export function makeStopeNoteApprovalDto (model: StopeNoteApprovalDto): StopeNoteApprovalDto {
  return {
    email: model.email,
    name: model.name,
    signatureFile: model.signatureFile ? makeEntitySummaryDto(model.signatureFile) : model.signatureFile,
    status: model.status ? makeStopeNoteApprovalStatus(model.status) : model.status,
    statusUpdates: (model.statusUpdates?.map((item) => makeStatusUpdateDtoOfStopeNoteApprovalStatus(item))),
    messages: (model.messages?.map((item) => makeMessageStatus(item))),
    lastMessage: model.lastMessage ? makeMessageStatus(model.lastMessage) : model.lastMessage,
    comment: model.comment,
  };
}

makeFunctions.StopeNoteApprovalDto = makeStopeNoteApprovalDto;

export enum StopeNoteApprovalStatus {
    Created = 0,
    AwaitingApproval = 10,
    Approved = 20,
    Reject = 30,
    Removed = -10,
}

function makeStopeNoteApprovalStatus (value: StopeNoteApprovalStatus): StopeNoteApprovalStatus {
  return value;
}

makeFunctions.StopeNoteApprovalStatus = makeStopeNoteApprovalStatus;

export interface StatusUpdateDtoOfStopeNoteApprovalStatus {
    status?: StopeNoteApprovalStatus;
    /** NodaTimeType:Instant */
    created?: Instant;    
    user?: EntitySummaryDto | undefined;
}

export function makeStatusUpdateDtoOfStopeNoteApprovalStatus (model: StatusUpdateDtoOfStopeNoteApprovalStatus): StatusUpdateDtoOfStopeNoteApprovalStatus {
  return {
    status: model.status ? makeStopeNoteApprovalStatus(model.status) : model.status,
    created: model.created && typeof model.created === 'string' ? makeInstant(model.created) : model.created,
    user: model.user ? makeEntitySummaryDto(model.user) : model.user,
  };
}

makeFunctions.StatusUpdateDtoOfStopeNoteApprovalStatus = makeStatusUpdateDtoOfStopeNoteApprovalStatus;

export interface AddStopeNoteApproverCommand {
    stopeNoteId: string;
    email: string;
    name: string;
}

export function makeAddStopeNoteApproverCommand (model: AddStopeNoteApproverCommand): AddStopeNoteApproverCommand {
  return {
    stopeNoteId: model.stopeNoteId,
    email: model.email,
    name: model.name,
  };
}

makeFunctions.AddStopeNoteApproverCommand = makeAddStopeNoteApproverCommand;

export interface RemoveStopeNoteApproverCommand {
    stopeNoteId: string;
    email: string;
}

export function makeRemoveStopeNoteApproverCommand (model: RemoveStopeNoteApproverCommand): RemoveStopeNoteApproverCommand {
  return {
    stopeNoteId: model.stopeNoteId,
    email: model.email,
  };
}

makeFunctions.RemoveStopeNoteApproverCommand = makeRemoveStopeNoteApproverCommand;

export interface UnapproveStopeNoteApproverCommand {
    stopeNoteId: string;
    email: string;
}

export function makeUnapproveStopeNoteApproverCommand (model: UnapproveStopeNoteApproverCommand): UnapproveStopeNoteApproverCommand {
  return {
    stopeNoteId: model.stopeNoteId,
    email: model.email,
  };
}

makeFunctions.UnapproveStopeNoteApproverCommand = makeUnapproveStopeNoteApproverCommand;

export interface ResendStopeNoteApprovalCommand {
    stopeNoteId: string;
    approvers?: string[] | undefined;
}

export function makeResendStopeNoteApprovalCommand (model: ResendStopeNoteApprovalCommand): ResendStopeNoteApprovalCommand {
  return {
    stopeNoteId: model.stopeNoteId,
    approvers: model.approvers,
  };
}

makeFunctions.ResendStopeNoteApprovalCommand = makeResendStopeNoteApprovalCommand;

export interface StopeNoteRouteImageDto {
    fileId?: string | undefined;
    fileName?: string | undefined;
    /** data:{contentType};base64,{data} representation of the image. Populated when listing
existing route images so the client can render them; left null on upload responses. */
    dataUri?: string | undefined;
}

export function makeStopeNoteRouteImageDto (model: StopeNoteRouteImageDto): StopeNoteRouteImageDto {
  return {
    fileId: model.fileId,
    fileName: model.fileName,
    dataUri: model.dataUri,
  };
}

makeFunctions.StopeNoteRouteImageDto = makeStopeNoteRouteImageDto;

export interface ChartParameterGroupDto {
    name?: string | undefined;
    items?: ChartParameterDto[] | undefined;
}

export function makeChartParameterGroupDto (model: ChartParameterGroupDto): ChartParameterGroupDto {
  return {
    name: model.name,
    items: (model.items?.map((item) => makeChartParameterDto(item))),
  };
}

makeFunctions.ChartParameterGroupDto = makeChartParameterGroupDto;

export interface ChartParameterDto {
    key?: string | undefined;
    label?: string | undefined;
    role?: ChartParameterRole;
    unit?: string | undefined;
}

export function makeChartParameterDto (model: ChartParameterDto): ChartParameterDto {
  return {
    key: model.key,
    label: model.label,
    role: model.role ? makeChartParameterRole(model.role) : model.role,
    unit: model.unit,
  };
}

makeFunctions.ChartParameterDto = makeChartParameterDto;

export enum ChartParameterRole {
    Measure = 0,
    Dimension = 1,
    Time = 2,
}

function makeChartParameterRole (value: ChartParameterRole): ChartParameterRole {
  return value;
}

makeFunctions.ChartParameterRole = makeChartParameterRole;

export interface PourFactDto {
    stopeName?: string | undefined;
    level?: string | undefined;
    area?: string | undefined;
    stopeVolume?: number | undefined;
    pourReference?: string | undefined;
    status?: string | undefined;
    /** NodaTimeType:Instant */
    intendedPourDate?: Instant | undefined;    
    plannedVolume?: number | undefined;
    targetUcs?: number | undefined;
    targetMassConcentration?: number | undefined;
    designBinderContent?: number | undefined;
    designThroughput?: number | undefined;
    /** NodaTimeType:Instant */
    completedDate?: Instant | undefined;    
    actualVolume?: number | undefined;
    actualMassConcentration?: number | undefined;
    actualBinderContent?: number | undefined;
    dryTonnage?: number | undefined;
    totalBinder?: number | undefined;
    ucsAverage?: number | undefined;
    scheduleVarianceDays?: number | undefined;
}

export function makePourFactDto (model: PourFactDto): PourFactDto {
  return {
    stopeName: model.stopeName,
    level: model.level,
    area: model.area,
    stopeVolume: model.stopeVolume,
    pourReference: model.pourReference,
    status: model.status,
    intendedPourDate: model.intendedPourDate && typeof model.intendedPourDate === 'string' ? makeInstant(model.intendedPourDate) : model.intendedPourDate,
    plannedVolume: model.plannedVolume,
    targetUcs: model.targetUcs,
    targetMassConcentration: model.targetMassConcentration,
    designBinderContent: model.designBinderContent,
    designThroughput: model.designThroughput,
    completedDate: model.completedDate && typeof model.completedDate === 'string' ? makeInstant(model.completedDate) : model.completedDate,
    actualVolume: model.actualVolume,
    actualMassConcentration: model.actualMassConcentration,
    actualBinderContent: model.actualBinderContent,
    dryTonnage: model.dryTonnage,
    totalBinder: model.totalBinder,
    ucsAverage: model.ucsAverage,
    scheduleVarianceDays: model.scheduleVarianceDays,
  };
}

makeFunctions.PourFactDto = makePourFactDto;

export interface PourTypeDataDto {
    stopeId: string;
    pourType: string;
    ucsStrength: number;
    curingDays: number;
    volume: number;
    pourTypeDataId: string;
    stopeName: string;
}

export function makePourTypeDataDto (model: PourTypeDataDto): PourTypeDataDto {
  return {
    stopeId: model.stopeId,
    pourType: model.pourType,
    ucsStrength: model.ucsStrength,
    curingDays: model.curingDays,
    volume: model.volume,
    pourTypeDataId: model.pourTypeDataId,
    stopeName: model.stopeName,
  };
}

makeFunctions.PourTypeDataDto = makePourTypeDataDto;

export interface ValueObjectOfPourTypeDataId {
}

export function makeValueObjectOfPourTypeDataId (model: ValueObjectOfPourTypeDataId): ValueObjectOfPourTypeDataId {
  return {
  };
}

makeFunctions.ValueObjectOfPourTypeDataId = makeValueObjectOfPourTypeDataId;

export interface EntityIdOfPourTypeDataId extends ValueObjectOfPourTypeDataId {
    value?: string | undefined;
}

export function makeEntityIdOfPourTypeDataId (model: EntityIdOfPourTypeDataId): EntityIdOfPourTypeDataId {
  return {
      ...makeValueObjectOfPourTypeDataId(model),
    value: model.value,
  };
}

makeFunctions.EntityIdOfPourTypeDataId = makeEntityIdOfPourTypeDataId;

export interface PourTypeDataId extends EntityIdOfPourTypeDataId {
}

export function makePourTypeDataId (model: PourTypeDataId): PourTypeDataId {
  return {
      ...makeEntityIdOfPourTypeDataId(model),
  };
}

makeFunctions.PourTypeDataId = makePourTypeDataId;

export interface CreatePourTypesCommand {
    mineModelId?: string | undefined;
    pourTypes?: PourTypeDataImportForm[] | undefined;
}

export function makeCreatePourTypesCommand (model: CreatePourTypesCommand): CreatePourTypesCommand {
  return {
    mineModelId: model.mineModelId,
    pourTypes: (model.pourTypes?.map((item) => makePourTypeDataImportForm(item))),
  };
}

makeFunctions.CreatePourTypesCommand = makeCreatePourTypesCommand;

export interface PourTypeDataImportForm {
    stopeId: string;
    stopeName: string;
    pourType: string;
    ucsStrength: number;
    curingDays: number;
    volume: number;
}

export function makePourTypeDataImportForm (model: PourTypeDataImportForm): PourTypeDataImportForm {
  return {
    stopeId: model.stopeId,
    stopeName: model.stopeName,
    pourType: model.pourType,
    ucsStrength: model.ucsStrength,
    curingDays: model.curingDays,
    volume: model.volume,
  };
}

makeFunctions.PourTypeDataImportForm = makePourTypeDataImportForm;

export interface UpdatePourTypeCommand {
    pourTypes?: PourTypeDataUpdateForm[] | undefined;
}

export function makeUpdatePourTypeCommand (model: UpdatePourTypeCommand): UpdatePourTypeCommand {
  return {
    pourTypes: (model.pourTypes?.map((item) => makePourTypeDataUpdateForm(item))),
  };
}

makeFunctions.UpdatePourTypeCommand = makeUpdatePourTypeCommand;

export interface PourTypeDataUpdateForm {
    pourTypeDataId: string;
    pourType: string;
    ucsStrength: number;
    curingDays: number;
    volume: number;
    archived: boolean;
}

export function makePourTypeDataUpdateForm (model: PourTypeDataUpdateForm): PourTypeDataUpdateForm {
  return {
    pourTypeDataId: model.pourTypeDataId,
    pourType: model.pourType,
    ucsStrength: model.ucsStrength,
    curingDays: model.curingDays,
    volume: model.volume,
    archived: model.archived,
  };
}

makeFunctions.PourTypeDataUpdateForm = makePourTypeDataUpdateForm;

export interface CustomReportTemplateDto extends EntityDtoOfString {
    projectId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    definition?: CustomReportDefinitionDto | undefined;
    requirementStages?: CustomReportRequirementStage[] | undefined;
    sourceFile?: EntitySummaryOfFileId | undefined;
}

export function makeCustomReportTemplateDto (model: CustomReportTemplateDto): CustomReportTemplateDto {
  return {
      ...makeEntityDtoOfString(model),
    projectId: model.projectId,
    name: model.name,
    description: model.description,
    definition: model.definition ? makeCustomReportDefinitionDto(model.definition) : model.definition,
    requirementStages: (model.requirementStages?.map((item) => makeCustomReportRequirementStage(item))),
    sourceFile: model.sourceFile ? makeEntitySummaryOfFileId(model.sourceFile) : model.sourceFile,
  };
}

makeFunctions.CustomReportTemplateDto = makeCustomReportTemplateDto;

export interface CustomReportDefinitionDto {
    fields?: CustomReportFieldDto[] | undefined;
    excelFormValues?: CustomReportExcelFormValuesDto | undefined;
    formSchema?: any | undefined;
}

export function makeCustomReportDefinitionDto (model: CustomReportDefinitionDto): CustomReportDefinitionDto {
  return {
    fields: (model.fields?.map((item) => makeCustomReportFieldDto(item))),
    excelFormValues: model.excelFormValues ? makeCustomReportExcelFormValuesDto(model.excelFormValues) : model.excelFormValues,
    formSchema: model.formSchema,
  };
}

makeFunctions.CustomReportDefinitionDto = makeCustomReportDefinitionDto;

export interface CustomReportFieldDto {
    id?: string | undefined;
    label?: string | undefined;
    type?: CustomReportFieldType;
    required?: boolean;
    helpText?: string | undefined;
    sortOrder?: number;
    options?: string[] | undefined;
    pdfPlacement?: CustomReportPdfFieldPlacementDto | undefined;
}

export function makeCustomReportFieldDto (model: CustomReportFieldDto): CustomReportFieldDto {
  return {
    id: model.id,
    label: model.label,
    type: model.type ? makeCustomReportFieldType(model.type) : model.type,
    required: model.required,
    helpText: model.helpText,
    sortOrder: model.sortOrder,
    options: model.options,
    pdfPlacement: model.pdfPlacement ? makeCustomReportPdfFieldPlacementDto(model.pdfPlacement) : model.pdfPlacement,
  };
}

makeFunctions.CustomReportFieldDto = makeCustomReportFieldDto;

export enum CustomReportFieldType {
    Text = 0,
    MultilineText = 1,
    Checkbox = 2,
    Signature = 3,
    Date = 4,
    Number = 5,
    Select = 6,
}

function makeCustomReportFieldType (value: CustomReportFieldType): CustomReportFieldType {
  return value;
}

makeFunctions.CustomReportFieldType = makeCustomReportFieldType;

export interface CustomReportPdfFieldPlacementDto {
    page?: number;
    x?: number;
    y?: number;
    width?: number;
    height?: number;
}

export function makeCustomReportPdfFieldPlacementDto (model: CustomReportPdfFieldPlacementDto): CustomReportPdfFieldPlacementDto {
  return {
    page: model.page,
    x: model.x,
    y: model.y,
    width: model.width,
    height: model.height,
  };
}

makeFunctions.CustomReportPdfFieldPlacementDto = makeCustomReportPdfFieldPlacementDto;

export interface CustomReportExcelFormValuesDto {
    cells?: { [key: string]: string; } | undefined;
    richCells?: { [key: string]: string; } | undefined;
    logoDataUri?: string | undefined;
    logoScale?: number | undefined;
    pdfBackgroundDataUri?: string | undefined;
    pdfBackgroundFileName?: string | undefined;
    pdfPageWidth?: number | undefined;
    pdfPageHeight?: number | undefined;
}

export function makeCustomReportExcelFormValuesDto (model: CustomReportExcelFormValuesDto): CustomReportExcelFormValuesDto {
  return {
    cells: model.cells,
    richCells: model.richCells,
    logoDataUri: model.logoDataUri,
    logoScale: model.logoScale,
    pdfBackgroundDataUri: model.pdfBackgroundDataUri,
    pdfBackgroundFileName: model.pdfBackgroundFileName,
    pdfPageWidth: model.pdfPageWidth,
    pdfPageHeight: model.pdfPageHeight,
  };
}

makeFunctions.CustomReportExcelFormValuesDto = makeCustomReportExcelFormValuesDto;

export interface KeyValuePairOfStringAndJsonNode {
    key?: string | undefined;
    value?: JsonNode | undefined;
}

export function makeKeyValuePairOfStringAndJsonNode (model: KeyValuePairOfStringAndJsonNode): KeyValuePairOfStringAndJsonNode {
  return {
    key: model.key,
    value: model.value ? makeJsonNode(model.value) : model.value,
  };
}

makeFunctions.KeyValuePairOfStringAndJsonNode = makeKeyValuePairOfStringAndJsonNode;

export interface JsonNode {

    [key: string]: any;
}

export function makeJsonNode (model: JsonNode): JsonNode {
  return {
  };
}

makeFunctions.JsonNode = makeJsonNode;

export interface JsonNodeOptions {
    propertyNameCaseInsensitive?: boolean;
}

export function makeJsonNodeOptions (model: JsonNodeOptions): JsonNodeOptions {
  return {
    propertyNameCaseInsensitive: model.propertyNameCaseInsensitive,
  };
}

makeFunctions.JsonNodeOptions = makeJsonNodeOptions;

export enum CustomReportRequirementStage {
    BeforePourNoteApproval = 0,
    BeforeStopeCompletion = 1,
}

function makeCustomReportRequirementStage (value: CustomReportRequirementStage): CustomReportRequirementStage {
  return value;
}

makeFunctions.CustomReportRequirementStage = makeCustomReportRequirementStage;

export interface CustomReportTemplateForm {
    name: string;
    description?: string | undefined;
    requirementStages?: CustomReportRequirementStage[] | undefined;
    fields?: CustomReportFieldDto[] | undefined;
    excelFormValues?: CustomReportExcelFormValuesDto | undefined;
    formSchema?: any | undefined;
}

export function makeCustomReportTemplateForm (model: CustomReportTemplateForm): CustomReportTemplateForm {
  return {
    name: model.name,
    description: model.description,
    requirementStages: (model.requirementStages?.map((item) => makeCustomReportRequirementStage(item))),
    fields: (model.fields?.map((item) => makeCustomReportFieldDto(item))),
    excelFormValues: model.excelFormValues ? makeCustomReportExcelFormValuesDto(model.excelFormValues) : model.excelFormValues,
    formSchema: model.formSchema,
  };
}

makeFunctions.CustomReportTemplateForm = makeCustomReportTemplateForm;

export interface CustomReportRequirementStatusDto {
    template?: CustomReportTemplateDto | undefined;
    submission?: CustomReportSubmissionDto | undefined;
    stage?: CustomReportRequirementStage;
    targetType?: CustomReportTargetType;
    targetId?: string | undefined;
    isComplete?: boolean;
}

export function makeCustomReportRequirementStatusDto (model: CustomReportRequirementStatusDto): CustomReportRequirementStatusDto {
  return {
    template: model.template ? makeCustomReportTemplateDto(model.template) : model.template,
    submission: model.submission ? makeCustomReportSubmissionDto(model.submission) : model.submission,
    stage: model.stage ? makeCustomReportRequirementStage(model.stage) : model.stage,
    targetType: model.targetType ? makeCustomReportTargetType(model.targetType) : model.targetType,
    targetId: model.targetId,
    isComplete: model.isComplete,
  };
}

makeFunctions.CustomReportRequirementStatusDto = makeCustomReportRequirementStatusDto;

export interface CustomReportSubmissionDto extends EntityDtoOfString {
    projectId?: string | undefined;
    templateId?: string | undefined;
    targetType?: CustomReportTargetType;
    targetId?: string | undefined;
    values?: { [key: string]: string; } | undefined;
    status?: CustomReportSubmissionStatus;
    /** NodaTimeType:Instant */
    completedUtc?: Instant | undefined;    
    completedBy?: EntitySummaryOfString | undefined;
}

export function makeCustomReportSubmissionDto (model: CustomReportSubmissionDto): CustomReportSubmissionDto {
  return {
      ...makeEntityDtoOfString(model),
    projectId: model.projectId,
    templateId: model.templateId,
    targetType: model.targetType ? makeCustomReportTargetType(model.targetType) : model.targetType,
    targetId: model.targetId,
    values: model.values,
    status: model.status ? makeCustomReportSubmissionStatus(model.status) : model.status,
    completedUtc: model.completedUtc && typeof model.completedUtc === 'string' ? makeInstant(model.completedUtc) : model.completedUtc,
    completedBy: model.completedBy ? makeEntitySummaryOfString(model.completedBy) : model.completedBy,
  };
}

makeFunctions.CustomReportSubmissionDto = makeCustomReportSubmissionDto;

export enum CustomReportTargetType {
    Pour = 0,
    Stope = 1,
}

function makeCustomReportTargetType (value: CustomReportTargetType): CustomReportTargetType {
  return value;
}

makeFunctions.CustomReportTargetType = makeCustomReportTargetType;

export enum CustomReportSubmissionStatus {
    Draft = 0,
    Completed = 1,
}

function makeCustomReportSubmissionStatus (value: CustomReportSubmissionStatus): CustomReportSubmissionStatus {
  return value;
}

makeFunctions.CustomReportSubmissionStatus = makeCustomReportSubmissionStatus;

export interface CustomReportBindingGroupDto {
    name?: string | undefined;
    items?: CustomReportBindingItemDto[] | undefined;
}

export function makeCustomReportBindingGroupDto (model: CustomReportBindingGroupDto): CustomReportBindingGroupDto {
  return {
    name: model.name,
    items: (model.items?.map((item) => makeCustomReportBindingItemDto(item))),
  };
}

makeFunctions.CustomReportBindingGroupDto = makeCustomReportBindingGroupDto;

export interface CustomReportBindingItemDto {
    key?: string | undefined;
    label?: string | undefined;
    valueType?: CustomReportFieldType;
    isCollection?: boolean;
}

export function makeCustomReportBindingItemDto (model: CustomReportBindingItemDto): CustomReportBindingItemDto {
  return {
    key: model.key,
    label: model.label,
    valueType: model.valueType ? makeCustomReportFieldType(model.valueType) : model.valueType,
    isCollection: model.isCollection,
  };
}

makeFunctions.CustomReportBindingItemDto = makeCustomReportBindingItemDto;

export interface ResolveCustomReportValuesForm {
    includeRoutePoints?: boolean;
    routePoints?: string | undefined;
}

export function makeResolveCustomReportValuesForm (model: ResolveCustomReportValuesForm): ResolveCustomReportValuesForm {
  return {
    includeRoutePoints: model.includeRoutePoints,
    routePoints: model.routePoints,
  };
}

makeFunctions.ResolveCustomReportValuesForm = makeResolveCustomReportValuesForm;

export interface CustomReportStopeBindingDto {
    templateId?: string | undefined;
    stages?: CustomReportRequirementStage[] | undefined;
}

export function makeCustomReportStopeBindingDto (model: CustomReportStopeBindingDto): CustomReportStopeBindingDto {
  return {
    templateId: model.templateId,
    stages: (model.stages?.map((item) => makeCustomReportRequirementStage(item))),
  };
}

makeFunctions.CustomReportStopeBindingDto = makeCustomReportStopeBindingDto;

export interface SetCustomReportStopeBindingForm {
    stages?: CustomReportRequirementStage[] | undefined;
}

export function makeSetCustomReportStopeBindingForm (model: SetCustomReportStopeBindingForm): SetCustomReportStopeBindingForm {
  return {
    stages: (model.stages?.map((item) => makeCustomReportRequirementStage(item))),
  };
}

makeFunctions.SetCustomReportStopeBindingForm = makeSetCustomReportStopeBindingForm;

/** The full requirement scope of one template: which stages it gates and which stopes it applies to (every stope in the project, or an explicit set). */
export interface CustomReportTemplateRequirementsDto {
    allStopes?: boolean;
    stopeIds?: string[] | undefined;
    stages?: CustomReportRequirementStage[] | undefined;
}

export function makeCustomReportTemplateRequirementsDto (model: CustomReportTemplateRequirementsDto): CustomReportTemplateRequirementsDto {
  return {
    allStopes: model.allStopes,
    stopeIds: model.stopeIds,
    stages: (model.stages?.map((item) => makeCustomReportRequirementStage(item))),
  };
}

makeFunctions.CustomReportTemplateRequirementsDto = makeCustomReportTemplateRequirementsDto;

export interface SetCustomReportTemplateRequirementsForm {
    allStopes?: boolean;
    stopeIds?: string[] | undefined;
    stages?: CustomReportRequirementStage[] | undefined;
}

export function makeSetCustomReportTemplateRequirementsForm (model: SetCustomReportTemplateRequirementsForm): SetCustomReportTemplateRequirementsForm {
  return {
    allStopes: model.allStopes,
    stopeIds: model.stopeIds,
    stages: (model.stages?.map((item) => makeCustomReportRequirementStage(item))),
  };
}

makeFunctions.SetCustomReportTemplateRequirementsForm = makeSetCustomReportTemplateRequirementsForm;

export interface SaveCustomReportSubmissionForm {
    values?: { [key: string]: string; } | undefined;
    complete?: boolean;
}

export function makeSaveCustomReportSubmissionForm (model: SaveCustomReportSubmissionForm): SaveCustomReportSubmissionForm {
  return {
    values: model.values,
    complete: model.complete,
  };
}

makeFunctions.SaveCustomReportSubmissionForm = makeSaveCustomReportSubmissionForm;

export interface BackfillRecipeDto extends EntityDtoOfString {
    reference: string;
    stopeIdentifier: StopeIdentifierDto;
    pasteSpecification?: PasteBackfillSpecificationDto | undefined;
    pasteOptimisedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSelectedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSlackFlowSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteMaxPressureSpecification?: PasteRecipeSpecificationDto | undefined;
    hydraulicSpecification?: HydraulicBackfillSpecificationDto | undefined;
    hydraulicOptimisedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    hydraulicSelectedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    warnings: BackfillWarningDto[];
    isStale: boolean;
    rheologyDataSetId: string;
    rheologyDataSetReference: string;
    rheologyDataSetVersion: string;
    /** The route as a node walk (legacy name, read by the pour note, exports and route highlighting). */
    spoolIds: string[];
    /** The route's real spool ids in route order. Empty on a recipe saved before the SPA sent them. */
    routeSpoolIds?: string[] | undefined;
    backfillPlantId?: string | undefined;
    pourPresetDto?: PourPresetDto | undefined;
    isAutoRecipe?: boolean;
    /** DateTime */
    creationDate?: Date;
    autoRecipeBatchId?: number;
    pipeFrictionDataItems?: PipeFrictionDataDto[] | undefined;
    nominalParameters?: NominalOptimisationParametersDto | undefined;
    targetLines?: OptimisationTargetLineDto[] | undefined;
}

export function makeBackfillRecipeDto (model: BackfillRecipeDto): BackfillRecipeDto {
  return {
      ...makeEntityDtoOfString(model),
    reference: model.reference,
    stopeIdentifier: model.stopeIdentifier ? makeStopeIdentifierDto(model.stopeIdentifier) : model.stopeIdentifier,
    pasteSpecification: model.pasteSpecification ? makePasteBackfillSpecificationDto(model.pasteSpecification) : model.pasteSpecification,
    pasteOptimisedSpecification: model.pasteOptimisedSpecification ? makePasteRecipeSpecificationDto(model.pasteOptimisedSpecification) : model.pasteOptimisedSpecification,
    pasteSelectedSpecification: model.pasteSelectedSpecification ? makePasteRecipeSpecificationDto(model.pasteSelectedSpecification) : model.pasteSelectedSpecification,
    pasteSlackFlowSpecification: model.pasteSlackFlowSpecification ? makePasteRecipeSpecificationDto(model.pasteSlackFlowSpecification) : model.pasteSlackFlowSpecification,
    pasteMaxPressureSpecification: model.pasteMaxPressureSpecification ? makePasteRecipeSpecificationDto(model.pasteMaxPressureSpecification) : model.pasteMaxPressureSpecification,
    hydraulicSpecification: model.hydraulicSpecification ? makeHydraulicBackfillSpecificationDto(model.hydraulicSpecification) : model.hydraulicSpecification,
    hydraulicOptimisedSpecification: model.hydraulicOptimisedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicOptimisedSpecification) : model.hydraulicOptimisedSpecification,
    hydraulicSelectedSpecification: model.hydraulicSelectedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicSelectedSpecification) : model.hydraulicSelectedSpecification,
    warnings: (model.warnings?.map((item) => makeBackfillWarningDto(item))),
    isStale: model.isStale,
    rheologyDataSetId: model.rheologyDataSetId,
    rheologyDataSetReference: model.rheologyDataSetReference,
    rheologyDataSetVersion: model.rheologyDataSetVersion,
    spoolIds: model.spoolIds,
    routeSpoolIds: model.routeSpoolIds,
    backfillPlantId: model.backfillPlantId,
    pourPresetDto: model.pourPresetDto ? makePourPresetDto(model.pourPresetDto) : model.pourPresetDto,
    isAutoRecipe: model.isAutoRecipe,
    creationDate: model.creationDate && typeof model.creationDate === 'string' ? makeDate(model.creationDate) : model.creationDate,
    autoRecipeBatchId: model.autoRecipeBatchId,
    pipeFrictionDataItems: (model.pipeFrictionDataItems?.map((item) => makePipeFrictionDataDto(item))),
    nominalParameters: model.nominalParameters ? makeNominalOptimisationParametersDto(model.nominalParameters) : model.nominalParameters,
    targetLines: (model.targetLines?.map((item) => makeOptimisationTargetLineDto(item))),
  };
}

makeFunctions.BackfillRecipeDto = makeBackfillRecipeDto;

export interface PourPresetDto extends EntityDtoOfString {
    name: string;
    groupId: string;
    ucsStrength: number;
    curingDays: number;
    volume?: number | undefined;
    height?: number | undefined;
    fillRemainingHeight: boolean;
    rheologyDatasetId?: string | undefined;
    order?: number;
    isRockFill?: boolean;
}

export function makePourPresetDto (model: PourPresetDto): PourPresetDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
    groupId: model.groupId,
    ucsStrength: model.ucsStrength,
    curingDays: model.curingDays,
    volume: model.volume,
    height: model.height,
    fillRemainingHeight: model.fillRemainingHeight,
    rheologyDatasetId: model.rheologyDatasetId,
    order: model.order,
    isRockFill: model.isRockFill,
  };
}

makeFunctions.PourPresetDto = makePourPresetDto;

export interface NominalOptimisationParametersDto {
    minYield?: number | undefined;
    maxYield?: number | undefined;
    pipeRatingOffsetPercent?: number | undefined;
    excludedPipeIds?: string[] | undefined;
}

export function makeNominalOptimisationParametersDto (model: NominalOptimisationParametersDto): NominalOptimisationParametersDto {
  return {
    minYield: model.minYield,
    maxYield: model.maxYield,
    pipeRatingOffsetPercent: model.pipeRatingOffsetPercent,
    excludedPipeIds: model.excludedPipeIds,
  };
}

makeFunctions.NominalOptimisationParametersDto = makeNominalOptimisationParametersDto;

export interface OptimisationTargetLineDto {
    targetType?: OptimisationTargetType;
    kPaPerMTarget?: number | undefined;
    targetPipeId?: string | undefined;
    pumpPressureTarget?: number | undefined;
    yieldTarget?: number | undefined;
    flowRateTarget?: number | undefined;
    result?: PasteRecipeSpecificationDto | undefined;
    hasErrors?: boolean;
    errorDescription?: string | undefined;
}

export function makeOptimisationTargetLineDto (model: OptimisationTargetLineDto): OptimisationTargetLineDto {
  return {
    targetType: model.targetType ? makeOptimisationTargetType(model.targetType) : model.targetType,
    kPaPerMTarget: model.kPaPerMTarget,
    targetPipeId: model.targetPipeId,
    pumpPressureTarget: model.pumpPressureTarget,
    yieldTarget: model.yieldTarget,
    flowRateTarget: model.flowRateTarget,
    result: model.result ? makePasteRecipeSpecificationDto(model.result) : model.result,
    hasErrors: model.hasErrors,
    errorDescription: model.errorDescription,
  };
}

makeFunctions.OptimisationTargetLineDto = makeOptimisationTargetLineDto;

export enum OptimisationTargetType {
    KPaPerM = 0,
    PumpPressure = 1,
    Yield = 2,
    FlowRate = 3,
}

function makeOptimisationTargetType (value: OptimisationTargetType): OptimisationTargetType {
  return value;
}

makeFunctions.OptimisationTargetType = makeOptimisationTargetType;

export interface AutoCreatedRecipeDto extends EntityDtoOfString {
    stopeIds?: string[] | undefined;
    stopeNames?: string | undefined;
    recipeNames?: string | undefined;
    /** DateTime */
    creationDate?: Date;
    autoRecipeBatchId?: number;
    mineModelId?: string | undefined;
}

export function makeAutoCreatedRecipeDto (model: AutoCreatedRecipeDto): AutoCreatedRecipeDto {
  return {
      ...makeEntityDtoOfString(model),
    stopeIds: model.stopeIds,
    stopeNames: model.stopeNames,
    recipeNames: model.recipeNames,
    creationDate: model.creationDate && typeof model.creationDate === 'string' ? makeDate(model.creationDate) : model.creationDate,
    autoRecipeBatchId: model.autoRecipeBatchId,
    mineModelId: model.mineModelId,
  };
}

makeFunctions.AutoCreatedRecipeDto = makeAutoCreatedRecipeDto;

export interface PagedListOfBackfillRecipeDto {
    items: BackfillRecipeDto[];
    pager: Pager;
}

export function makePagedListOfBackfillRecipeDto (model: PagedListOfBackfillRecipeDto): PagedListOfBackfillRecipeDto {
  return {
    items: (model.items?.map((item) => makeBackfillRecipeDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfBackfillRecipeDto = makePagedListOfBackfillRecipeDto;

export interface AuditableCommandOfBackfillRecipeAndBackfillRecipeId {
}

export function makeAuditableCommandOfBackfillRecipeAndBackfillRecipeId (model: AuditableCommandOfBackfillRecipeAndBackfillRecipeId): AuditableCommandOfBackfillRecipeAndBackfillRecipeId {
  return {
  };
}

makeFunctions.AuditableCommandOfBackfillRecipeAndBackfillRecipeId = makeAuditableCommandOfBackfillRecipeAndBackfillRecipeId;

export interface BackfillRecipeForm extends AuditableCommandOfBackfillRecipeAndBackfillRecipeId {
    reference: string;
    rheologyDataSetId: string;
    pasteSpecification?: PasteBackfillSpecificationDto | undefined;
    pasteOptimisedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSelectedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSlackFlowSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteMaxPressureSpecification?: PasteRecipeSpecificationDto | undefined;
    hydraulicSpecification?: HydraulicBackfillSpecificationDto | undefined;
    hydraulicOptimisedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    hydraulicSelectedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    /** The route as a node walk (legacy name; read by the pour note, exports and route highlighting). */
    spools?: string[] | undefined;
    /** The route's real spool ids, in route order. Throughput accrues onto these on pour completion. */
    routeSpools?: string[] | undefined;
    warnings: BackfillWarningDto[];
    backfillPlantId?: string | undefined;
    pourPresetId?: string | undefined;
    stopeId?: string | undefined;
    isAutoRecipe?: boolean;
    pipeFrictionDataItems?: PipeFrictionDataDto[] | undefined;
    nominalParameters?: NominalOptimisationParametersDto | undefined;
    targetLines?: OptimisationTargetLineDto[] | undefined;
}

export function makeBackfillRecipeForm (model: BackfillRecipeForm): BackfillRecipeForm {
  return {
      ...makeAuditableCommandOfBackfillRecipeAndBackfillRecipeId(model),
    reference: model.reference,
    rheologyDataSetId: model.rheologyDataSetId,
    pasteSpecification: model.pasteSpecification ? makePasteBackfillSpecificationDto(model.pasteSpecification) : model.pasteSpecification,
    pasteOptimisedSpecification: model.pasteOptimisedSpecification ? makePasteRecipeSpecificationDto(model.pasteOptimisedSpecification) : model.pasteOptimisedSpecification,
    pasteSelectedSpecification: model.pasteSelectedSpecification ? makePasteRecipeSpecificationDto(model.pasteSelectedSpecification) : model.pasteSelectedSpecification,
    pasteSlackFlowSpecification: model.pasteSlackFlowSpecification ? makePasteRecipeSpecificationDto(model.pasteSlackFlowSpecification) : model.pasteSlackFlowSpecification,
    pasteMaxPressureSpecification: model.pasteMaxPressureSpecification ? makePasteRecipeSpecificationDto(model.pasteMaxPressureSpecification) : model.pasteMaxPressureSpecification,
    hydraulicSpecification: model.hydraulicSpecification ? makeHydraulicBackfillSpecificationDto(model.hydraulicSpecification) : model.hydraulicSpecification,
    hydraulicOptimisedSpecification: model.hydraulicOptimisedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicOptimisedSpecification) : model.hydraulicOptimisedSpecification,
    hydraulicSelectedSpecification: model.hydraulicSelectedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicSelectedSpecification) : model.hydraulicSelectedSpecification,
    spools: model.spools,
    routeSpools: model.routeSpools,
    warnings: (model.warnings?.map((item) => makeBackfillWarningDto(item))),
    backfillPlantId: model.backfillPlantId,
    pourPresetId: model.pourPresetId,
    stopeId: model.stopeId,
    isAutoRecipe: model.isAutoRecipe,
    pipeFrictionDataItems: (model.pipeFrictionDataItems?.map((item) => makePipeFrictionDataDto(item))),
    nominalParameters: model.nominalParameters ? makeNominalOptimisationParametersDto(model.nominalParameters) : model.nominalParameters,
    targetLines: (model.targetLines?.map((item) => makeOptimisationTargetLineDto(item))),
  };
}

makeFunctions.BackfillRecipeForm = makeBackfillRecipeForm;

export interface CreateBackfillRecipeCommand extends BackfillRecipeForm {
}

export function makeCreateBackfillRecipeCommand (model: CreateBackfillRecipeCommand): CreateBackfillRecipeCommand {
  return {
      ...makeBackfillRecipeForm(model),
  };
}

makeFunctions.CreateBackfillRecipeCommand = makeCreateBackfillRecipeCommand;

/** Should be wrapped with BackfillRecipeCommandContext[T] */
export interface UpdateBackfillRecipeCommand extends BackfillRecipeForm {
}

export function makeUpdateBackfillRecipeCommand (model: UpdateBackfillRecipeCommand): UpdateBackfillRecipeCommand {
  return {
      ...makeBackfillRecipeForm(model),
  };
}

makeFunctions.UpdateBackfillRecipeCommand = makeUpdateBackfillRecipeCommand;

export interface PagedListOfPourReportDto {
    items: PourReportDto[];
    pager: Pager;
}

export function makePagedListOfPourReportDto (model: PagedListOfPourReportDto): PagedListOfPourReportDto {
  return {
    items: (model.items?.map((item) => makePourReportDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfPourReportDto = makePagedListOfPourReportDto;

export interface PourReportDto extends EntityDtoOfString {
    status: PourStatus;
    reference: string;
    /** NodaTimeType:ZonedDateTime */
    intendedPourDate: ZonedDateTime;    
    volume: number;
    volumeRetainedAfterOutflow?: number | undefined;
    stopeId: string;
    pasteSpecification?: PasteBackfillSpecificationDto | undefined;
    pasteOptimisedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSelectedSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteSlackFlowSpecification?: PasteRecipeSpecificationDto | undefined;
    pasteMaxPressureSpecification?: PasteRecipeSpecificationDto | undefined;
    hydraulicSpecification?: HydraulicBackfillSpecificationDto | undefined;
    hydraulicOptimisedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    hydraulicSelectedSpecification?: HydraulicRecipeSpecificationDto | undefined;
    warnings: string[];
    warningCodes: string[];
    spoolIds: string[];
    routeSpoolIds?: string[] | undefined;
    pourData?: PourDataDto | undefined;
    stopeData?: StopeDataDto | undefined;
    calculatedBinderTonnes?: number | undefined;
    rheologyDataSetId: string;
    documents?: PourDocument[] | undefined;
    pourNote?: PourNoteDto | undefined;
}

export function makePourReportDto (model: PourReportDto): PourReportDto {
  return {
      ...makeEntityDtoOfString(model),
    status: model.status ? makePourStatus(model.status) : model.status,
    reference: model.reference,
    intendedPourDate: model.intendedPourDate && typeof model.intendedPourDate === 'string' ? makeZonedDateTime(model.intendedPourDate) : model.intendedPourDate,
    volume: model.volume,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
    stopeId: model.stopeId,
    pasteSpecification: model.pasteSpecification ? makePasteBackfillSpecificationDto(model.pasteSpecification) : model.pasteSpecification,
    pasteOptimisedSpecification: model.pasteOptimisedSpecification ? makePasteRecipeSpecificationDto(model.pasteOptimisedSpecification) : model.pasteOptimisedSpecification,
    pasteSelectedSpecification: model.pasteSelectedSpecification ? makePasteRecipeSpecificationDto(model.pasteSelectedSpecification) : model.pasteSelectedSpecification,
    pasteSlackFlowSpecification: model.pasteSlackFlowSpecification ? makePasteRecipeSpecificationDto(model.pasteSlackFlowSpecification) : model.pasteSlackFlowSpecification,
    pasteMaxPressureSpecification: model.pasteMaxPressureSpecification ? makePasteRecipeSpecificationDto(model.pasteMaxPressureSpecification) : model.pasteMaxPressureSpecification,
    hydraulicSpecification: model.hydraulicSpecification ? makeHydraulicBackfillSpecificationDto(model.hydraulicSpecification) : model.hydraulicSpecification,
    hydraulicOptimisedSpecification: model.hydraulicOptimisedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicOptimisedSpecification) : model.hydraulicOptimisedSpecification,
    hydraulicSelectedSpecification: model.hydraulicSelectedSpecification ? makeHydraulicRecipeSpecificationDto(model.hydraulicSelectedSpecification) : model.hydraulicSelectedSpecification,
    warnings: model.warnings,
    warningCodes: model.warningCodes,
    spoolIds: model.spoolIds,
    routeSpoolIds: model.routeSpoolIds,
    pourData: model.pourData ? makePourDataDto(model.pourData) : model.pourData,
    stopeData: model.stopeData ? makeStopeDataDto(model.stopeData) : model.stopeData,
    calculatedBinderTonnes: model.calculatedBinderTonnes,
    rheologyDataSetId: model.rheologyDataSetId,
    documents: (model.documents?.map((item) => makePourDocument(item))),
    pourNote: model.pourNote ? makePourNoteDto(model.pourNote) : model.pourNote,
  };
}

makeFunctions.PourReportDto = makePourReportDto;

export interface PourProjectPreferencesDto {
    projectId: string;
    fillType: FillType;
    unitSystemPreference: UnitSystem;
    name: string;
    decimalSeparator: DecimalSeparator;
    thousandsSeparator: ThousandsSeparator;
    metricPressureUnit: MetricPressureUnit;
}

export function makePourProjectPreferencesDto (model: PourProjectPreferencesDto): PourProjectPreferencesDto {
  return {
    projectId: model.projectId,
    fillType: model.fillType ? makeFillType(model.fillType) : model.fillType,
    unitSystemPreference: model.unitSystemPreference ? makeUnitSystem(model.unitSystemPreference) : model.unitSystemPreference,
    name: model.name,
    decimalSeparator: model.decimalSeparator ? makeDecimalSeparator(model.decimalSeparator) : model.decimalSeparator,
    thousandsSeparator: model.thousandsSeparator ? makeThousandsSeparator(model.thousandsSeparator) : model.thousandsSeparator,
    metricPressureUnit: model.metricPressureUnit ? makeMetricPressureUnit(model.metricPressureUnit) : model.metricPressureUnit,
  };
}

makeFunctions.PourProjectPreferencesDto = makePourProjectPreferencesDto;

export interface PourBreakingScheduleDetailsDto {
    stopeName: string;
    pourName: string;
    /** NodaTimeType:ZonedDateTime */
    pourCompletedDate?: ZonedDateTime | undefined;    
    stopeIdentifier: StopeIdentifier;
    massConcentrationPercentageTarget?: number | undefined;
    binderPercentageTarget?: number | undefined;
    waterBinderRatio?: number | undefined;
    predictedUcs?: number | undefined;
    ucsTargetDays?: number | undefined;
    rheologyDataSetReference?: string | undefined;
}

export function makePourBreakingScheduleDetailsDto (model: PourBreakingScheduleDetailsDto): PourBreakingScheduleDetailsDto {
  return {
    stopeName: model.stopeName,
    pourName: model.pourName,
    pourCompletedDate: model.pourCompletedDate && typeof model.pourCompletedDate === 'string' ? makeZonedDateTime(model.pourCompletedDate) : model.pourCompletedDate,
    stopeIdentifier: model.stopeIdentifier ? makeStopeIdentifier(model.stopeIdentifier) : model.stopeIdentifier,
    massConcentrationPercentageTarget: model.massConcentrationPercentageTarget,
    binderPercentageTarget: model.binderPercentageTarget,
    waterBinderRatio: model.waterBinderRatio,
    predictedUcs: model.predictedUcs,
    ucsTargetDays: model.ucsTargetDays,
    rheologyDataSetReference: model.rheologyDataSetReference,
  };
}

makeFunctions.PourBreakingScheduleDetailsDto = makePourBreakingScheduleDetailsDto;

export interface UpdatePourDateCommand {
    /** NodaTimeType:LocalDateTime */
    pourDate: LocalDateTime;    
}

export function makeUpdatePourDateCommand (model: UpdatePourDateCommand): UpdatePourDateCommand {
  return {
    pourDate: model.pourDate && typeof model.pourDate === 'string' ? makeLocalDateTime(model.pourDate) : model.pourDate,
  };
}

makeFunctions.UpdatePourDateCommand = makeUpdatePourDateCommand;

export interface UpdatePourVolumeCommand {
    volume: number;
    volumeRetainedAfterOutflow?: number | undefined;
}

export function makeUpdatePourVolumeCommand (model: UpdatePourVolumeCommand): UpdatePourVolumeCommand {
  return {
    volume: model.volume,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
  };
}

makeFunctions.UpdatePourVolumeCommand = makeUpdatePourVolumeCommand;

export interface UpdatePourReferenceCommand {
    reference: string;
}

export function makeUpdatePourReferenceCommand (model: UpdatePourReferenceCommand): UpdatePourReferenceCommand {
  return {
    reference: model.reference,
  };
}

makeFunctions.UpdatePourReferenceCommand = makeUpdatePourReferenceCommand;

export interface AddApproverCommand {
    email: string;
    name: string;
}

export function makeAddApproverCommand (model: AddApproverCommand): AddApproverCommand {
  return {
    email: model.email,
    name: model.name,
  };
}

makeFunctions.AddApproverCommand = makeAddApproverCommand;

export interface RemoveApproverCommand {
    email: string;
}

export function makeRemoveApproverCommand (model: RemoveApproverCommand): RemoveApproverCommand {
  return {
    email: model.email,
  };
}

makeFunctions.RemoveApproverCommand = makeRemoveApproverCommand;

export interface UnapprovePourNoteApprovalCommand {
    email: string;
}

export function makeUnapprovePourNoteApprovalCommand (model: UnapprovePourNoteApprovalCommand): UnapprovePourNoteApprovalCommand {
  return {
    email: model.email,
  };
}

makeFunctions.UnapprovePourNoteApprovalCommand = makeUnapprovePourNoteApprovalCommand;

export interface PourRouteImageDto {
    fileId?: string | undefined;
    fileName?: string | undefined;
    /** data:{contentType};base64,{data} representation of the image. Populated when listing
existing route images so the client can render them; left null on upload responses. */
    dataUri?: string | undefined;
}

export function makePourRouteImageDto (model: PourRouteImageDto): PourRouteImageDto {
  return {
    fileId: model.fileId,
    fileName: model.fileName,
    dataUri: model.dataUri,
  };
}

makeFunctions.PourRouteImageDto = makePourRouteImageDto;

export interface ResendPourNoteApprovalRequestCommand {
    approvers?: string[] | undefined;
}

export function makeResendPourNoteApprovalRequestCommand (model: ResendPourNoteApprovalRequestCommand): ResendPourNoteApprovalRequestCommand {
  return {
    approvers: model.approvers,
  };
}

makeFunctions.ResendPourNoteApprovalRequestCommand = makeResendPourNoteApprovalRequestCommand;

export interface StopeBackfillSummaryDto {
    stopeIdentifier: StopeIdentifierDto;
    totalCount: number;
    plannedCount: number;
    completedCount: number;
    plannedVolume: number;
    completedVolume: number;
    nextPourId?: string | undefined;
    /** NodaTimeType:ZonedDateTime */
    nextPourDate?: ZonedDateTime | undefined;    
    isComplete: boolean;
}

export function makeStopeBackfillSummaryDto (model: StopeBackfillSummaryDto): StopeBackfillSummaryDto {
  return {
    stopeIdentifier: model.stopeIdentifier ? makeStopeIdentifierDto(model.stopeIdentifier) : model.stopeIdentifier,
    totalCount: model.totalCount,
    plannedCount: model.plannedCount,
    completedCount: model.completedCount,
    plannedVolume: model.plannedVolume,
    completedVolume: model.completedVolume,
    nextPourId: model.nextPourId,
    nextPourDate: model.nextPourDate && typeof model.nextPourDate === 'string' ? makeZonedDateTime(model.nextPourDate) : model.nextPourDate,
    isComplete: model.isComplete,
  };
}

makeFunctions.StopeBackfillSummaryDto = makeStopeBackfillSummaryDto;

export interface PourForm {
    reference: string;
    /** NodaTimeType:LocalDateTime */
    plannedDate: LocalDateTime;    
    volume: number;
    acceptedWarnings: string[];
    volumeRetainedAfterOutflow?: number | undefined;
    pourPositionX?: number | undefined;
    pourPositionY?: number | undefined;
    pourHeight?: number | undefined;
    pasteBeachAngleDegrees?: number | undefined;
    flushRecipeId?: string | undefined;
}

export function makePourForm (model: PourForm): PourForm {
  return {
    reference: model.reference,
    plannedDate: model.plannedDate && typeof model.plannedDate === 'string' ? makeLocalDateTime(model.plannedDate) : model.plannedDate,
    volume: model.volume,
    acceptedWarnings: model.acceptedWarnings,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
    pourPositionX: model.pourPositionX,
    pourPositionY: model.pourPositionY,
    pourHeight: model.pourHeight,
    pasteBeachAngleDegrees: model.pasteBeachAngleDegrees,
    flushRecipeId: model.flushRecipeId,
  };
}

makeFunctions.PourForm = makePourForm;

export interface CreatePoursResult {
    createdPourIds?: string[] | undefined;
    failures?: CreatePourFailure[] | undefined;
}

export function makeCreatePoursResult (model: CreatePoursResult): CreatePoursResult {
  return {
    createdPourIds: model.createdPourIds,
    failures: (model.failures?.map((item) => makeCreatePourFailure(item))),
  };
}

makeFunctions.CreatePoursResult = makeCreatePoursResult;

export interface CreatePourFailure {
    index?: number;
    reference?: string | undefined;
    error?: string | undefined;
}

export function makeCreatePourFailure (model: CreatePourFailure): CreatePourFailure {
  return {
    index: model.index,
    reference: model.reference,
    error: model.error,
  };
}

makeFunctions.CreatePourFailure = makeCreatePourFailure;

export interface CreatePoursCommand {
    pours?: CreatePourItem[] | undefined;
    isAutoPour?: boolean;
    autoPourBatchId?: number;
}

export function makeCreatePoursCommand (model: CreatePoursCommand): CreatePoursCommand {
  return {
    pours: (model.pours?.map((item) => makeCreatePourItem(item))),
    isAutoPour: model.isAutoPour,
    autoPourBatchId: model.autoPourBatchId,
  };
}

makeFunctions.CreatePoursCommand = makeCreatePoursCommand;

export interface CreatePourItem {
    recipeId?: string | undefined;
    pour?: PourForm | undefined;
}

export function makeCreatePourItem (model: CreatePourItem): CreatePourItem {
  return {
    recipeId: model.recipeId,
    pour: model.pour ? makePourForm(model.pour) : model.pour,
  };
}

makeFunctions.CreatePourItem = makeCreatePourItem;

export interface AutoCreatedPourDto extends EntityDtoOfString {
    stopeIds?: string[] | undefined;
    stopeNames?: string | undefined;
    pourNames?: string | undefined;
    /** DateTime */
    creationDate?: Date;
    autoPourBatchId?: number;
    mineModelId?: string | undefined;
}

export function makeAutoCreatedPourDto (model: AutoCreatedPourDto): AutoCreatedPourDto {
  return {
      ...makeEntityDtoOfString(model),
    stopeIds: model.stopeIds,
    stopeNames: model.stopeNames,
    pourNames: model.pourNames,
    creationDate: model.creationDate && typeof model.creationDate === 'string' ? makeDate(model.creationDate) : model.creationDate,
    autoPourBatchId: model.autoPourBatchId,
    mineModelId: model.mineModelId,
  };
}

makeFunctions.AutoCreatedPourDto = makeAutoCreatedPourDto;

export interface PourVolumeComparisonDto {
    planned: number;
    actual: number;
    plannedVolumeRetainedAfterOutflow: number;
    actualVolumeRetainedAfterOutflow: number;
    /** NodaTimeType:ZonedDateTime */
    pourCompletedDate?: ZonedDateTime | undefined;    
    pourName: string;
    stopeName: string;
}

export function makePourVolumeComparisonDto (model: PourVolumeComparisonDto): PourVolumeComparisonDto {
  return {
    planned: model.planned,
    actual: model.actual,
    plannedVolumeRetainedAfterOutflow: model.plannedVolumeRetainedAfterOutflow,
    actualVolumeRetainedAfterOutflow: model.actualVolumeRetainedAfterOutflow,
    pourCompletedDate: model.pourCompletedDate && typeof model.pourCompletedDate === 'string' ? makeZonedDateTime(model.pourCompletedDate) : model.pourCompletedDate,
    pourName: model.pourName,
    stopeName: model.stopeName,
  };
}

makeFunctions.PourVolumeComparisonDto = makePourVolumeComparisonDto;

export interface BinderSavingsReportDto {
    numberOfPoursProcessed: number;
    numberOfInvalidPours: number;
    historicBinderCostTotal: number;
    actualBinderCostTotal: number;
    alerts: string[];
}

export function makeBinderSavingsReportDto (model: BinderSavingsReportDto): BinderSavingsReportDto {
  return {
    numberOfPoursProcessed: model.numberOfPoursProcessed,
    numberOfInvalidPours: model.numberOfInvalidPours,
    historicBinderCostTotal: model.historicBinderCostTotal,
    actualBinderCostTotal: model.actualBinderCostTotal,
    alerts: model.alerts,
  };
}

makeFunctions.BinderSavingsReportDto = makeBinderSavingsReportDto;

export interface CreatePourPresetForm {
    name: string;
    groupId: string;
    ucsStrength: number;
    curingDays: number;
    volume?: number | undefined;
    height?: number | undefined;
    fillRemainingHeight: boolean;
    rheologyDatasetId?: string | undefined;
    isRockFill?: boolean;
}

export function makeCreatePourPresetForm (model: CreatePourPresetForm): CreatePourPresetForm {
  return {
    name: model.name,
    groupId: model.groupId,
    ucsStrength: model.ucsStrength,
    curingDays: model.curingDays,
    volume: model.volume,
    height: model.height,
    fillRemainingHeight: model.fillRemainingHeight,
    rheologyDatasetId: model.rheologyDatasetId,
    isRockFill: model.isRockFill,
  };
}

makeFunctions.CreatePourPresetForm = makeCreatePourPresetForm;

export interface CreatePourPresetGroupForm {
    name: string;
}

export function makeCreatePourPresetGroupForm (model: CreatePourPresetGroupForm): CreatePourPresetGroupForm {
  return {
    name: model.name,
  };
}

makeFunctions.CreatePourPresetGroupForm = makeCreatePourPresetGroupForm;

export interface PagedListOfPourPresetGroupDto {
    items: PourPresetGroupDto[];
    pager: Pager;
}

export function makePagedListOfPourPresetGroupDto (model: PagedListOfPourPresetGroupDto): PagedListOfPourPresetGroupDto {
  return {
    items: (model.items?.map((item) => makePourPresetGroupDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfPourPresetGroupDto = makePagedListOfPourPresetGroupDto;

export interface PourPresetGroupDto extends EntityDtoOfString {
    name?: string | undefined;
    mineModelId?: string | undefined;
    pourPresets?: PourPresetDto[] | undefined;
}

export function makePourPresetGroupDto (model: PourPresetGroupDto): PourPresetGroupDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
    mineModelId: model.mineModelId,
    pourPresets: (model.pourPresets?.map((item) => makePourPresetDto(item))),
  };
}

makeFunctions.PourPresetGroupDto = makePourPresetGroupDto;

export interface UpdatePourPresetForm {
    name?: string | undefined;
    ucsStrength?: number;
    curingDays?: number;
    volume?: number | undefined;
    height?: number | undefined;
    fillRemainingHeight?: boolean;
    rheologyDatasetId?: string | undefined;
    isRockFill?: boolean;
}

export function makeUpdatePourPresetForm (model: UpdatePourPresetForm): UpdatePourPresetForm {
  return {
    name: model.name,
    ucsStrength: model.ucsStrength,
    curingDays: model.curingDays,
    volume: model.volume,
    height: model.height,
    fillRemainingHeight: model.fillRemainingHeight,
    rheologyDatasetId: model.rheologyDatasetId,
    isRockFill: model.isRockFill,
  };
}

makeFunctions.UpdatePourPresetForm = makeUpdatePourPresetForm;

export interface ReorderPourPresetsForm {
    orderedPresetIds?: string[] | undefined;
}

export function makeReorderPourPresetsForm (model: ReorderPourPresetsForm): ReorderPourPresetsForm {
  return {
    orderedPresetIds: model.orderedPresetIds,
  };
}

makeFunctions.ReorderPourPresetsForm = makeReorderPourPresetsForm;

export interface CreateApprovalPresetGroupForm {
    name: string;
}

export function makeCreateApprovalPresetGroupForm (model: CreateApprovalPresetGroupForm): CreateApprovalPresetGroupForm {
  return {
    name: model.name,
  };
}

makeFunctions.CreateApprovalPresetGroupForm = makeCreateApprovalPresetGroupForm;

export interface PagedListOfApprovalPresetGroupDto {
    items: ApprovalPresetGroupDto[];
    pager: Pager;
}

export function makePagedListOfApprovalPresetGroupDto (model: PagedListOfApprovalPresetGroupDto): PagedListOfApprovalPresetGroupDto {
  return {
    items: (model.items?.map((item) => makeApprovalPresetGroupDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfApprovalPresetGroupDto = makePagedListOfApprovalPresetGroupDto;

export interface ApprovalPresetGroupDto extends EntityDtoOfString {
    name?: string | undefined;
    mineModelId?: string | undefined;
    emails?: string[] | undefined;
}

export function makeApprovalPresetGroupDto (model: ApprovalPresetGroupDto): ApprovalPresetGroupDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
    mineModelId: model.mineModelId,
    emails: model.emails,
  };
}

makeFunctions.ApprovalPresetGroupDto = makeApprovalPresetGroupDto;

export interface AddApprovalPresetGroupEmailForm {
    email: string;
}

export function makeAddApprovalPresetGroupEmailForm (model: AddApprovalPresetGroupEmailForm): AddApprovalPresetGroupEmailForm {
  return {
    email: model.email,
  };
}

makeFunctions.AddApprovalPresetGroupEmailForm = makeAddApprovalPresetGroupEmailForm;

export interface PagedListOfStopePoursDto {
    items: StopePoursDto[];
    pager: Pager;
}

export function makePagedListOfStopePoursDto (model: PagedListOfStopePoursDto): PagedListOfStopePoursDto {
  return {
    items: (model.items?.map((item) => makeStopePoursDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfStopePoursDto = makePagedListOfStopePoursDto;

export interface StopePoursDto {
    stopeSummary?: StopeBackfillSummaryDto | undefined;
    pours?: PourDto[] | undefined;
    stope?: StopeDataDto | undefined;
}

export function makeStopePoursDto (model: StopePoursDto): StopePoursDto {
  return {
    stopeSummary: model.stopeSummary ? makeStopeBackfillSummaryDto(model.stopeSummary) : model.stopeSummary,
    pours: (model.pours?.map((item) => makePourDto(item))),
    stope: model.stope ? makeStopeDataDto(model.stope) : model.stope,
  };
}

makeFunctions.StopePoursDto = makeStopePoursDto;

export interface BulkDeletePoursRequest {
    pourIds: string[];
}

export function makeBulkDeletePoursRequest (model: BulkDeletePoursRequest): BulkDeletePoursRequest {
  return {
    pourIds: model.pourIds,
  };
}

makeFunctions.BulkDeletePoursRequest = makeBulkDeletePoursRequest;

export interface BinderDeliveryDto extends EntityDtoOfString {
    supplier: string;
    brand?: string;
    notes?: string;
    /** NodaTimeType:ZonedDateTime */
    deliveryDate: ZonedDateTime;    
    tonnesDelivered: number;
    projectId: string;
}

export function makeBinderDeliveryDto (model: BinderDeliveryDto): BinderDeliveryDto {
  return {
      ...makeEntityDtoOfString(model),
    supplier: model.supplier,
    brand: model.brand,
    notes: model.notes,
    deliveryDate: model.deliveryDate && typeof model.deliveryDate === 'string' ? makeZonedDateTime(model.deliveryDate) : model.deliveryDate,
    tonnesDelivered: model.tonnesDelivered,
    projectId: model.projectId,
  };
}

makeFunctions.BinderDeliveryDto = makeBinderDeliveryDto;

export interface PagedListOfBinderDeliveryDto {
    items: BinderDeliveryDto[];
    pager: Pager;
}

export function makePagedListOfBinderDeliveryDto (model: PagedListOfBinderDeliveryDto): PagedListOfBinderDeliveryDto {
  return {
    items: (model.items?.map((item) => makeBinderDeliveryDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfBinderDeliveryDto = makePagedListOfBinderDeliveryDto;

export interface BinderDeliveryForm {
    supplier: string;
    brand?: string | undefined;
    notes?: string | undefined;
    /** NodaTimeType:LocalDateTime */
    deliveryDate: LocalDateTime;    
    tonnesDelivered: number;
}

export function makeBinderDeliveryForm (model: BinderDeliveryForm): BinderDeliveryForm {
  return {
    supplier: model.supplier,
    brand: model.brand,
    notes: model.notes,
    deliveryDate: model.deliveryDate && typeof model.deliveryDate === 'string' ? makeLocalDateTime(model.deliveryDate) : model.deliveryDate,
    tonnesDelivered: model.tonnesDelivered,
  };
}

makeFunctions.BinderDeliveryForm = makeBinderDeliveryForm;

export interface BinderCostRecordDto extends EntityDtoOfString {
    brand: string;
    supplier: string;
    /** NodaTimeType:ZonedDateTime */
    purchaseDate: ZonedDateTime;    
    pricePerTonne: number;
    projectId: string;
}

export function makeBinderCostRecordDto (model: BinderCostRecordDto): BinderCostRecordDto {
  return {
      ...makeEntityDtoOfString(model),
    brand: model.brand,
    supplier: model.supplier,
    purchaseDate: model.purchaseDate && typeof model.purchaseDate === 'string' ? makeZonedDateTime(model.purchaseDate) : model.purchaseDate,
    pricePerTonne: model.pricePerTonne,
    projectId: model.projectId,
  };
}

makeFunctions.BinderCostRecordDto = makeBinderCostRecordDto;

export interface PagedListOfBinderCostRecordDto {
    items: BinderCostRecordDto[];
    pager: Pager;
}

export function makePagedListOfBinderCostRecordDto (model: PagedListOfBinderCostRecordDto): PagedListOfBinderCostRecordDto {
  return {
    items: (model.items?.map((item) => makeBinderCostRecordDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfBinderCostRecordDto = makePagedListOfBinderCostRecordDto;

export interface BinderCostRecordForm {
    brand: string;
    supplier: string;
    /** NodaTimeType:LocalDateTime */
    purchaseDate: LocalDateTime;    
    pricePerTonne: number;
}

export function makeBinderCostRecordForm (model: BinderCostRecordForm): BinderCostRecordForm {
  return {
    brand: model.brand,
    supplier: model.supplier,
    purchaseDate: model.purchaseDate && typeof model.purchaseDate === 'string' ? makeLocalDateTime(model.purchaseDate) : model.purchaseDate,
    pricePerTonne: model.pricePerTonne,
  };
}

makeFunctions.BinderCostRecordForm = makeBinderCostRecordForm;

export interface BinderSupplierDto extends EntityDtoOfString {
    name: string;
    brands?: string[];
    projectId: string;
}

export function makeBinderSupplierDto (model: BinderSupplierDto): BinderSupplierDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
    brands: model.brands,
    projectId: model.projectId,
  };
}

makeFunctions.BinderSupplierDto = makeBinderSupplierDto;

export interface BinderSupplierForm {
    name: string;
    brands?: string[];
}

export function makeBinderSupplierForm (model: BinderSupplierForm): BinderSupplierForm {
  return {
    name: model.name,
    brands: model.brands,
  };
}

makeFunctions.BinderSupplierForm = makeBinderSupplierForm;

export interface MineModelDto extends EntityDtoOfString {
    initialModelCenter?: Point3DDto | undefined;
    initialOrientation?: Orientation3DDto | undefined;
    reticulationData?: ReticulationDataDto | undefined;
    rheologyDataList?: RheologyDataSummaryDto[] | undefined;
    tunnelProfile?: TunnelProfileDto | undefined;
}

export function makeMineModelDto (model: MineModelDto): MineModelDto {
  return {
      ...makeEntityDtoOfString(model),
    initialModelCenter: model.initialModelCenter ? makePoint3DDto(model.initialModelCenter) : model.initialModelCenter,
    initialOrientation: model.initialOrientation ? makeOrientation3DDto(model.initialOrientation) : model.initialOrientation,
    reticulationData: model.reticulationData ? makeReticulationDataDto(model.reticulationData) : model.reticulationData,
    rheologyDataList: (model.rheologyDataList?.map((item) => makeRheologyDataSummaryDto(item))),
    tunnelProfile: model.tunnelProfile ? makeTunnelProfileDto(model.tunnelProfile) : model.tunnelProfile,
  };
}

makeFunctions.MineModelDto = makeMineModelDto;

export interface Orientation3DDto {
    x: number;
    y: number;
    z: number;
}

export function makeOrientation3DDto (model: Orientation3DDto): Orientation3DDto {
  return {
    x: model.x,
    y: model.y,
    z: model.z,
  };
}

makeFunctions.Orientation3DDto = makeOrientation3DDto;

export interface ReticulationDataDto {
    /** NodaTimeType:Instant */
    generated: Instant;    
    pipeData: PipeDataDto[];
    nodes: ModelNodeDto[];
    spools: SpoolDto[];
    stopeLocations: StopeLocationDto[];
    stopes: StopeDataDto[];
}

export function makeReticulationDataDto (model: ReticulationDataDto): ReticulationDataDto {
  return {
    generated: model.generated && typeof model.generated === 'string' ? makeInstant(model.generated) : model.generated,
    pipeData: (model.pipeData?.map((item) => makePipeDataDto(item))),
    nodes: (model.nodes?.map((item) => makeModelNodeDto(item))),
    spools: (model.spools?.map((item) => makeSpoolDto(item))),
    stopeLocations: (model.stopeLocations?.map((item) => makeStopeLocationDto(item))),
    stopes: (model.stopes?.map((item) => makeStopeDataDto(item))),
  };
}

makeFunctions.ReticulationDataDto = makeReticulationDataDto;

export interface PipeDataDto {
    pipeId: string;
    name: string;
    pipeClass: string;
    insideDiameter: number;
    minimumVelocity: number;
    maximumVelocity: number;
    pressureRating: number;
    minimumPressure: number;
    colour: string;
    startingThickness?: number | undefined;
    minimumThickness?: number | undefined;
    calculationMode?: string | undefined;
    dimensionStandard?: string | undefined;
    pipeSize?: string | undefined;
    wallSelection?: string | undefined;
    outsideDiameter?: number | undefined;
    wallThickness?: number | undefined;
    liningThickness?: number | undefined;
    wearAllowance?: number | undefined;
    materialStandard?: string | undefined;
    materialGrade?: string | undefined;
    pressureRatingCode?: string | undefined;
    factorOfSafety?: number | undefined;
    weldType?: string | undefined;
    couplingStandard?: string | undefined;
    couplingClass?: string | undefined;
    cutDepth?: number | undefined;
    pipePressureRating?: number | undefined;
    couplingPressureRating?: number | undefined;
    designTemperature?: number | undefined;
    pipeRoughness?: number | undefined;
}

export function makePipeDataDto (model: PipeDataDto): PipeDataDto {
  return {
    pipeId: model.pipeId,
    name: model.name,
    pipeClass: model.pipeClass,
    insideDiameter: model.insideDiameter,
    minimumVelocity: model.minimumVelocity,
    maximumVelocity: model.maximumVelocity,
    pressureRating: model.pressureRating,
    minimumPressure: model.minimumPressure,
    colour: model.colour,
    startingThickness: model.startingThickness,
    minimumThickness: model.minimumThickness,
    calculationMode: model.calculationMode,
    dimensionStandard: model.dimensionStandard,
    pipeSize: model.pipeSize,
    wallSelection: model.wallSelection,
    outsideDiameter: model.outsideDiameter,
    wallThickness: model.wallThickness,
    liningThickness: model.liningThickness,
    wearAllowance: model.wearAllowance,
    materialStandard: model.materialStandard,
    materialGrade: model.materialGrade,
    pressureRatingCode: model.pressureRatingCode,
    factorOfSafety: model.factorOfSafety,
    weldType: model.weldType,
    couplingStandard: model.couplingStandard,
    couplingClass: model.couplingClass,
    cutDepth: model.cutDepth,
    pipePressureRating: model.pipePressureRating,
    couplingPressureRating: model.couplingPressureRating,
    designTemperature: model.designTemperature,
    pipeRoughness: model.pipeRoughness,
  };
}

makeFunctions.PipeDataDto = makePipeDataDto;

export interface ModelNodeDto {
    nodeId: string;
    nodeName: string;
    point: Point3DDto;
    pipeId: string;
    pit: string;
    isPit: boolean;
    level: string;
    area: string;
    isStope: boolean;
    totalVolumeThroughNode?: number | undefined;
    totalDryTonnesThroughNode?: number | undefined;
    stopeData?: StopeDataForm | undefined;
    boosterPressure?: number | undefined;
    ruptureDiskPressure?: number | undefined;
    chokeHead?: number | undefined;
    isPlantNode?: boolean;
    isManuallyAdded?: boolean | undefined;
}

export function makeModelNodeDto (model: ModelNodeDto): ModelNodeDto {
  return {
    nodeId: model.nodeId,
    nodeName: model.nodeName,
    point: model.point ? makePoint3DDto(model.point) : model.point,
    pipeId: model.pipeId,
    pit: model.pit,
    isPit: model.isPit,
    level: model.level,
    area: model.area,
    isStope: model.isStope,
    totalVolumeThroughNode: model.totalVolumeThroughNode,
    totalDryTonnesThroughNode: model.totalDryTonnesThroughNode,
    stopeData: model.stopeData ? makeStopeDataForm(model.stopeData) : model.stopeData,
    boosterPressure: model.boosterPressure,
    ruptureDiskPressure: model.ruptureDiskPressure,
    chokeHead: model.chokeHead,
    isPlantNode: model.isPlantNode,
    isManuallyAdded: model.isManuallyAdded,
  };
}

makeFunctions.ModelNodeDto = makeModelNodeDto;

export interface StopeDataForm {
    stopeId?: string | undefined;
    stopeName: string;
    volume: number;
    level?: string | undefined;
    area?: string | undefined;
    pourPresetGroupId?: string | undefined;
    documents?: DocumentDto[] | undefined;
    pipeArrays?: StopePipeArray[] | undefined;
    /** NodaTimeType:LocalDate */
    startDate?: LocalDate | undefined;    
    /** NodaTimeType:LocalDate */
    endDate?: LocalDate | undefined;    
}

export function makeStopeDataForm (model: StopeDataForm): StopeDataForm {
  return {
    stopeId: model.stopeId,
    stopeName: model.stopeName,
    volume: model.volume,
    level: model.level,
    area: model.area,
    pourPresetGroupId: model.pourPresetGroupId,
    documents: (model.documents?.map((item) => makeDocumentDto(item))),
    pipeArrays: (model.pipeArrays?.map((item) => makeStopePipeArray(item))),
    startDate: model.startDate && typeof model.startDate === 'string' ? makeLocalDate(model.startDate) : model.startDate,
    endDate: model.endDate && typeof model.endDate === 'string' ? makeLocalDate(model.endDate) : model.endDate,
  };
}

makeFunctions.StopeDataForm = makeStopeDataForm;

export interface DocumentDto {
    fileName?: string | undefined;
    contentType?: string | undefined;
    content?: string | undefined;
}

export function makeDocumentDto (model: DocumentDto): DocumentDto {
  return {
    fileName: model.fileName,
    contentType: model.contentType,
    content: model.content,
  };
}

makeFunctions.DocumentDto = makeDocumentDto;

export interface SpoolDto {
    spoolId: string;
    nodeAId: string;
    nodeBId: string;
    pipeId: string;
    allowFlowAB: boolean;
    allowFlowBA: boolean;
    chokeLength: number;
    totalVolumeThroughSpool?: number | undefined;
    totalDryTonnesThroughSpool?: number | undefined;
    name?: string | undefined;
    /** NodaTimeType:LocalDate */
    installedOn?: LocalDate | undefined;    
    /** NodaTimeType:LocalDate */
    removedOn?: LocalDate | undefined;    
    status: SpoolStatus;
    other?: string | undefined;
    level?: string | undefined;
    area?: string | undefined;
}

export function makeSpoolDto (model: SpoolDto): SpoolDto {
  return {
    spoolId: model.spoolId,
    nodeAId: model.nodeAId,
    nodeBId: model.nodeBId,
    pipeId: model.pipeId,
    allowFlowAB: model.allowFlowAB,
    allowFlowBA: model.allowFlowBA,
    chokeLength: model.chokeLength,
    totalVolumeThroughSpool: model.totalVolumeThroughSpool,
    totalDryTonnesThroughSpool: model.totalDryTonnesThroughSpool,
    name: model.name,
    installedOn: model.installedOn && typeof model.installedOn === 'string' ? makeLocalDate(model.installedOn) : model.installedOn,
    removedOn: model.removedOn && typeof model.removedOn === 'string' ? makeLocalDate(model.removedOn) : model.removedOn,
    status: model.status ? makeSpoolStatus(model.status) : model.status,
    other: model.other,
    level: model.level,
    area: model.area,
  };
}

makeFunctions.SpoolDto = makeSpoolDto;

/** Whether a spool is part of the routable network. No 0 member: a spool persisted before the status existed carries no key and loads as Active. */
export enum SpoolStatus {
    Active = 1,
    Inactive = 2,
}

function makeSpoolStatus (value: SpoolStatus): SpoolStatus {
  return value;
}

makeFunctions.SpoolStatus = makeSpoolStatus;

export interface StopeLocationDto {
    stopeId: string;
    nodeId: string;
}

export function makeStopeLocationDto (model: StopeLocationDto): StopeLocationDto {
  return {
    stopeId: model.stopeId,
    nodeId: model.nodeId,
  };
}

makeFunctions.StopeLocationDto = makeStopeLocationDto;

export interface RheologyDataSummaryDto {
    mineModelId: string;
    rheologyDataSetId: string;
    reference: string;
    version: string;
    /** NodaTimeType:Instant */
    generated: Instant;    
    entries: number;
    isComplete?: boolean;
    isDeactivated?: boolean;
}

export function makeRheologyDataSummaryDto (model: RheologyDataSummaryDto): RheologyDataSummaryDto {
  return {
    mineModelId: model.mineModelId,
    rheologyDataSetId: model.rheologyDataSetId,
    reference: model.reference,
    version: model.version,
    generated: model.generated && typeof model.generated === 'string' ? makeInstant(model.generated) : model.generated,
    entries: model.entries,
    isComplete: model.isComplete,
    isDeactivated: model.isDeactivated,
  };
}

makeFunctions.RheologyDataSummaryDto = makeRheologyDataSummaryDto;

export interface TunnelProfileDto {
    geometryFile?: ImageSummary | undefined;
    opacity?: number;
    visible?: boolean;
}

export function makeTunnelProfileDto (model: TunnelProfileDto): TunnelProfileDto {
  return {
    geometryFile: model.geometryFile ? makeImageSummary(model.geometryFile) : model.geometryFile,
    opacity: model.opacity,
    visible: model.visible,
  };
}

makeFunctions.TunnelProfileDto = makeTunnelProfileDto;

export interface RheologyDataAbstractsRequestDto {
    rheologyDataSetIds?: string[] | undefined;
}

export function makeRheologyDataAbstractsRequestDto (model: RheologyDataAbstractsRequestDto): RheologyDataAbstractsRequestDto {
  return {
    rheologyDataSetIds: model.rheologyDataSetIds,
  };
}

makeFunctions.RheologyDataAbstractsRequestDto = makeRheologyDataAbstractsRequestDto;

export interface MineModelSummaryDto {
    reticulationData?: ReticulationDataSummaryDto | undefined;
    rheologyDataList?: RheologyDataSummaryDto[] | undefined;
}

export function makeMineModelSummaryDto (model: MineModelSummaryDto): MineModelSummaryDto {
  return {
    reticulationData: model.reticulationData ? makeReticulationDataSummaryDto(model.reticulationData) : model.reticulationData,
    rheologyDataList: (model.rheologyDataList?.map((item) => makeRheologyDataSummaryDto(item))),
  };
}

makeFunctions.MineModelSummaryDto = makeMineModelSummaryDto;

export interface ReticulationDataSummaryDto {
    pipes?: number;
    nodes?: number;
    stopes?: number;
    spools?: number;
    stopesWithData?: number;
}

export function makeReticulationDataSummaryDto (model: ReticulationDataSummaryDto): ReticulationDataSummaryDto {
  return {
    pipes: model.pipes,
    nodes: model.nodes,
    stopes: model.stopes,
    spools: model.spools,
    stopesWithData: model.stopesWithData,
  };
}

makeFunctions.ReticulationDataSummaryDto = makeReticulationDataSummaryDto;

export interface PagedListOfInspectionPointDto {
    items: InspectionPointDto[];
    pager: Pager;
}

export function makePagedListOfInspectionPointDto (model: PagedListOfInspectionPointDto): PagedListOfInspectionPointDto {
  return {
    items: (model.items?.map((item) => makeInspectionPointDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfInspectionPointDto = makePagedListOfInspectionPointDto;

export interface InspectionPointDto extends EntityDtoOfString {
    name: string;
    /** The spool the point measures. Null only on a legacy point the migration could not relink. */
    spoolId?: string | undefined;
    /** Legacy anchor, for display only: where an unassigned point used to sit. */
    nodeId?: string | undefined;
}

export function makeInspectionPointDto (model: InspectionPointDto): InspectionPointDto {
  return {
      ...makeEntityDtoOfString(model),
    name: model.name,
    spoolId: model.spoolId,
    nodeId: model.nodeId,
  };
}

makeFunctions.InspectionPointDto = makeInspectionPointDto;

export interface PagedListOfWearDataDto {
    items: WearDataDto[];
    pager: Pager;
}

export function makePagedListOfWearDataDto (model: PagedListOfWearDataDto): PagedListOfWearDataDto {
  return {
    items: (model.items?.map((item) => makeWearDataDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfWearDataDto = makePagedListOfWearDataDto;

export interface WearDataDto extends EntityDtoOfString {
    position1?: number | undefined;
    position2?: number | undefined;
    position3?: number | undefined;
    position4?: number | undefined;
    position5?: number | undefined;
    position6?: number | undefined;
    position7?: number | undefined;
    position8?: number | undefined;
    average: number;
    inspectionPointId: string;
    /** NodaTimeType:ZonedDateTime */
    createdDate: ZonedDateTime;    
    /** NodaTimeType:ZonedDateTime */
    inspectionDate: ZonedDateTime;    
}

export function makeWearDataDto (model: WearDataDto): WearDataDto {
  return {
      ...makeEntityDtoOfString(model),
    position1: model.position1,
    position2: model.position2,
    position3: model.position3,
    position4: model.position4,
    position5: model.position5,
    position6: model.position6,
    position7: model.position7,
    position8: model.position8,
    average: model.average,
    inspectionPointId: model.inspectionPointId,
    createdDate: model.createdDate && typeof model.createdDate === 'string' ? makeZonedDateTime(model.createdDate) : model.createdDate,
    inspectionDate: model.inspectionDate && typeof model.inspectionDate === 'string' ? makeZonedDateTime(model.inspectionDate) : model.inspectionDate,
  };
}

makeFunctions.WearDataDto = makeWearDataDto;

export interface ReticulationDataImportDto {
    /** DateTime */
    date: Date;
    pipe_data: PipeDataImportDto[];
    node_data?: ModelNodeImportDto[] | undefined;
    spool_data: SpoolImportDto[];
    stope_data: StopeDataImportDto[];
    rheology_data?: RheologyDataForm[] | undefined;
}

export function makeReticulationDataImportDto (model: ReticulationDataImportDto): ReticulationDataImportDto {
  return {
    date: model.date && typeof model.date === 'string' ? makeDate(model.date) : model.date,
    pipe_data: (model.pipe_data?.map((item) => makePipeDataImportDto(item))),
    node_data: (model.node_data?.map((item) => makeModelNodeImportDto(item))),
    spool_data: (model.spool_data?.map((item) => makeSpoolImportDto(item))),
    stope_data: (model.stope_data?.map((item) => makeStopeDataImportDto(item))),
    rheology_data: (model.rheology_data?.map((item) => makeRheologyDataForm(item))),
  };
}

makeFunctions.ReticulationDataImportDto = makeReticulationDataImportDto;

export interface PipeDataImportDto {
    PIPE_ID: string;
    name: string | undefined;
    class: string;
    inside_diameter: number;
    minimum_v: number;
    maximum_v: number;
    p_rating: number;
    p_minimum: number;
    starting_thickness?: number | undefined;
    minimum_thickness?: number | undefined;
    colour?: string | undefined;
    calculation_mode?: string | undefined;
    dimension_standard?: string | undefined;
    pipe_size?: string | undefined;
    wall_selection?: string | undefined;
    outside_diameter?: number | undefined;
    wall_thickness?: number | undefined;
    lining_thickness?: number | undefined;
    wear_allowance?: number | undefined;
    material_standard?: string | undefined;
    material_grade?: string | undefined;
    pressure_rating_code?: string | undefined;
    factor_of_safety?: number | undefined;
    weld_type?: string | undefined;
    coupling_standard?: string | undefined;
    coupling_class?: string | undefined;
    cut_depth?: number | undefined;
    pipe_pressure_rating?: number | undefined;
    coupling_pressure_rating?: number | undefined;
    design_temperature?: number | undefined;
    pipe_roughness?: number | undefined;
}

export function makePipeDataImportDto (model: PipeDataImportDto): PipeDataImportDto {
  return {
    PIPE_ID: model.PIPE_ID,
    name: model.name,
    class: model.class,
    inside_diameter: model.inside_diameter,
    minimum_v: model.minimum_v,
    maximum_v: model.maximum_v,
    p_rating: model.p_rating,
    p_minimum: model.p_minimum,
    starting_thickness: model.starting_thickness,
    minimum_thickness: model.minimum_thickness,
    colour: model.colour,
    calculation_mode: model.calculation_mode,
    dimension_standard: model.dimension_standard,
    pipe_size: model.pipe_size,
    wall_selection: model.wall_selection,
    outside_diameter: model.outside_diameter,
    wall_thickness: model.wall_thickness,
    lining_thickness: model.lining_thickness,
    wear_allowance: model.wear_allowance,
    material_standard: model.material_standard,
    material_grade: model.material_grade,
    pressure_rating_code: model.pressure_rating_code,
    factor_of_safety: model.factor_of_safety,
    weld_type: model.weld_type,
    coupling_standard: model.coupling_standard,
    coupling_class: model.coupling_class,
    cut_depth: model.cut_depth,
    pipe_pressure_rating: model.pipe_pressure_rating,
    coupling_pressure_rating: model.coupling_pressure_rating,
    design_temperature: model.design_temperature,
    pipe_roughness: model.pipe_roughness,
  };
}

makeFunctions.PipeDataImportDto = makePipeDataImportDto;

export interface ModelNodeImportDto {
    NODE_ID: string;
    NODE_NAME?: string | undefined;
    x: number;
    y: number;
    z: number;
    previous_node?: NodeId[] | undefined;
    choke_length?: number;
    spool_pipe_overrides?: { [key: string]: string; } | undefined;
    stope: boolean;
    PIPE_ID: string;
    pit_name?: string | undefined;
    pit: boolean;
    area?: string | undefined;
    level?: string | undefined;
    booster_pressure?: number;
    rupture_disk_pressure?: number;
    choke_head?: number | undefined;
    plant_node: boolean;
    total_volume_through_node?: number | undefined;
    total_dry_tonnes_through_node?: number | undefined;
}

export function makeModelNodeImportDto (model: ModelNodeImportDto): ModelNodeImportDto {
  return {
    NODE_ID: model.NODE_ID,
    NODE_NAME: model.NODE_NAME,
    x: model.x,
    y: model.y,
    z: model.z,
    previous_node: (model.previous_node?.map((item) => makeNodeId(item))),
    choke_length: model.choke_length,
    spool_pipe_overrides: model.spool_pipe_overrides,
    stope: model.stope,
    PIPE_ID: model.PIPE_ID,
    pit_name: model.pit_name,
    pit: model.pit,
    area: model.area,
    level: model.level,
    booster_pressure: model.booster_pressure,
    rupture_disk_pressure: model.rupture_disk_pressure,
    choke_head: model.choke_head,
    plant_node: model.plant_node,
    total_volume_through_node: model.total_volume_through_node,
    total_dry_tonnes_through_node: model.total_dry_tonnes_through_node,
  };
}

makeFunctions.ModelNodeImportDto = makeModelNodeImportDto;

export interface ValueObjectOfNodeId {
}

export function makeValueObjectOfNodeId (model: ValueObjectOfNodeId): ValueObjectOfNodeId {
  return {
  };
}

makeFunctions.ValueObjectOfNodeId = makeValueObjectOfNodeId;

export interface ItemIdOfNodeId extends ValueObjectOfNodeId {
    value?: string | undefined;
}

export function makeItemIdOfNodeId (model: ItemIdOfNodeId): ItemIdOfNodeId {
  return {
      ...makeValueObjectOfNodeId(model),
    value: model.value,
  };
}

makeFunctions.ItemIdOfNodeId = makeItemIdOfNodeId;

export interface NodeId extends ItemIdOfNodeId {
}

export function makeNodeId (model: NodeId): NodeId {
  return {
      ...makeItemIdOfNodeId(model),
  };
}

makeFunctions.NodeId = makeNodeId;

export interface SpoolImportDto {
    /** Optional. A spool id is an opaque GUID, so the server mints one when the payload omits it. Clients
that mint their own (for optimistic state) send it and it is persisted verbatim. */
    SPOOL_ID?: string | undefined;
    nodeAId: string;
    nodeBId: string;
    pipeId: string;
    allowFlowAB: boolean;
    allowFlowBA: boolean;
    chokeLength: number;
    totalVolumeThroughSpool?: number | undefined;
    totalDryTonnesThroughSpool?: number | undefined;
    name?: string | undefined;
    /** NodaTimeType:LocalDate */
    installedOn?: LocalDate | undefined;    
    /** NodaTimeType:LocalDate */
    removedOn?: LocalDate | undefined;    
    /** Optional: a file or client payload that does not send it means Active. */
    status?: SpoolStatus | undefined;
    other?: string | undefined;
    level?: string | undefined;
    area?: string | undefined;
}

export function makeSpoolImportDto (model: SpoolImportDto): SpoolImportDto {
  return {
    SPOOL_ID: model.SPOOL_ID,
    nodeAId: model.nodeAId,
    nodeBId: model.nodeBId,
    pipeId: model.pipeId,
    allowFlowAB: model.allowFlowAB,
    allowFlowBA: model.allowFlowBA,
    chokeLength: model.chokeLength,
    totalVolumeThroughSpool: model.totalVolumeThroughSpool,
    totalDryTonnesThroughSpool: model.totalDryTonnesThroughSpool,
    name: model.name,
    installedOn: model.installedOn && typeof model.installedOn === 'string' ? makeLocalDate(model.installedOn) : model.installedOn,
    removedOn: model.removedOn && typeof model.removedOn === 'string' ? makeLocalDate(model.removedOn) : model.removedOn,
    status: model.status ? makeSpoolStatus(model.status) : model.status,
    other: model.other,
    level: model.level,
    area: model.area,
  };
}

makeFunctions.SpoolImportDto = makeSpoolImportDto;

export interface StopeDataImportDto {
    STOPE_ID: string;
    STOPE_NAME?: string | undefined;
    NODE_ID: string;
    reference_1?: string | undefined;
    reference_2?: string | undefined;
    reference_3?: string | undefined;
    reference_4?: string | undefined;
    reference_5?: string | undefined;
    pipes?: StopePipeArrayImportDto[] | undefined;
    pipe_length?: number | undefined;
    pipe_horizontal_length?: number | undefined;
    pipe_vertical_length?: number | undefined;
    PIPE_ID?: string | undefined;
    volume?: number | undefined;
    level?: string | undefined;
    area?: string | undefined;
    pour_preset_group_name?: string | undefined;
}

export function makeStopeDataImportDto (model: StopeDataImportDto): StopeDataImportDto {
  return {
    STOPE_ID: model.STOPE_ID,
    STOPE_NAME: model.STOPE_NAME,
    NODE_ID: model.NODE_ID,
    reference_1: model.reference_1,
    reference_2: model.reference_2,
    reference_3: model.reference_3,
    reference_4: model.reference_4,
    reference_5: model.reference_5,
    pipes: (model.pipes?.map((item) => makeStopePipeArrayImportDto(item))),
    pipe_length: model.pipe_length,
    pipe_horizontal_length: model.pipe_horizontal_length,
    pipe_vertical_length: model.pipe_vertical_length,
    PIPE_ID: model.PIPE_ID,
    volume: model.volume,
    level: model.level,
    area: model.area,
    pour_preset_group_name: model.pour_preset_group_name,
  };
}

makeFunctions.StopeDataImportDto = makeStopeDataImportDto;

export interface StopePipeArrayImportDto {
    pipe_id: string | undefined;
    pipe_vertical_length?: number | undefined;
    pipe_horizontal_length?: number | undefined;
}

export function makeStopePipeArrayImportDto (model: StopePipeArrayImportDto): StopePipeArrayImportDto {
  return {
    pipe_id: model.pipe_id,
    pipe_vertical_length: model.pipe_vertical_length,
    pipe_horizontal_length: model.pipe_horizontal_length,
  };
}

makeFunctions.StopePipeArrayImportDto = makeStopePipeArrayImportDto;

export interface RheologyDataForm {
    version?: string | undefined;
    reference?: string | undefined;
    /** DateTime */
    generatedUtc?: Date;
    ucsCoefficients?: UcsCoefficientsForm[] | undefined;
    mixerCoefficients?: MixerCoefficientsForm | undefined;
    pumpPressure?: PumpPressureForm | undefined;
    tailingsDrySolidsDensity?: number;
    carrierFluidDensity?: number;
    binderDryParticleDensity?: number;
    yieldStressCoefficients?: YieldStressCoefficientsForm | undefined;
    heightOfCylinder?: number;
    binder?: BinderForm | undefined;
    tonnage?: TonnageForm | undefined;
    viscosityCoefficients?: ViscosityCoefficientsForm | undefined;
    massConcentration?: MassConcentrationForm | undefined;
    frictionLossFactorOfSafety?: number;
}

export function makeRheologyDataForm (model: RheologyDataForm): RheologyDataForm {
  return {
    version: model.version,
    reference: model.reference,
    generatedUtc: model.generatedUtc && typeof model.generatedUtc === 'string' ? makeDate(model.generatedUtc) : model.generatedUtc,
    ucsCoefficients: (model.ucsCoefficients?.map((item) => makeUcsCoefficientsForm(item))),
    mixerCoefficients: model.mixerCoefficients ? makeMixerCoefficientsForm(model.mixerCoefficients) : model.mixerCoefficients,
    pumpPressure: model.pumpPressure ? makePumpPressureForm(model.pumpPressure) : model.pumpPressure,
    tailingsDrySolidsDensity: model.tailingsDrySolidsDensity,
    carrierFluidDensity: model.carrierFluidDensity,
    binderDryParticleDensity: model.binderDryParticleDensity,
    yieldStressCoefficients: model.yieldStressCoefficients ? makeYieldStressCoefficientsForm(model.yieldStressCoefficients) : model.yieldStressCoefficients,
    heightOfCylinder: model.heightOfCylinder,
    binder: model.binder ? makeBinderForm(model.binder) : model.binder,
    tonnage: model.tonnage ? makeTonnageForm(model.tonnage) : model.tonnage,
    viscosityCoefficients: model.viscosityCoefficients ? makeViscosityCoefficientsForm(model.viscosityCoefficients) : model.viscosityCoefficients,
    massConcentration: model.massConcentration ? makeMassConcentrationForm(model.massConcentration) : model.massConcentration,
    frictionLossFactorOfSafety: model.frictionLossFactorOfSafety,
  };
}

makeFunctions.RheologyDataForm = makeRheologyDataForm;

export interface UcsCoefficientsForm {
    targetDays?: number;
    coefficient1?: number;
    coefficient2?: number;
    minUCS?: number | undefined;
    maxUCS?: number | undefined;
}

export function makeUcsCoefficientsForm (model: UcsCoefficientsForm): UcsCoefficientsForm {
  return {
    targetDays: model.targetDays,
    coefficient1: model.coefficient1,
    coefficient2: model.coefficient2,
    minUCS: model.minUCS,
    maxUCS: model.maxUCS,
  };
}

makeFunctions.UcsCoefficientsForm = makeUcsCoefficientsForm;

export interface MixerCoefficientsForm {
    continuousMixerCoefficientC?: number;
    continuousMixerCoefficientD?: number;
    continuousMixerCoefficientM?: number;
    continuousMixerCoefficientN?: number;
    batchMixerCoefficientD?: number;
    batchMixerCoefficientM?: number;
    batchMixerCoefficientN?: number;
}

export function makeMixerCoefficientsForm (model: MixerCoefficientsForm): MixerCoefficientsForm {
  return {
    continuousMixerCoefficientC: model.continuousMixerCoefficientC,
    continuousMixerCoefficientD: model.continuousMixerCoefficientD,
    continuousMixerCoefficientM: model.continuousMixerCoefficientM,
    continuousMixerCoefficientN: model.continuousMixerCoefficientN,
    batchMixerCoefficientD: model.batchMixerCoefficientD,
    batchMixerCoefficientM: model.batchMixerCoefficientM,
    batchMixerCoefficientN: model.batchMixerCoefficientN,
  };
}

makeFunctions.MixerCoefficientsForm = makeMixerCoefficientsForm;

export interface PumpPressureForm {
    max: number;
    default: number;
}

export function makePumpPressureForm (model: PumpPressureForm): PumpPressureForm {
  return {
    max: model.max,
    default: model.default,
  };
}

makeFunctions.PumpPressureForm = makePumpPressureForm;

export interface YieldStressCoefficientsForm {
    coefficient1: number;
    coefficient2: number;
}

export function makeYieldStressCoefficientsForm (model: YieldStressCoefficientsForm): YieldStressCoefficientsForm {
  return {
    coefficient1: model.coefficient1,
    coefficient2: model.coefficient2,
  };
}

makeFunctions.YieldStressCoefficientsForm = makeYieldStressCoefficientsForm;

export interface BinderForm {
    min: number;
    max: number;
    interval: number;
}

export function makeBinderForm (model: BinderForm): BinderForm {
  return {
    min: model.min,
    max: model.max,
    interval: model.interval,
  };
}

makeFunctions.BinderForm = makeBinderForm;

export interface TonnageForm {
    min: number;
    max: number;
    interval: number;
    default: number;
}

export function makeTonnageForm (model: TonnageForm): TonnageForm {
  return {
    min: model.min,
    max: model.max,
    interval: model.interval,
    default: model.default,
  };
}

makeFunctions.TonnageForm = makeTonnageForm;

export interface ViscosityCoefficientsForm {
    coefficient1: number;
    coefficient2: number;
}

export function makeViscosityCoefficientsForm (model: ViscosityCoefficientsForm): ViscosityCoefficientsForm {
  return {
    coefficient1: model.coefficient1,
    coefficient2: model.coefficient2,
  };
}

makeFunctions.ViscosityCoefficientsForm = makeViscosityCoefficientsForm;

export interface MassConcentrationForm {
    min: number;
    max: number;
    interval: number;
}

export function makeMassConcentrationForm (model: MassConcentrationForm): MassConcentrationForm {
  return {
    min: model.min,
    max: model.max,
    interval: model.interval,
  };
}

makeFunctions.MassConcentrationForm = makeMassConcentrationForm;

/** A stope's pour solids as triangulated meshes, posted by the client for packaging into a Deswik DUF. Vertices are metric mine-grid coordinates (the client reverses the local view transform before posting), so the exported file lines up with the CAD model it came from. */
export interface PourShapesExportDto {
    stopeName: string;
    shapes: PourShapeDto[];
}

export function makePourShapesExportDto (model: PourShapesExportDto): PourShapesExportDto {
  return {
    stopeName: model.stopeName,
    shapes: (model.shapes?.map((item) => makePourShapeDto(item))),
  };
}

makeFunctions.PourShapesExportDto = makePourShapesExportDto;

export interface PourShapeDto {
    /** Pour reference; becomes the entity label and the layer name. */
    name: string;
    /** Flat x,y,z triples in metres (mine grid, Z-up). */
    vertices: number[];
    /** Zero-based vertex indices, three per triangle. */
    triangles: number[];
    /** Written to the entity as Deswik attributes (XProperties). */
    attributes?: { [key: string]: string; } | undefined;
}

export function makePourShapeDto (model: PourShapeDto): PourShapeDto {
  return {
    name: model.name,
    vertices: model.vertices,
    triangles: model.triangles,
    attributes: model.attributes,
  };
}

makeFunctions.PourShapeDto = makePourShapeDto;

/** Spools to remove, named either by their own id or by the pair of nodes they join. Both are accepted in one request because a client that has just optimistically drawn an edge knows the pair but a client deleting a node knows the ids, and the reticulation document is one per mine - two calls would race. */
export interface RemoveSpoolsForm {
    spoolIds?: string[] | undefined;
    connections?: RemoveSpoolByNodesForm[] | undefined;
}

export function makeRemoveSpoolsForm (model: RemoveSpoolsForm): RemoveSpoolsForm {
  return {
    spoolIds: model.spoolIds,
    connections: (model.connections?.map((item) => makeRemoveSpoolByNodesForm(item))),
  };
}

makeFunctions.RemoveSpoolsForm = makeRemoveSpoolsForm;

export interface RemoveSpoolByNodesForm {
    nodeAId?: string | undefined;
    nodeBId?: string | undefined;
}

export function makeRemoveSpoolByNodesForm (model: RemoveSpoolByNodesForm): RemoveSpoolByNodesForm {
  return {
    nodeAId: model.nodeAId,
    nodeBId: model.nodeBId,
  };
}

makeFunctions.RemoveSpoolByNodesForm = makeRemoveSpoolByNodesForm;

/** A partial patch of one spool. Every property except the id is optional: an omitted property is left as it is, so a caller changing only a pipe never has to restate the flow flags or the flow-loop length.            "Cleared" and "not supplied" have to be told apart, as for node names. Name, Other, Level and Area do it with the empty string: null leaves the value alone, empty or whitespace clears it, anything else sets it trimmed. A date has no empty value, so clearing one takes its explicit flag, ClearInstalledOn or ClearRemovedOn; sending a date and its clear flag together is invalid. */
export interface SpoolUpdateForm {
    spoolId: string;
    pipeId?: string | undefined;
    allowFlowAB?: boolean | undefined;
    allowFlowBA?: boolean | undefined;
    chokeLength?: number | undefined;
    name?: string | undefined;
    /** NodaTimeType:LocalDate */
    installedOn?: LocalDate | undefined;    
    clearInstalledOn?: boolean | undefined;
    /** NodaTimeType:LocalDate */
    removedOn?: LocalDate | undefined;    
    clearRemovedOn?: boolean | undefined;
    status?: SpoolStatus | undefined;
    other?: string | undefined;
    level?: string | undefined;
    area?: string | undefined;
}

export function makeSpoolUpdateForm (model: SpoolUpdateForm): SpoolUpdateForm {
  return {
    spoolId: model.spoolId,
    pipeId: model.pipeId,
    allowFlowAB: model.allowFlowAB,
    allowFlowBA: model.allowFlowBA,
    chokeLength: model.chokeLength,
    name: model.name,
    installedOn: model.installedOn && typeof model.installedOn === 'string' ? makeLocalDate(model.installedOn) : model.installedOn,
    clearInstalledOn: model.clearInstalledOn,
    removedOn: model.removedOn && typeof model.removedOn === 'string' ? makeLocalDate(model.removedOn) : model.removedOn,
    clearRemovedOn: model.clearRemovedOn,
    status: model.status ? makeSpoolStatus(model.status) : model.status,
    other: model.other,
    level: model.level,
    area: model.area,
  };
}

makeFunctions.SpoolUpdateForm = makeSpoolUpdateForm;

export interface ApplySpoolStatusFromDatesResultDto {
    activeCount?: number;
    inactiveCount?: number;
    /** Spools whose status the apply flipped. */
    changedCount?: number;
}

export function makeApplySpoolStatusFromDatesResultDto (model: ApplySpoolStatusFromDatesResultDto): ApplySpoolStatusFromDatesResultDto {
  return {
    activeCount: model.activeCount,
    inactiveCount: model.inactiveCount,
    changedCount: model.changedCount,
  };
}

makeFunctions.ApplySpoolStatusFromDatesResultDto = makeApplySpoolStatusFromDatesResultDto;

export interface ApplySpoolStatusFromDatesForm {
    /** NodaTimeType:LocalDate */
    asOf: LocalDate;    
}

export function makeApplySpoolStatusFromDatesForm (model: ApplySpoolStatusFromDatesForm): ApplySpoolStatusFromDatesForm {
  return {
    asOf: model.asOf && typeof model.asOf === 'string' ? makeLocalDate(model.asOf) : model.asOf,
  };
}

makeFunctions.ApplySpoolStatusFromDatesForm = makeApplySpoolStatusFromDatesForm;

/** Splits the spool between NodeAId and NodeBId with Node. The nodes must already be connected; the two halves inherit the original spool's flow direction, and its pipe unless SpoolPipeId overrides it. */
export interface AddNodeBetweenNodesForm {
    node: ModelNodeDataForm;
    nodeAId: string;
    nodeBId: string;
    spoolPipeId?: string | undefined;
}

export function makeAddNodeBetweenNodesForm (model: AddNodeBetweenNodesForm): AddNodeBetweenNodesForm {
  return {
    node: model.node ? makeModelNodeDataForm(model.node) : model.node,
    nodeAId: model.nodeAId,
    nodeBId: model.nodeBId,
    spoolPipeId: model.spoolPipeId,
  };
}

makeFunctions.AddNodeBetweenNodesForm = makeAddNodeBetweenNodesForm;

/** A node is coordinates plus the attributes that belong to a location. Which nodes it is connected to, the pipe between them and the flow-loop length all belong to the spool; PipeId survives only as the default pipe for a spool created from this node. */
export interface ModelNodeDataForm {
    nodeId: string;
    nodeName?: string | undefined;
    point: Point3D;
    pipeId: string;
    pit?: string | undefined;
    isStope?: boolean | undefined;
    isPit?: boolean | undefined;
    stopeData?: StopeDataForm[] | undefined;
    level?: string | undefined;
    area?: string | undefined;
    isPlantNode?: boolean | undefined;
    boosterPressure?: number | undefined;
    ruptureDiskPressure?: number | undefined;
    chokeHead?: number | undefined;
}

export function makeModelNodeDataForm (model: ModelNodeDataForm): ModelNodeDataForm {
  return {
    nodeId: model.nodeId,
    nodeName: model.nodeName,
    point: model.point ? makePoint3D(model.point) : model.point,
    pipeId: model.pipeId,
    pit: model.pit,
    isStope: model.isStope,
    isPit: model.isPit,
    stopeData: (model.stopeData?.map((item) => makeStopeDataForm(item))),
    level: model.level,
    area: model.area,
    isPlantNode: model.isPlantNode,
    boosterPressure: model.boosterPressure,
    ruptureDiskPressure: model.ruptureDiskPressure,
    chokeHead: model.chokeHead,
  };
}

makeFunctions.ModelNodeDataForm = makeModelNodeDataForm;

/** The file format describes the network as a chain: each node names the node(s) before it, optionally with a per-neighbour pipe override and a node-level choke length. Spools own all three now, so the import handler materialises them - these are accepted as input and are never emitted. */
export interface DxfImportDataForm {
    nodeId: string;
    point: Point3D;
    previousNodeId: string[];
    pipeId: string;
    chokeLength: number;
    pit?: string | undefined;
    isStope?: boolean | undefined;
    isPit?: boolean | undefined;
    stopeData?: StopeDataForm[] | undefined;
    level?: string | undefined;
    area?: string | undefined;
    isPlantNode?: boolean | undefined;
    ruptureDiskPressure?: number | undefined;
    chokeHead?: number | undefined;
    spoolPipeOverrides?: { [key: string]: string; } | undefined;
}

export function makeDxfImportDataForm (model: DxfImportDataForm): DxfImportDataForm {
  return {
    nodeId: model.nodeId,
    point: model.point ? makePoint3D(model.point) : model.point,
    previousNodeId: model.previousNodeId,
    pipeId: model.pipeId,
    chokeLength: model.chokeLength,
    pit: model.pit,
    isStope: model.isStope,
    isPit: model.isPit,
    stopeData: (model.stopeData?.map((item) => makeStopeDataForm(item))),
    level: model.level,
    area: model.area,
    isPlantNode: model.isPlantNode,
    ruptureDiskPressure: model.ruptureDiskPressure,
    chokeHead: model.chokeHead,
    spoolPipeOverrides: model.spoolPipeOverrides,
  };
}

makeFunctions.DxfImportDataForm = makeDxfImportDataForm;

/** The file format describes the network as a chain: each node names the node(s) before it, optionally with a per-neighbour pipe override and a node-level choke length. Spools own all three now, so the import handler materialises them - these are accepted as input and are never emitted. */
export interface DufImportDataForm {
    nodeId: string;
    point: Point3D;
    previousNodeId: string[];
    pipeId: string;
    chokeLength: number;
    pit?: string | undefined;
    isStope?: boolean | undefined;
    isPit?: boolean | undefined;
    stopeData?: StopeDataForm[] | undefined;
    level?: string | undefined;
    area?: string | undefined;
    isPlantNode?: boolean | undefined;
    ruptureDiskPressure?: number | undefined;
    chokeHead?: number | undefined;
    spoolPipeOverrides?: { [key: string]: string; } | undefined;
}

export function makeDufImportDataForm (model: DufImportDataForm): DufImportDataForm {
  return {
    nodeId: model.nodeId,
    point: model.point ? makePoint3D(model.point) : model.point,
    previousNodeId: model.previousNodeId,
    pipeId: model.pipeId,
    chokeLength: model.chokeLength,
    pit: model.pit,
    isStope: model.isStope,
    isPit: model.isPit,
    stopeData: (model.stopeData?.map((item) => makeStopeDataForm(item))),
    level: model.level,
    area: model.area,
    isPlantNode: model.isPlantNode,
    ruptureDiskPressure: model.ruptureDiskPressure,
    chokeHead: model.chokeHead,
    spoolPipeOverrides: model.spoolPipeOverrides,
  };
}

makeFunctions.DufImportDataForm = makeDufImportDataForm;

export interface UpdateModelNodeDataForm {
    nodeId: string;
    modelNodeDataForm: ModelNodeDataForm;
}

export function makeUpdateModelNodeDataForm (model: UpdateModelNodeDataForm): UpdateModelNodeDataForm {
  return {
    nodeId: model.nodeId,
    modelNodeDataForm: model.modelNodeDataForm ? makeModelNodeDataForm(model.modelNodeDataForm) : model.modelNodeDataForm,
  };
}

makeFunctions.UpdateModelNodeDataForm = makeUpdateModelNodeDataForm;

export interface ResetSpoolThroughputCommand {
    spoolIds?: string[] | undefined;
}

export function makeResetSpoolThroughputCommand (model: ResetSpoolThroughputCommand): ResetSpoolThroughputCommand {
  return {
    spoolIds: model.spoolIds,
  };
}

makeFunctions.ResetSpoolThroughputCommand = makeResetSpoolThroughputCommand;

export interface UpdateStopeDataForm {
    nodeId: string;
    stopeDataForm: StopeDataForm;
}

export function makeUpdateStopeDataForm (model: UpdateStopeDataForm): UpdateStopeDataForm {
  return {
    nodeId: model.nodeId,
    stopeDataForm: model.stopeDataForm ? makeStopeDataForm(model.stopeDataForm) : model.stopeDataForm,
  };
}

makeFunctions.UpdateStopeDataForm = makeUpdateStopeDataForm;

export interface WearDataForm {
    position1?: number | undefined;
    position2?: number | undefined;
    position3?: number | undefined;
    position4?: number | undefined;
    position5?: number | undefined;
    position6?: number | undefined;
    position7?: number | undefined;
    position8?: number | undefined;
    inspectionPointId: string;
    /** NodaTimeType:LocalDateTime */
    inspectionDate: LocalDateTime;    
}

export function makeWearDataForm (model: WearDataForm): WearDataForm {
  return {
    position1: model.position1,
    position2: model.position2,
    position3: model.position3,
    position4: model.position4,
    position5: model.position5,
    position6: model.position6,
    position7: model.position7,
    position8: model.position8,
    inspectionPointId: model.inspectionPointId,
    inspectionDate: model.inspectionDate && typeof model.inspectionDate === 'string' ? makeLocalDateTime(model.inspectionDate) : model.inspectionDate,
  };
}

makeFunctions.WearDataForm = makeWearDataForm;

export interface UpdateWearDataForm {
    position1?: number | undefined;
    position2?: number | undefined;
    position3?: number | undefined;
    position4?: number | undefined;
    position5?: number | undefined;
    position6?: number | undefined;
    position7?: number | undefined;
    position8?: number | undefined;
    /** NodaTimeType:LocalDateTime */
    inspectionDate: LocalDateTime;    
}

export function makeUpdateWearDataForm (model: UpdateWearDataForm): UpdateWearDataForm {
  return {
    position1: model.position1,
    position2: model.position2,
    position3: model.position3,
    position4: model.position4,
    position5: model.position5,
    position6: model.position6,
    position7: model.position7,
    position8: model.position8,
    inspectionDate: model.inspectionDate && typeof model.inspectionDate === 'string' ? makeLocalDateTime(model.inspectionDate) : model.inspectionDate,
  };
}

makeFunctions.UpdateWearDataForm = makeUpdateWearDataForm;

export interface RemoveStopesResultDto {
    removedStopeIds?: string[] | undefined;
    skipped?: RemoveStopeSkippedDto[] | undefined;
}

export function makeRemoveStopesResultDto (model: RemoveStopesResultDto): RemoveStopesResultDto {
  return {
    removedStopeIds: model.removedStopeIds,
    skipped: (model.skipped?.map((item) => makeRemoveStopeSkippedDto(item))),
  };
}

makeFunctions.RemoveStopesResultDto = makeRemoveStopesResultDto;

export interface RemoveStopeSkippedDto {
    stopeId?: string | undefined;
    reason?: string | undefined;
}

export function makeRemoveStopeSkippedDto (model: RemoveStopeSkippedDto): RemoveStopeSkippedDto {
  return {
    stopeId: model.stopeId,
    reason: model.reason,
  };
}

makeFunctions.RemoveStopeSkippedDto = makeRemoveStopeSkippedDto;

export interface RemoveStopesForm {
    entries?: RemoveStopeEntryForm[] | undefined;
}

export function makeRemoveStopesForm (model: RemoveStopesForm): RemoveStopesForm {
  return {
    entries: (model.entries?.map((item) => makeRemoveStopeEntryForm(item))),
  };
}

makeFunctions.RemoveStopesForm = makeRemoveStopesForm;

export interface RemoveStopeEntryForm {
    stopeId?: string | undefined;
    nodeId?: string | undefined;
}

export function makeRemoveStopeEntryForm (model: RemoveStopeEntryForm): RemoveStopeEntryForm {
  return {
    stopeId: model.stopeId,
    nodeId: model.nodeId,
  };
}

makeFunctions.RemoveStopeEntryForm = makeRemoveStopeEntryForm;

export interface SetRheologyDataDeactivatedCommand {
    rheologyDataSetId?: string | undefined;
    isDeactivated?: boolean;
}

export function makeSetRheologyDataDeactivatedCommand (model: SetRheologyDataDeactivatedCommand): SetRheologyDataDeactivatedCommand {
  return {
    rheologyDataSetId: model.rheologyDataSetId,
    isDeactivated: model.isDeactivated,
  };
}

makeFunctions.SetRheologyDataDeactivatedCommand = makeSetRheologyDataDeactivatedCommand;

export interface TunnelProfileSettingsForm {
    visible?: boolean;
    opacity?: number;
}

export function makeTunnelProfileSettingsForm (model: TunnelProfileSettingsForm): TunnelProfileSettingsForm {
  return {
    visible: model.visible,
    opacity: model.opacity,
  };
}

makeFunctions.TunnelProfileSettingsForm = makeTunnelProfileSettingsForm;

export interface PagedListOfNodeVolumeRecordDto {
    items: NodeVolumeRecordDto[];
    pager: Pager;
}

export function makePagedListOfNodeVolumeRecordDto (model: PagedListOfNodeVolumeRecordDto): PagedListOfNodeVolumeRecordDto {
  return {
    items: (model.items?.map((item) => makeNodeVolumeRecordDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfNodeVolumeRecordDto = makePagedListOfNodeVolumeRecordDto;

/** A throughput record. The DTO keeps the persisted type's name; the UI calls it a throughput record. */
export interface NodeVolumeRecordDto extends EntityDtoOfString {
    mineModelId?: string | undefined;
    /** NodaTimeType:Instant */
    generated?: Instant;    
    spoolSnapshots?: SpoolThroughputSnapshot[] | undefined;
}

export function makeNodeVolumeRecordDto (model: NodeVolumeRecordDto): NodeVolumeRecordDto {
  return {
      ...makeEntityDtoOfString(model),
    mineModelId: model.mineModelId,
    generated: model.generated && typeof model.generated === 'string' ? makeInstant(model.generated) : model.generated,
    spoolSnapshots: (model.spoolSnapshots?.map((item) => makeSpoolThroughputSnapshot(item))),
  };
}

makeFunctions.NodeVolumeRecordDto = makeNodeVolumeRecordDto;

export interface ValueObjectOfSpoolThroughputSnapshot {
}

export function makeValueObjectOfSpoolThroughputSnapshot (model: ValueObjectOfSpoolThroughputSnapshot): ValueObjectOfSpoolThroughputSnapshot {
  return {
  };
}

makeFunctions.ValueObjectOfSpoolThroughputSnapshot = makeValueObjectOfSpoolThroughputSnapshot;

/** One spool's running totals at the moment a record was taken. */
export interface SpoolThroughputSnapshot extends ValueObjectOfSpoolThroughputSnapshot {
    spoolId?: string | undefined;
    totalVolumeThroughSpool?: number | undefined;
    totalDryTonnesThroughSpool?: number | undefined;
}

export function makeSpoolThroughputSnapshot (model: SpoolThroughputSnapshot): SpoolThroughputSnapshot {
  return {
      ...makeValueObjectOfSpoolThroughputSnapshot(model),
    spoolId: model.spoolId,
    totalVolumeThroughSpool: model.totalVolumeThroughSpool,
    totalDryTonnesThroughSpool: model.totalDryTonnesThroughSpool,
  };
}

makeFunctions.SpoolThroughputSnapshot = makeSpoolThroughputSnapshot;

export interface BulkRheologyDataCommand {
    rheologyParameters?: RheologyParameterForm[] | undefined;
    globalParameters?: GlobalParametersForm | undefined;
    ucsParameters?: UcsParameterForm[] | undefined;
    pipes?: PipeForm[] | undefined;
}

export function makeBulkRheologyDataCommand (model: BulkRheologyDataCommand): BulkRheologyDataCommand {
  return {
    rheologyParameters: (model.rheologyParameters?.map((item) => makeRheologyParameterForm(item))),
    globalParameters: model.globalParameters ? makeGlobalParametersForm(model.globalParameters) : model.globalParameters,
    ucsParameters: (model.ucsParameters?.map((item) => makeUcsParameterForm(item))),
    pipes: (model.pipes?.map((item) => makePipeForm(item))),
  };
}

makeFunctions.BulkRheologyDataCommand = makeBulkRheologyDataCommand;

export interface RheologyParameterForm {
    name?: string | undefined;
    yieldStressA?: number;
    yieldStressB?: number;
    viscosityC?: number;
    viscosityD?: number;
    solidsDensity?: number;
}

export function makeRheologyParameterForm (model: RheologyParameterForm): RheologyParameterForm {
  return {
    name: model.name,
    yieldStressA: model.yieldStressA,
    yieldStressB: model.yieldStressB,
    viscosityC: model.viscosityC,
    viscosityD: model.viscosityD,
    solidsDensity: model.solidsDensity,
  };
}

makeFunctions.RheologyParameterForm = makeRheologyParameterForm;

export interface GlobalParametersForm {
    factorOfSafety?: number;
    maxPumpPressure?: number;
    defaultPumpPressure?: number;
    flowRateMin?: number;
    flowRateMax?: number;
    flowRateInterval?: number;
    flowRateDefault?: number;
    massConcentrationMin?: number;
    massConcentrationMax?: number;
    massConcentrationInterval?: number;
    binderMin?: number;
    binderMax?: number;
    binderInterval?: number;
    carrierFluidDensity?: number;
    binderDensity?: number;
}

export function makeGlobalParametersForm (model: GlobalParametersForm): GlobalParametersForm {
  return {
    factorOfSafety: model.factorOfSafety,
    maxPumpPressure: model.maxPumpPressure,
    defaultPumpPressure: model.defaultPumpPressure,
    flowRateMin: model.flowRateMin,
    flowRateMax: model.flowRateMax,
    flowRateInterval: model.flowRateInterval,
    flowRateDefault: model.flowRateDefault,
    massConcentrationMin: model.massConcentrationMin,
    massConcentrationMax: model.massConcentrationMax,
    massConcentrationInterval: model.massConcentrationInterval,
    binderMin: model.binderMin,
    binderMax: model.binderMax,
    binderInterval: model.binderInterval,
    carrierFluidDensity: model.carrierFluidDensity,
    binderDensity: model.binderDensity,
  };
}

makeFunctions.GlobalParametersForm = makeGlobalParametersForm;

export interface UcsParameterForm {
    days?: number;
    ucs1?: number;
    ucs2?: number;
}

export function makeUcsParameterForm (model: UcsParameterForm): UcsParameterForm {
  return {
    days: model.days,
    ucs1: model.ucs1,
    ucs2: model.ucs2,
  };
}

makeFunctions.UcsParameterForm = makeUcsParameterForm;

export interface PipeForm {
    id?: string | undefined;
    name?: string | undefined;
    calculationMode?: string | undefined;
    isMetric?: boolean;
    dimensionStandard?: string | undefined;
    pipeSize?: string | undefined;
    wallSelection?: string | undefined;
    insideDiameter?: number;
    outsideDiameter?: number;
    wallThickness?: number;
    liningThickness?: number;
    wearAllowance?: number;
    materialStandard?: string | undefined;
    materialGrade?: string | undefined;
    pressureRatingCode?: string | undefined;
    factorOfSafety?: number;
    weldType?: string | undefined;
    couplingStandard?: string | undefined;
    couplingClass?: string | undefined;
    cutDepth?: number;
    designTemperature?: number | undefined;
    pipeRoughness?: number | undefined;
    simplePressureRating?: number | undefined;
    pipePressureRating?: number;
    couplingPressureRating?: number;
    overallPressureRating?: number;
    colour?: string | undefined;
    startingThickness?: number | undefined;
    minimumThickness?: number | undefined;
}

export function makePipeForm (model: PipeForm): PipeForm {
  return {
    id: model.id,
    name: model.name,
    calculationMode: model.calculationMode,
    isMetric: model.isMetric,
    dimensionStandard: model.dimensionStandard,
    pipeSize: model.pipeSize,
    wallSelection: model.wallSelection,
    insideDiameter: model.insideDiameter,
    outsideDiameter: model.outsideDiameter,
    wallThickness: model.wallThickness,
    liningThickness: model.liningThickness,
    wearAllowance: model.wearAllowance,
    materialStandard: model.materialStandard,
    materialGrade: model.materialGrade,
    pressureRatingCode: model.pressureRatingCode,
    factorOfSafety: model.factorOfSafety,
    weldType: model.weldType,
    couplingStandard: model.couplingStandard,
    couplingClass: model.couplingClass,
    cutDepth: model.cutDepth,
    designTemperature: model.designTemperature,
    pipeRoughness: model.pipeRoughness,
    simplePressureRating: model.simplePressureRating,
    pipePressureRating: model.pipePressureRating,
    couplingPressureRating: model.couplingPressureRating,
    overallPressureRating: model.overallPressureRating,
    colour: model.colour,
    startingThickness: model.startingThickness,
    minimumThickness: model.minimumThickness,
  };
}

makeFunctions.PipeForm = makePipeForm;

export interface BulkImportStopesResultDto {
    createdStopeIds?: string[] | undefined;
}

export function makeBulkImportStopesResultDto (model: BulkImportStopesResultDto): BulkImportStopesResultDto {
  return {
    createdStopeIds: model.createdStopeIds,
  };
}

makeFunctions.BulkImportStopesResultDto = makeBulkImportStopesResultDto;

export interface BulkImportStopesForm {
    entries?: BulkImportStopeEntryForm[];
}

export function makeBulkImportStopesForm (model: BulkImportStopesForm): BulkImportStopesForm {
  return {
    entries: (model.entries?.map((item) => makeBulkImportStopeEntryForm(item))),
  };
}

makeFunctions.BulkImportStopesForm = makeBulkImportStopesForm;

export interface BulkImportStopeEntryForm {
    solidEntityGuid?: string | undefined;
    existingNodeId?: string | undefined;
    newNodeForm?: ModelNodeDataForm | undefined;
    insertBetweenNodes?: InsertBetweenNodesForm | undefined;
    spoolFromNodeId?: string | undefined;
    spoolPipeTypeId?: string | undefined;
    stopeDataForm?: StopeDataForm | undefined;
    mode?: BulkImportMode;
}

export function makeBulkImportStopeEntryForm (model: BulkImportStopeEntryForm): BulkImportStopeEntryForm {
  return {
    solidEntityGuid: model.solidEntityGuid,
    existingNodeId: model.existingNodeId,
    newNodeForm: model.newNodeForm ? makeModelNodeDataForm(model.newNodeForm) : model.newNodeForm,
    insertBetweenNodes: model.insertBetweenNodes ? makeInsertBetweenNodesForm(model.insertBetweenNodes) : model.insertBetweenNodes,
    spoolFromNodeId: model.spoolFromNodeId,
    spoolPipeTypeId: model.spoolPipeTypeId,
    stopeDataForm: model.stopeDataForm ? makeStopeDataForm(model.stopeDataForm) : model.stopeDataForm,
    mode: model.mode ? makeBulkImportMode(model.mode) : model.mode,
  };
}

makeFunctions.BulkImportStopeEntryForm = makeBulkImportStopeEntryForm;

export interface InsertBetweenNodesForm {
    nodeAId?: string | undefined;
    nodeBId?: string | undefined;
}

export function makeInsertBetweenNodesForm (model: InsertBetweenNodesForm): InsertBetweenNodesForm {
  return {
    nodeAId: model.nodeAId,
    nodeBId: model.nodeBId,
  };
}

makeFunctions.InsertBetweenNodesForm = makeInsertBetweenNodesForm;

export enum BulkImportMode {
    Skip = 0,
    UpdateShapefileOnly = 1,
    FullImport = 2,
}

function makeBulkImportMode (value: BulkImportMode): BulkImportMode {
  return value;
}

makeFunctions.BulkImportMode = makeBulkImportMode;

export interface BulkUpdateStopeGeometryForm {
    entries?: StopeGeometryEntry[] | undefined;
}

export function makeBulkUpdateStopeGeometryForm (model: BulkUpdateStopeGeometryForm): BulkUpdateStopeGeometryForm {
  return {
    entries: (model.entries?.map((item) => makeStopeGeometryEntry(item))),
  };
}

makeFunctions.BulkUpdateStopeGeometryForm = makeBulkUpdateStopeGeometryForm;

export interface StopeGeometryEntry {
    stopeId?: string | undefined;
    objContent?: string | undefined;
    fileName?: string | undefined;
}

export function makeStopeGeometryEntry (model: StopeGeometryEntry): StopeGeometryEntry {
  return {
    stopeId: model.stopeId,
    objContent: model.objContent,
    fileName: model.fileName,
  };
}

makeFunctions.StopeGeometryEntry = makeStopeGeometryEntry;

export interface DufBulkImportParseResponse {
    layers?: DufLayerRefDto[];
    geometryEntities?: DufBulkImportGeometryEntityDto[];
    /** True when the source DUF was authored in imperial units. The geometry and bounding boxes
on this response are already converted to metres; this flag exists so the client can also
convert values it reads straight off the raw DUF attributes. */
    imperialUnits?: boolean;
}

export function makeDufBulkImportParseResponse (model: DufBulkImportParseResponse): DufBulkImportParseResponse {
  return {
    layers: (model.layers?.map((item) => makeDufLayerRefDto(item))),
    geometryEntities: (model.geometryEntities?.map((item) => makeDufBulkImportGeometryEntityDto(item))),
    imperialUnits: model.imperialUnits,
  };
}

makeFunctions.DufBulkImportParseResponse = makeDufBulkImportParseResponse;

export interface DufLayerRefDto {
    guid?: string;
    name?: string | undefined;
}

export function makeDufLayerRefDto (model: DufLayerRefDto): DufLayerRefDto {
  return {
    guid: model.guid,
    name: model.name,
  };
}

makeFunctions.DufLayerRefDto = makeDufLayerRefDto;

export interface DufBulkImportGeometryEntityDto {
    guid?: string;
    type?: string;
    layerGuid?: string | undefined;
    layerName?: string | undefined;
    attributes?: { [key: string]: string; };
    objData?: string;
    boundingBox?: DufBoundingBoxDto | undefined;
}

export function makeDufBulkImportGeometryEntityDto (model: DufBulkImportGeometryEntityDto): DufBulkImportGeometryEntityDto {
  return {
    guid: model.guid,
    type: model.type,
    layerGuid: model.layerGuid,
    layerName: model.layerName,
    attributes: model.attributes,
    objData: model.objData,
    boundingBox: model.boundingBox ? makeDufBoundingBoxDto(model.boundingBox) : model.boundingBox,
  };
}

makeFunctions.DufBulkImportGeometryEntityDto = makeDufBulkImportGeometryEntityDto;

export interface DufBoundingBoxDto {
    minX?: number;
    minY?: number;
    minZ?: number;
    maxX?: number;
    maxY?: number;
    maxZ?: number;
    centerX?: number;
    centerY?: number;
    centerZ?: number;
    volume?: number;
}

export function makeDufBoundingBoxDto (model: DufBoundingBoxDto): DufBoundingBoxDto {
  return {
    minX: model.minX,
    minY: model.minY,
    minZ: model.minZ,
    maxX: model.maxX,
    maxY: model.maxY,
    maxZ: model.maxZ,
    centerX: model.centerX,
    centerY: model.centerY,
    centerZ: model.centerZ,
    volume: model.volume,
  };
}

makeFunctions.DufBoundingBoxDto = makeDufBoundingBoxDto;

export interface ModelEntityGroupDto {
    groupId?: string | undefined;
    groupName?: string | undefined;
    groupType?: string | undefined;
    memberIds?: string[] | undefined;
}

export function makeModelEntityGroupDto (model: ModelEntityGroupDto): ModelEntityGroupDto {
  return {
    groupId: model.groupId,
    groupName: model.groupName,
    groupType: model.groupType,
    memberIds: model.memberIds,
  };
}

makeFunctions.ModelEntityGroupDto = makeModelEntityGroupDto;

export interface CreateModelEntityGroupForm {
    groupName?: string | undefined;
    groupType?: string | undefined;
    memberIds?: string[] | undefined;
}

export function makeCreateModelEntityGroupForm (model: CreateModelEntityGroupForm): CreateModelEntityGroupForm {
  return {
    groupName: model.groupName,
    groupType: model.groupType,
    memberIds: model.memberIds,
  };
}

makeFunctions.CreateModelEntityGroupForm = makeCreateModelEntityGroupForm;

export interface UpdateModelEntityGroupForm {
    groupName?: string | undefined;
    memberIds?: string[] | undefined;
}

export function makeUpdateModelEntityGroupForm (model: UpdateModelEntityGroupForm): UpdateModelEntityGroupForm {
  return {
    groupName: model.groupName,
    memberIds: model.memberIds,
  };
}

makeFunctions.UpdateModelEntityGroupForm = makeUpdateModelEntityGroupForm;

export interface ProjectScenarioDto {
    scenarioId?: string | undefined;
    mineModelId?: string | undefined;
    name?: string | undefined;
    clonedFromScenarioId?: string | undefined;
    createdAt?: string | undefined;
    createdBy?: string | undefined;
}

export function makeProjectScenarioDto (model: ProjectScenarioDto): ProjectScenarioDto {
  return {
    scenarioId: model.scenarioId,
    mineModelId: model.mineModelId,
    name: model.name,
    clonedFromScenarioId: model.clonedFromScenarioId,
    createdAt: model.createdAt,
    createdBy: model.createdBy,
  };
}

makeFunctions.ProjectScenarioDto = makeProjectScenarioDto;

export interface CloneScenarioForm {
    name?: string | undefined;
    sourceScenarioId?: string | undefined;
    cloneRecipes?: boolean;
    clonePours?: boolean;
}

export function makeCloneScenarioForm (model: CloneScenarioForm): CloneScenarioForm {
  return {
    name: model.name,
    sourceScenarioId: model.sourceScenarioId,
    cloneRecipes: model.cloneRecipes,
    clonePours: model.clonePours,
  };
}

makeFunctions.CloneScenarioForm = makeCloneScenarioForm;

export interface PagedListOfUserNotificationDto {
    items: UserNotificationDto[];
    pager: Pager;
}

export function makePagedListOfUserNotificationDto (model: PagedListOfUserNotificationDto): PagedListOfUserNotificationDto {
  return {
    items: (model.items?.map((item) => makeUserNotificationDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfUserNotificationDto = makePagedListOfUserNotificationDto;

export interface UserNotificationDto extends EntityDtoOfString {
    notification: NotificationDto;
    /** NodaTimeType:ZonedDateTime */
    createdDate: ZonedDateTime;    
    read: boolean;
}

export function makeUserNotificationDto (model: UserNotificationDto): UserNotificationDto {
  return {
      ...makeEntityDtoOfString(model),
    notification: model.notification ? makeNotificationDto(model.notification) : model.notification,
    createdDate: model.createdDate && typeof model.createdDate === 'string' ? makeZonedDateTime(model.createdDate) : model.createdDate,
    read: model.read,
  };
}

makeFunctions.UserNotificationDto = makeUserNotificationDto;

export interface NotificationDto extends EntityDtoOfString {
    title: string;
    body: string;
    /** NodaTimeType:ZonedDateTime */
    createdDate: ZonedDateTime;    
}

export function makeNotificationDto (model: NotificationDto): NotificationDto {
  return {
      ...makeEntityDtoOfString(model),
    title: model.title,
    body: model.body,
    createdDate: model.createdDate && typeof model.createdDate === 'string' ? makeZonedDateTime(model.createdDate) : model.createdDate,
  };
}

makeFunctions.NotificationDto = makeNotificationDto;

export interface MarkUserNotificationsAsReadCommand {
    notificationIds?: string[];
}

export function makeMarkUserNotificationsAsReadCommand (model: MarkUserNotificationsAsReadCommand): MarkUserNotificationsAsReadCommand {
  return {
    notificationIds: model.notificationIds,
  };
}

makeFunctions.MarkUserNotificationsAsReadCommand = makeMarkUserNotificationsAsReadCommand;

export interface NotificationForm {
    projectId?: string | undefined;
    title: string;
    body: string;
}

export function makeNotificationForm (model: NotificationForm): NotificationForm {
  return {
    projectId: model.projectId,
    title: model.title,
    body: model.body,
  };
}

makeFunctions.NotificationForm = makeNotificationForm;

export interface PagedListOfNotificationDto {
    items: NotificationDto[];
    pager: Pager;
}

export function makePagedListOfNotificationDto (model: PagedListOfNotificationDto): PagedListOfNotificationDto {
  return {
    items: (model.items?.map((item) => makeNotificationDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfNotificationDto = makePagedListOfNotificationDto;

export interface QaqcSampleDto extends EntityDtoOfString {
    pourId?: string;
    mineModelId?: string;
    operatorSummary?: EntitySummaryOfString;
    /** NodaTimeType:ZonedDateTime */
    sampledAt?: ZonedDateTime;    
    temperature?: number;
    ph?: number;
    massConcentration?: number;
    psd?: number;
}

export function makeQaqcSampleDto (model: QaqcSampleDto): QaqcSampleDto {
  return {
      ...makeEntityDtoOfString(model),
    pourId: model.pourId,
    mineModelId: model.mineModelId,
    operatorSummary: model.operatorSummary ? makeEntitySummaryOfString(model.operatorSummary) : model.operatorSummary,
    sampledAt: model.sampledAt && typeof model.sampledAt === 'string' ? makeZonedDateTime(model.sampledAt) : model.sampledAt,
    temperature: model.temperature,
    ph: model.ph,
    massConcentration: model.massConcentration,
    psd: model.psd,
  };
}

makeFunctions.QaqcSampleDto = makeQaqcSampleDto;

export interface QaqcSampleForm {
    /** NodaTimeType:LocalDateTime */
    sampledAt?: LocalDateTime;    
    temperature?: number | undefined;
    ph?: number | undefined;
    massConcentration?: number | undefined;
    psd?: number | undefined;
}

export function makeQaqcSampleForm (model: QaqcSampleForm): QaqcSampleForm {
  return {
    sampledAt: model.sampledAt && typeof model.sampledAt === 'string' ? makeLocalDateTime(model.sampledAt) : model.sampledAt,
    temperature: model.temperature,
    ph: model.ph,
    massConcentration: model.massConcentration,
    psd: model.psd,
  };
}

makeFunctions.QaqcSampleForm = makeQaqcSampleForm;

export interface BreakingTestDto extends EntityDtoOfString {
    breakingScheduleId: string;
    cylinderHeight: number;
    cylinderWidth: number;
    cylinderWetWeight?: number | undefined;
    recordedUcs: number;
    trayWeight?: number | undefined;
    sampleAndTrayWeightWet?: number | undefined;
    sampleAndTrayWeightDry?: number | undefined;
    actualMassConcentrationPercentage?: number | undefined;
    wetDensity?: number | undefined;
    isOutlierData?: boolean;
    isFaultyCylinder?: boolean;
    image?: ImageSummaryDto | undefined;
    waterToBinderRatio?: number | undefined;
    cylinders?: CylinderDto[] | undefined;
    /** NodaTimeType:ZonedDateTime */
    intendedDate: ZonedDateTime;    
    inspectionInterval: number;
}

export function makeBreakingTestDto (model: BreakingTestDto): BreakingTestDto {
  return {
      ...makeEntityDtoOfString(model),
    breakingScheduleId: model.breakingScheduleId,
    cylinderHeight: model.cylinderHeight,
    cylinderWidth: model.cylinderWidth,
    cylinderWetWeight: model.cylinderWetWeight,
    recordedUcs: model.recordedUcs,
    trayWeight: model.trayWeight,
    sampleAndTrayWeightWet: model.sampleAndTrayWeightWet,
    sampleAndTrayWeightDry: model.sampleAndTrayWeightDry,
    actualMassConcentrationPercentage: model.actualMassConcentrationPercentage,
    wetDensity: model.wetDensity,
    isOutlierData: model.isOutlierData,
    isFaultyCylinder: model.isFaultyCylinder,
    image: model.image ? makeImageSummaryDto(model.image) : model.image,
    waterToBinderRatio: model.waterToBinderRatio,
    cylinders: (model.cylinders?.map((item) => makeCylinderDto(item))),
    intendedDate: model.intendedDate && typeof model.intendedDate === 'string' ? makeZonedDateTime(model.intendedDate) : model.intendedDate,
    inspectionInterval: model.inspectionInterval,
  };
}

makeFunctions.BreakingTestDto = makeBreakingTestDto;

export interface CylinderDto {
    cylinderHeight?: number | undefined;
    cylinderWidth?: number | undefined;
    cylinderWetWeight?: number | undefined;
    recordedUcs?: number | undefined;
    trayWeight?: number | undefined;
    sampleAndTrayWeightWet?: number | undefined;
    sampleAndTrayWeightDry?: number | undefined;
    actualMassConcentrationPercentage?: number | undefined;
    wetDensity?: number | undefined;
    isOutlierData?: boolean;
    isFaultyCylinder?: boolean;
    waterToBinderRatio?: number | undefined;
    image?: ImageSummaryDto | undefined;
}

export function makeCylinderDto (model: CylinderDto): CylinderDto {
  return {
    cylinderHeight: model.cylinderHeight,
    cylinderWidth: model.cylinderWidth,
    cylinderWetWeight: model.cylinderWetWeight,
    recordedUcs: model.recordedUcs,
    trayWeight: model.trayWeight,
    sampleAndTrayWeightWet: model.sampleAndTrayWeightWet,
    sampleAndTrayWeightDry: model.sampleAndTrayWeightDry,
    actualMassConcentrationPercentage: model.actualMassConcentrationPercentage,
    wetDensity: model.wetDensity,
    isOutlierData: model.isOutlierData,
    isFaultyCylinder: model.isFaultyCylinder,
    waterToBinderRatio: model.waterToBinderRatio,
    image: model.image ? makeImageSummaryDto(model.image) : model.image,
  };
}

makeFunctions.CylinderDto = makeCylinderDto;

export interface PagedListOfPourSummaryDto {
    items: PourSummaryDto[];
    pager: Pager;
}

export function makePagedListOfPourSummaryDto (model: PagedListOfPourSummaryDto): PagedListOfPourSummaryDto {
  return {
    items: (model.items?.map((item) => makePourSummaryDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfPourSummaryDto = makePagedListOfPourSummaryDto;

export interface PourSummaryDto extends EntityDtoOfString {
    reference: string;
    /** NodaTimeType:ZonedDateTime */
    pourCompletedDate?: ZonedDateTime | undefined;    
    volume: number;
    projectReference: string;
    stopeId?: string | undefined;
    stopeName?: string | undefined;
    rheologyDataSetReference?: string | undefined;
    projectId?: string | undefined;
}

export function makePourSummaryDto (model: PourSummaryDto): PourSummaryDto {
  return {
      ...makeEntityDtoOfString(model),
    reference: model.reference,
    pourCompletedDate: model.pourCompletedDate && typeof model.pourCompletedDate === 'string' ? makeZonedDateTime(model.pourCompletedDate) : model.pourCompletedDate,
    volume: model.volume,
    projectReference: model.projectReference,
    stopeId: model.stopeId,
    stopeName: model.stopeName,
    rheologyDataSetReference: model.rheologyDataSetReference,
    projectId: model.projectId,
  };
}

makeFunctions.PourSummaryDto = makePourSummaryDto;

export interface BreakingTestForm {
    cylinders: CylinderData[];
    /** NodaTimeType:LocalDateTime */
    intendedDate: LocalDateTime;    
    breakingScheduleInspectionInterval: number;
}

export function makeBreakingTestForm (model: BreakingTestForm): BreakingTestForm {
  return {
    cylinders: (model.cylinders?.map((item) => makeCylinderData(item))),
    intendedDate: model.intendedDate && typeof model.intendedDate === 'string' ? makeLocalDateTime(model.intendedDate) : model.intendedDate,
    breakingScheduleInspectionInterval: model.breakingScheduleInspectionInterval,
  };
}

makeFunctions.BreakingTestForm = makeBreakingTestForm;

export interface CylinderData {
    cylinderHeight?: number | undefined;
    cylinderWidth?: number | undefined;
    cylinderWetWeight?: number | undefined;
    recordedUcs?: number | undefined;
    trayWeight?: number | undefined;
    sampleAndTrayWeightWet?: number | undefined;
    sampleAndTrayWeightDry?: number | undefined;
    actualMassConcentrationPercentage?: number | undefined;
    wetDensity?: number | undefined;
    isOutlierData?: boolean;
    isFaultyCylinder?: boolean;
    waterToBinderRatio?: number | undefined;
    image?: string | undefined;
}

export function makeCylinderData (model: CylinderData): CylinderData {
  return {
    cylinderHeight: model.cylinderHeight,
    cylinderWidth: model.cylinderWidth,
    cylinderWetWeight: model.cylinderWetWeight,
    recordedUcs: model.recordedUcs,
    trayWeight: model.trayWeight,
    sampleAndTrayWeightWet: model.sampleAndTrayWeightWet,
    sampleAndTrayWeightDry: model.sampleAndTrayWeightDry,
    actualMassConcentrationPercentage: model.actualMassConcentrationPercentage,
    wetDensity: model.wetDensity,
    isOutlierData: model.isOutlierData,
    isFaultyCylinder: model.isFaultyCylinder,
    waterToBinderRatio: model.waterToBinderRatio,
    image: model.image,
  };
}

makeFunctions.CylinderData = makeCylinderData;

export interface HistoricBreakingTestImportBatchDto {
    /** DateTime */
    importedDateUtc?: Date;
    recordCount?: number;
}

export function makeHistoricBreakingTestImportBatchDto (model: HistoricBreakingTestImportBatchDto): HistoricBreakingTestImportBatchDto {
  return {
    importedDateUtc: model.importedDateUtc && typeof model.importedDateUtc === 'string' ? makeDate(model.importedDateUtc) : model.importedDateUtc,
    recordCount: model.recordCount,
  };
}

makeFunctions.HistoricBreakingTestImportBatchDto = makeHistoricBreakingTestImportBatchDto;

export interface HistoricBreakingTestImportDto {
    rheologyDataSetReference?: any | undefined;
    breakingTestInspectionInterval?: number | undefined;
    breakingTestRecordedUcs?: number | undefined;
    massConcentrationPercentageTarget?: number | undefined;
    binderPercentageTarget?: number | undefined;
    inspectionInterval?: number;
    operatorName?: string | undefined;
    stopeName?: string | undefined;
    sampleName?: string | undefined;
    pourReference?: string | undefined;
    dateCast?: string | undefined;
    wetDensity?: number | undefined;
    waterToBinderRatio?: number | undefined;
    actualMassConcentrationPercentage?: number | undefined;
    recipeWaterBinderRatio?: number | undefined;
    cylinderHeight?: number | undefined;
    cylinderWidth?: number | undefined;
    cylinderWetWeight?: number | undefined;
}

export function makeHistoricBreakingTestImportDto (model: HistoricBreakingTestImportDto): HistoricBreakingTestImportDto {
  return {
    rheologyDataSetReference: model.rheologyDataSetReference,
    breakingTestInspectionInterval: model.breakingTestInspectionInterval,
    breakingTestRecordedUcs: model.breakingTestRecordedUcs,
    massConcentrationPercentageTarget: model.massConcentrationPercentageTarget,
    binderPercentageTarget: model.binderPercentageTarget,
    inspectionInterval: model.inspectionInterval,
    operatorName: model.operatorName,
    stopeName: model.stopeName,
    sampleName: model.sampleName,
    pourReference: model.pourReference,
    dateCast: model.dateCast,
    wetDensity: model.wetDensity,
    waterToBinderRatio: model.waterToBinderRatio,
    actualMassConcentrationPercentage: model.actualMassConcentrationPercentage,
    recipeWaterBinderRatio: model.recipeWaterBinderRatio,
    cylinderHeight: model.cylinderHeight,
    cylinderWidth: model.cylinderWidth,
    cylinderWetWeight: model.cylinderWetWeight,
  };
}

makeFunctions.HistoricBreakingTestImportDto = makeHistoricBreakingTestImportDto;

export interface PagedListOfBreakingScheduleDto {
    items: BreakingScheduleDto[];
    pager: Pager;
}

export function makePagedListOfBreakingScheduleDto (model: PagedListOfBreakingScheduleDto): PagedListOfBreakingScheduleDto {
  return {
    items: (model.items?.map((item) => makeBreakingScheduleDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfBreakingScheduleDto = makePagedListOfBreakingScheduleDto;

export interface BreakingScheduleDto extends EntityDtoOfString {
    pourId: string;
    sampleName: string;
    slump: number;
    slumpPicture: ImageSummaryDto;
    /** NodaTimeType:ZonedDateTime */
    dateCast: ZonedDateTime;    
    inspectionInterval: number[];
    numberOfCylinders: number;
    vane: number;
    slurryDensity?: number | undefined;
    stopeName?: string | undefined;
    pourReference?: string | undefined;
}

export function makeBreakingScheduleDto (model: BreakingScheduleDto): BreakingScheduleDto {
  return {
      ...makeEntityDtoOfString(model),
    pourId: model.pourId,
    sampleName: model.sampleName,
    slump: model.slump,
    slumpPicture: model.slumpPicture ? makeImageSummaryDto(model.slumpPicture) : model.slumpPicture,
    dateCast: model.dateCast && typeof model.dateCast === 'string' ? makeZonedDateTime(model.dateCast) : model.dateCast,
    inspectionInterval: model.inspectionInterval,
    numberOfCylinders: model.numberOfCylinders,
    vane: model.vane,
    slurryDensity: model.slurryDensity,
    stopeName: model.stopeName,
    pourReference: model.pourReference,
  };
}

makeFunctions.BreakingScheduleDto = makeBreakingScheduleDto;

/** Outcome of the setup for one pour. A pour that already had a breaking schedule is left untouched and reported with Created false so the caller can link to the existing schedule. */
export interface BreakingScheduleSetupResultDto {
    pourId: string;
    breakingScheduleId: string;
    created: boolean;
}

export function makeBreakingScheduleSetupResultDto (model: BreakingScheduleSetupResultDto): BreakingScheduleSetupResultDto {
  return {
    pourId: model.pourId,
    breakingScheduleId: model.breakingScheduleId,
    created: model.created,
  };
}

makeFunctions.BreakingScheduleSetupResultDto = makeBreakingScheduleSetupResultDto;

export interface BreakingScheduleSetupForm {
    pours?: PourBreakingScheduleSetupForm[];
}

export function makeBreakingScheduleSetupForm (model: BreakingScheduleSetupForm): BreakingScheduleSetupForm {
  return {
    pours: (model.pours?.map((item) => makePourBreakingScheduleSetupForm(item))),
  };
}

makeFunctions.BreakingScheduleSetupForm = makeBreakingScheduleSetupForm;

/** The QAQC sampling plan for one pour, captured at the pour approval stage before the pour has actually been placed. Only the test days and cylinder count are known at this point; the slump, vane and slump picture are recorded later in the QAQC area once the sample is cast. */
export interface PourBreakingScheduleSetupForm {
    pourId: string;
    /** Testing intervals in days after the pour e.g. 7, 14, 28. */
    inspectionInterval?: number[];
    numberOfCylinders?: number;
    /** NodaTimeType:LocalDateTime */
    dateCast?: LocalDateTime | undefined;    
    /** Optional. Defaults to "{pour reference} {yyyyMMdd}" when omitted. */
    sampleName?: string | undefined;
}

export function makePourBreakingScheduleSetupForm (model: PourBreakingScheduleSetupForm): PourBreakingScheduleSetupForm {
  return {
    pourId: model.pourId,
    inspectionInterval: model.inspectionInterval,
    numberOfCylinders: model.numberOfCylinders,
    dateCast: model.dateCast && typeof model.dateCast === 'string' ? makeLocalDateTime(model.dateCast) : model.dateCast,
    sampleName: model.sampleName,
  };
}

makeFunctions.PourBreakingScheduleSetupForm = makePourBreakingScheduleSetupForm;

export interface MoveBreakingScheduleCommand {
    actioningUserId: string;
    targetPourId: string;
}

export function makeMoveBreakingScheduleCommand (model: MoveBreakingScheduleCommand): MoveBreakingScheduleCommand {
  return {
    actioningUserId: model.actioningUserId,
    targetPourId: model.targetPourId,
  };
}

makeFunctions.MoveBreakingScheduleCommand = makeMoveBreakingScheduleCommand;

export interface PagedListOfQAQCTableRecordDto {
    items: QAQCTableRecordDto[];
    pager: Pager;
}

export function makePagedListOfQAQCTableRecordDto (model: PagedListOfQAQCTableRecordDto): PagedListOfQAQCTableRecordDto {
  return {
    items: (model.items?.map((item) => makeQAQCTableRecordDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfQAQCTableRecordDto = makePagedListOfQAQCTableRecordDto;

export interface QAQCTableRecordDto {
    operatorEntityId: string;
    operatorDisplay: string;
    sampleName: string;
    slump: number;
    /** NodaTimeType:ZonedDateTime */
    dateCast: ZonedDateTime;    
    inspectionInterval: number[];
    numberOfCylinders: number;
    vane: number;
    slurryDensity?: number | undefined;
    pourId: string;
    pourReference: string;
    /** NodaTimeType:ZonedDateTime */
    pourCompletedDate: ZonedDateTime;    
    massConcentrationPercentageTarget: number;
    binderPercentageTarget?: number | undefined;
    waterBinderRatio?: number | undefined;
    predictedUcs?: number | undefined;
    rheologyDataSetReference?: string | undefined;
    stopeId: string;
    stopeName: string;
    references: string[];
    pipeArrays?: StopePipeArray[] | undefined;
    volume: number;
    level?: string | undefined;
    area?: string | undefined;
    breakingTests?: BreakingTestDto[] | undefined;
}

export function makeQAQCTableRecordDto (model: QAQCTableRecordDto): QAQCTableRecordDto {
  return {
    operatorEntityId: model.operatorEntityId,
    operatorDisplay: model.operatorDisplay,
    sampleName: model.sampleName,
    slump: model.slump,
    dateCast: model.dateCast && typeof model.dateCast === 'string' ? makeZonedDateTime(model.dateCast) : model.dateCast,
    inspectionInterval: model.inspectionInterval,
    numberOfCylinders: model.numberOfCylinders,
    vane: model.vane,
    slurryDensity: model.slurryDensity,
    pourId: model.pourId,
    pourReference: model.pourReference,
    pourCompletedDate: model.pourCompletedDate && typeof model.pourCompletedDate === 'string' ? makeZonedDateTime(model.pourCompletedDate) : model.pourCompletedDate,
    massConcentrationPercentageTarget: model.massConcentrationPercentageTarget,
    binderPercentageTarget: model.binderPercentageTarget,
    waterBinderRatio: model.waterBinderRatio,
    predictedUcs: model.predictedUcs,
    rheologyDataSetReference: model.rheologyDataSetReference,
    stopeId: model.stopeId,
    stopeName: model.stopeName,
    references: model.references,
    pipeArrays: (model.pipeArrays?.map((item) => makeStopePipeArray(item))),
    volume: model.volume,
    level: model.level,
    area: model.area,
    breakingTests: (model.breakingTests?.map((item) => makeBreakingTestDto(item))),
  };
}

makeFunctions.QAQCTableRecordDto = makeQAQCTableRecordDto;

export interface UscStrengthRecordDto {
    pourId?: string | undefined;
    /** NodaTimeType:Instant */
    pourDate?: Instant;    
    pourName?: string | undefined;
    stopeId?: string | undefined;
    stopeName?: string | undefined;
    target?: number;
    recipe?: number;
    lab?: number | undefined;
    designTargetDays?: number | undefined;
    labDataSource?: string | undefined;
}

export function makeUscStrengthRecordDto (model: UscStrengthRecordDto): UscStrengthRecordDto {
  return {
    pourId: model.pourId,
    pourDate: model.pourDate && typeof model.pourDate === 'string' ? makeInstant(model.pourDate) : model.pourDate,
    pourName: model.pourName,
    stopeId: model.stopeId,
    stopeName: model.stopeName,
    target: model.target,
    recipe: model.recipe,
    lab: model.lab,
    designTargetDays: model.designTargetDays,
    labDataSource: model.labDataSource,
  };
}

makeFunctions.UscStrengthRecordDto = makeUscStrengthRecordDto;

export interface UcsRheologyDataDto {
    curveValues?: number[];
    actualUcsPoints?: UcsDataPointDto[];
}

export function makeUcsRheologyDataDto (model: UcsRheologyDataDto): UcsRheologyDataDto {
  return {
    curveValues: model.curveValues,
    actualUcsPoints: (model.actualUcsPoints?.map((item) => makeUcsDataPointDto(item))),
  };
}

makeFunctions.UcsRheologyDataDto = makeUcsRheologyDataDto;

export interface UcsDataPointDto {
    waterToBinderRatio?: number;
    recordedUcs?: number;
}

export function makeUcsDataPointDto (model: UcsDataPointDto): UcsDataPointDto {
  return {
    waterToBinderRatio: model.waterToBinderRatio,
    recordedUcs: model.recordedUcs,
  };
}

makeFunctions.UcsDataPointDto = makeUcsDataPointDto;

export interface PagedListOfUserDto {
    items: UserDto[];
    pager: Pager;
}

export function makePagedListOfUserDto (model: PagedListOfUserDto): PagedListOfUserDto {
  return {
    items: (model.items?.map((item) => makeUserDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfUserDto = makePagedListOfUserDto;

export interface UserDto {
    userId: string;
    userName: string;
    email: string;
    forename: string;
    surname: string;
    /** DateTime */
    lastConnectionUtc?: Date | undefined;
    /** Note: This is only the roles for the current team.
Do not use this to determine the permissions the user has. */
    teamRoles: TeamRolesAssignmentDto[];
}

export function makeUserDto (model: UserDto): UserDto {
  return {
    userId: model.userId,
    userName: model.userName,
    email: model.email,
    forename: model.forename,
    surname: model.surname,
    lastConnectionUtc: model.lastConnectionUtc && typeof model.lastConnectionUtc === 'string' ? makeDate(model.lastConnectionUtc) : model.lastConnectionUtc,
    teamRoles: (model.teamRoles?.map((item) => makeTeamRolesAssignmentDto(item))),
  };
}

makeFunctions.UserDto = makeUserDto;

export interface TeamRolesAssignmentForm {
    teamId: string;
    roles: string[];
}

export function makeTeamRolesAssignmentForm (model: TeamRolesAssignmentForm): TeamRolesAssignmentForm {
  return {
    teamId: model.teamId,
    roles: model.roles,
  };
}

makeFunctions.TeamRolesAssignmentForm = makeTeamRolesAssignmentForm;

export interface TeamRolesAssignmentDto extends TeamRolesAssignmentForm {
}

export function makeTeamRolesAssignmentDto (model: TeamRolesAssignmentDto): TeamRolesAssignmentDto {
  return {
      ...makeTeamRolesAssignmentForm(model),
  };
}

makeFunctions.TeamRolesAssignmentDto = makeTeamRolesAssignmentDto;

export interface UpdateUserDto extends UserDto {
    clients: EntitySummaryDto[];
}

export function makeUpdateUserDto (model: UpdateUserDto): UpdateUserDto {
  return {
      ...makeUserDto(model),
    clients: (model.clients?.map((item) => makeEntitySummaryDto(item))),
  };
}

makeFunctions.UpdateUserDto = makeUpdateUserDto;

export interface UpdateUserCommand {
    userName: string;
    email: string;
    forename: string;
    surname: string;
}

export function makeUpdateUserCommand (model: UpdateUserCommand): UpdateUserCommand {
  return {
    userName: model.userName,
    email: model.email,
    forename: model.forename,
    surname: model.surname,
  };
}

makeFunctions.UpdateUserCommand = makeUpdateUserCommand;

export interface UpdateUserTeamRolesCommand {
    teamRoles: TeamRolesAssignmentDto[];
}

export function makeUpdateUserTeamRolesCommand (model: UpdateUserTeamRolesCommand): UpdateUserTeamRolesCommand {
  return {
    teamRoles: (model.teamRoles?.map((item) => makeTeamRolesAssignmentDto(item))),
  };
}

makeFunctions.UpdateUserTeamRolesCommand = makeUpdateUserTeamRolesCommand;

export interface ProjectDisclaimer {
    /** NodaTimeType:Instant */
    expiryDate?: Instant;    
    isLicenced?: boolean;
    daysUntilExpiry?: number;
    acceptedTimeZone?: string | undefined;
    projectId?: string | undefined;
}

export function makeProjectDisclaimer (model: ProjectDisclaimer): ProjectDisclaimer {
  return {
    expiryDate: model.expiryDate && typeof model.expiryDate === 'string' ? makeInstant(model.expiryDate) : model.expiryDate,
    isLicenced: model.isLicenced,
    daysUntilExpiry: model.daysUntilExpiry,
    acceptedTimeZone: model.acceptedTimeZone,
    projectId: model.projectId,
  };
}

makeFunctions.ProjectDisclaimer = makeProjectDisclaimer;

export interface UpdateDisclaimerOneDayCommand {
    /** NodaTimeType:Instant */
    dateAccepted: Instant;    
    acceptedTimeZone: string;
    projectId: string;
}

export function makeUpdateDisclaimerOneDayCommand (model: UpdateDisclaimerOneDayCommand): UpdateDisclaimerOneDayCommand {
  return {
    dateAccepted: model.dateAccepted && typeof model.dateAccepted === 'string' ? makeInstant(model.dateAccepted) : model.dateAccepted,
    acceptedTimeZone: model.acceptedTimeZone,
    projectId: model.projectId,
  };
}

makeFunctions.UpdateDisclaimerOneDayCommand = makeUpdateDisclaimerOneDayCommand;

export interface UpdateDisclaimerSevenDaysCommand {
    /** NodaTimeType:Instant */
    dateAccepted: Instant;    
    acceptedTimeZone: string;
    projectId: string;
}

export function makeUpdateDisclaimerSevenDaysCommand (model: UpdateDisclaimerSevenDaysCommand): UpdateDisclaimerSevenDaysCommand {
  return {
    dateAccepted: model.dateAccepted && typeof model.dateAccepted === 'string' ? makeInstant(model.dateAccepted) : model.dateAccepted,
    acceptedTimeZone: model.acceptedTimeZone,
    projectId: model.projectId,
  };
}

makeFunctions.UpdateDisclaimerSevenDaysCommand = makeUpdateDisclaimerSevenDaysCommand;

export interface TermsAndConditionsAcceptance {
    isAccepted?: boolean;
    /** NodaTimeType:Instant */
    acceptedDate?: Instant | undefined;    
}

export function makeTermsAndConditionsAcceptance (model: TermsAndConditionsAcceptance): TermsAndConditionsAcceptance {
  return {
    isAccepted: model.isAccepted,
    acceptedDate: model.acceptedDate && typeof model.acceptedDate === 'string' ? makeInstant(model.acceptedDate) : model.acceptedDate,
  };
}

makeFunctions.TermsAndConditionsAcceptance = makeTermsAndConditionsAcceptance;

/** One row per user account: who they are, which company they belong to, which models (projects) they can open and until when, and their most recent activity. Built for CRM / marketing automation consumers. */
export interface UserDirectoryEntryDto {
    userId: string;
    userName: string;
    email: string;
    isEnabled?: boolean;
    /** True when Roles contains the Paterson & Cooke or Administrator role, so campaigns can exclude internal accounts. */
    isInternal?: boolean;
    /** Site-wide role names (not team roles). */
    roles: string[];
    /** Names of the client companies the user belongs to, directly or through one of their projects. */
    companies: string[];
    /** The models (projects) the user can open, with licence expiry. */
    models: UserModelAccessDto[];
    /** DateTime */
    lastConnectionUtc?: Date | undefined;
    /** Most recent audit-trail entries recorded for this user, newest first. */
    lastLogs: UserLogEntryDto[];
}

export function makeUserDirectoryEntryDto (model: UserDirectoryEntryDto): UserDirectoryEntryDto {
  return {
    userId: model.userId,
    userName: model.userName,
    email: model.email,
    isEnabled: model.isEnabled,
    isInternal: model.isInternal,
    roles: model.roles,
    companies: model.companies,
    models: (model.models?.map((item) => makeUserModelAccessDto(item))),
    lastConnectionUtc: model.lastConnectionUtc && typeof model.lastConnectionUtc === 'string' ? makeDate(model.lastConnectionUtc) : model.lastConnectionUtc,
    lastLogs: (model.lastLogs?.map((item) => makeUserLogEntryDto(item))),
  };
}

makeFunctions.UserDirectoryEntryDto = makeUserDirectoryEntryDto;

export interface UserModelAccessDto {
    projectId: string;
    name?: string | undefined;
    company?: string | undefined;
    /** DateTime */
    licenceExpiryUtc?: Date | undefined;
    isLicenced?: boolean;
    licenceTypes: string[];
    enabledModules: string[];
    isArchived?: boolean;
    /** "Project" when the user is on the project team, "Client" when access comes from company membership. */
    accessVia?: string | undefined;
}

export function makeUserModelAccessDto (model: UserModelAccessDto): UserModelAccessDto {
  return {
    projectId: model.projectId,
    name: model.name,
    company: model.company,
    licenceExpiryUtc: model.licenceExpiryUtc && typeof model.licenceExpiryUtc === 'string' ? makeDate(model.licenceExpiryUtc) : model.licenceExpiryUtc,
    isLicenced: model.isLicenced,
    licenceTypes: model.licenceTypes,
    enabledModules: model.enabledModules,
    isArchived: model.isArchived,
    accessVia: model.accessVia,
  };
}

makeFunctions.UserModelAccessDto = makeUserModelAccessDto;

export interface UserLogEntryDto {
    /** DateTime */
    createdUtc?: Date;
    category?: string | undefined;
    name?: string | undefined;
}

export function makeUserLogEntryDto (model: UserLogEntryDto): UserLogEntryDto {
  return {
    createdUtc: model.createdUtc && typeof model.createdUtc === 'string' ? makeDate(model.createdUtc) : model.createdUtc,
    category: model.category,
    name: model.name,
  };
}

makeFunctions.UserLogEntryDto = makeUserLogEntryDto;

export interface InactiveUserDto {
    userName?: string | undefined;
    email?: string | undefined;
    /** DateTime */
    lastConnectionUtc?: Date | undefined;
}

export function makeInactiveUserDto (model: InactiveUserDto): InactiveUserDto {
  return {
    userName: model.userName,
    email: model.email,
    lastConnectionUtc: model.lastConnectionUtc && typeof model.lastConnectionUtc === 'string' ? makeDate(model.lastConnectionUtc) : model.lastConnectionUtc,
  };
}

makeFunctions.InactiveUserDto = makeInactiveUserDto;

export interface PagedListOfTeamDto {
    items: TeamDto[];
    pager: Pager;
}

export function makePagedListOfTeamDto (model: PagedListOfTeamDto): PagedListOfTeamDto {
  return {
    items: (model.items?.map((item) => makeTeamDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfTeamDto = makePagedListOfTeamDto;

export interface TeamDto {
    teamId: string;
    name: string;
}

export function makeTeamDto (model: TeamDto): TeamDto {
  return {
    teamId: model.teamId,
    name: model.name,
  };
}

makeFunctions.TeamDto = makeTeamDto;

export interface ClientTeamsDto {
    clientTeam: TeamDto;
    projectTeams: TeamDto[];
}

export function makeClientTeamsDto (model: ClientTeamsDto): ClientTeamsDto {
  return {
    clientTeam: model.clientTeam ? makeTeamDto(model.clientTeam) : model.clientTeam,
    projectTeams: (model.projectTeams?.map((item) => makeTeamDto(item))),
  };
}

makeFunctions.ClientTeamsDto = makeClientTeamsDto;

export interface RoleDto {
    name: string;
    description: string;
}

export function makeRoleDto (model: RoleDto): RoleDto {
  return {
    name: model.name,
    description: model.description,
  };
}

makeFunctions.RoleDto = makeRoleDto;

export interface PagedListOfInvitationDto {
    items: InvitationDto[];
    pager: Pager;
}

export function makePagedListOfInvitationDto (model: PagedListOfInvitationDto): PagedListOfInvitationDto {
  return {
    items: (model.items?.map((item) => makeInvitationDto(item))),
    pager: model.pager ? makePager(model.pager) : model.pager,
  };
}

makeFunctions.PagedListOfInvitationDto = makePagedListOfInvitationDto;

export interface InvitationDto {
    invitationId: string;
    email: string;
    /** DateTime */
    createdUtc?: Date | undefined;
    /** DateTime */
    modifiedUtc?: Date | undefined;
    /** DateTime */
    acceptedUtc?: Date | undefined;
    /** DateTime */
    revokedUtc?: Date | undefined;
    /** DateTime */
    lastConnectionUtc?: Date | undefined;
    teamRoles: TeamRolesAssignmentDto[];
}

export function makeInvitationDto (model: InvitationDto): InvitationDto {
  return {
    invitationId: model.invitationId,
    email: model.email,
    createdUtc: model.createdUtc && typeof model.createdUtc === 'string' ? makeDate(model.createdUtc) : model.createdUtc,
    modifiedUtc: model.modifiedUtc && typeof model.modifiedUtc === 'string' ? makeDate(model.modifiedUtc) : model.modifiedUtc,
    acceptedUtc: model.acceptedUtc && typeof model.acceptedUtc === 'string' ? makeDate(model.acceptedUtc) : model.acceptedUtc,
    revokedUtc: model.revokedUtc && typeof model.revokedUtc === 'string' ? makeDate(model.revokedUtc) : model.revokedUtc,
    lastConnectionUtc: model.lastConnectionUtc && typeof model.lastConnectionUtc === 'string' ? makeDate(model.lastConnectionUtc) : model.lastConnectionUtc,
    teamRoles: (model.teamRoles?.map((item) => makeTeamRolesAssignmentDto(item))),
  };
}

makeFunctions.InvitationDto = makeInvitationDto;

export interface AuditableCommandOfInvitationAndString {
}

export function makeAuditableCommandOfInvitationAndString (model: AuditableCommandOfInvitationAndString): AuditableCommandOfInvitationAndString {
  return {
  };
}

makeFunctions.AuditableCommandOfInvitationAndString = makeAuditableCommandOfInvitationAndString;

export interface InviteUserToTeamsCommand extends AuditableCommandOfInvitationAndString {
    email: string;
    teamRoles: TeamRolesAssignmentForm[];
    isPatersonAndCookeUser?: boolean;
}

export function makeInviteUserToTeamsCommand (model: InviteUserToTeamsCommand): InviteUserToTeamsCommand {
  return {
      ...makeAuditableCommandOfInvitationAndString(model),
    email: model.email,
    teamRoles: (model.teamRoles?.map((item) => makeTeamRolesAssignmentForm(item))),
    isPatersonAndCookeUser: model.isPatersonAndCookeUser,
  };
}

makeFunctions.InviteUserToTeamsCommand = makeInviteUserToTeamsCommand;

export interface PagerParameters {
    /** Gets or sets the current page number or null if none specified. */
    page?: number;
    /** Gets or sets the current page size or null if none specified. */
    pageSize?: number | undefined;
}

export function makePagerParameters (model: PagerParameters): PagerParameters {
  return {
    page: model.page,
    pageSize: model.pageSize,
  };
}

makeFunctions.PagerParameters = makePagerParameters;

export interface PoursSearchParameters {
    /** NodaTimeType:LocalDate */
    startDate?: LocalDate | undefined;    
    /** NodaTimeType:LocalDate */
    endDate?: LocalDate | undefined;    
    status?: PourStatus | undefined;
    stopeId?: string | undefined;
}

export function makePoursSearchParameters (model: PoursSearchParameters): PoursSearchParameters {
  return {
    startDate: model.startDate && typeof model.startDate === 'string' ? makeLocalDate(model.startDate) : model.startDate,
    endDate: model.endDate && typeof model.endDate === 'string' ? makeLocalDate(model.endDate) : model.endDate,
    status: model.status ? makePourStatus(model.status) : model.status,
    stopeId: model.stopeId,
  };
}

makeFunctions.PoursSearchParameters = makePoursSearchParameters;

export interface PourDataForm {
    /** NodaTimeType:LocalDateTime */
    pourCompletedDate: LocalDateTime;    
    dryTonnage?: number | undefined;
    massConcentration?: number | undefined;
    binderContent?: number | undefined;
    volume?: number | undefined;
    totalBinder?: number | undefined;
    comments?: string | undefined;
    volumeRetainedAfterOutflow?: number | undefined;
    binderTailingsRatio?: number | undefined;
    documents?: PourDocument[] | undefined;
    ucsAverage?: number | undefined;
}

export function makePourDataForm (model: PourDataForm): PourDataForm {
  return {
    pourCompletedDate: model.pourCompletedDate && typeof model.pourCompletedDate === 'string' ? makeLocalDateTime(model.pourCompletedDate) : model.pourCompletedDate,
    dryTonnage: model.dryTonnage,
    massConcentration: model.massConcentration,
    binderContent: model.binderContent,
    volume: model.volume,
    totalBinder: model.totalBinder,
    comments: model.comments,
    volumeRetainedAfterOutflow: model.volumeRetainedAfterOutflow,
    binderTailingsRatio: model.binderTailingsRatio,
    documents: (model.documents?.map((item) => makePourDocument(item))),
    ucsAverage: model.ucsAverage,
  };
}

makeFunctions.PourDataForm = makePourDataForm;

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-unused-vars */